<template>
  <svg
    :x="svgCoords.x"
    :y="svgCoords.y"
    width="600"
    height="500"
    id="milestone-build-plugins"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-50 -50 400 300"
    role="presentation"
    aria-labelledby="buildpluginsga"
  >
    <title id="buildpluginsga">GA of Build Plugins</title>
    <g id="Puzzle">
      <g id="Piece-4">
        <path
          class="cls-1"
          d="M223.5,60.1a17.5,17.5,0,0,0-7.2-.7,2.8,2.8,0,0,1-2.8-1.1h0a1,1,0,0,1-.1-.9,1.2,1.2,0,0,1,.4-1.1l12.1-11.9L170.5,25.5c-2.3-.8-5.3-.4-6.6.9L131.8,57.9l20.8,7.2a2.6,2.6,0,0,0,1.5-.2,5.7,5.7,0,0,1-.1-1.3,4.6,4.6,0,0,1,1.7-3.6c3.5-3.4,11.1-4.4,16.6-2.1,3.3,1.3,5.2,3.7,5,6.1a4.6,4.6,0,0,1-1.1,3.7,12,12,0,0,1-6.4,3.3l21.5,7.4,12.8-12.7a3.5,3.5,0,0,1,2.6-.6,2.4,2.4,0,0,1,1.8.9c.8,1.4,2.6,2.6,5,3.4,4.7,1.4,10.6.5,13.5-2.1h0a5.1,5.1,0,0,0,1.4-2.6h0v-.3a5.1,5.1,0,0,0-2.4-3c-.1,0-.1,0-.1-.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M226.9,44h0l.5.2a.3.3,0,0,1,.3.3h0a.4.4,0,0,1-.1.5l-.9.8V59.5l-.6.7-2.3-1a17.7,17.7,0,0,0-5.6-.9h-2a1.8,1.8,0,0,1-1.7-.5h-.7a.5.5,0,0,1-.3-.5.9.9,0,0,0,0,.7h0a2.8,2.8,0,0,0,2.8,1.1,17.5,17.5,0,0,1,7.2.7l2.4,1.1c0,.1,0,.1.1.1h.5l.4-.5.7-.6c.1-.1.1-.2.1-.4V44.4a.4.4,0,0,0-.1-.3c0-.1-.1-.1-.2-.2Z"
          transform="translate(0 0.1)"
        />
        <path class="cls-3" d="M206.2,82.1" transform="translate(0 0.1)" />
        <path class="cls-3" d="M191.3,95.4Z" transform="translate(0 0.1)" />
        <path
          class="cls-3"
          d="M229.4,80.8a2.4,2.4,0,0,0,0-1.2h0A2.4,2.4,0,0,1,229.4,80.8Z"
          transform="translate(0 0.1)"
        />
        <path class="cls-3" d="M204.8,82.5Z" transform="translate(0 0.1)" />
        <path class="cls-3" d="M157,76.3l-.6.5Z" transform="translate(0 0.1)" />
        <path
          class="cls-2"
          d="M205,82.3h-.1a.5.5,0,0,1-.5-.5c0-.2.1-.3.3-.4l-.6.3L192,93.7V80.2h-.2l-.3.2h-.7V94.2l-21.3-7.3-.4-.2h0a.5.5,0,1,1-1,0v-.2a.5.5,0,0,1,1,0h0V72.8a1.4,1.4,0,0,1-.9-.9,1.6,1.6,0,0,1,.5-1.1c.2-.2.5-.2.6,0h.4a15.2,15.2,0,0,0,4.2-1.6,7.2,7.2,0,0,0,2.2-1.7,4.7,4.7,0,0,0,1.2-3.1c0,.2-.3.4-.5.4h0c-.2,0-.4-.2-.5-.5V64a3.7,3.7,0,0,1-.9,2.8,10.5,10.5,0,0,1-5.9,3,1.9,1.9,0,0,0-1.2.7,1.4,1.4,0,0,0-.2.6h0v1.5c-4.8-.6-9.9.7-12.4,3.2a5.7,5.7,0,0,0-1.2,1.5V66.9l-1,.3v14h0v.2c0,.2.1.3.3.4h.5l.2-.2c0,.2-.2.3-.4.3h-.4c-.1.2-.2.3-.4.3h-1l-1.6-.5a.5.5,0,0,1-.3-.5V81c.1-.2.2-.3.4-.3l-19.9-6.8v-14l-.7-.3q-.1,0-.3-.3a.4.4,0,0,1,.1-.3V74a.5.5,0,0,0,.3.5l22.1,7.6a2.8,2.8,0,0,0,2.5-.4.9.9,0,0,0,.4-1.1,3.6,3.6,0,0,1,1.2-3.8l.6-.5c2.5-2,6.9-3,11.1-2.4V86.4a1.7,1.7,0,0,0,.1.7,1.6,1.6,0,0,0,1,.8l22,7.5h.6l13-12.8h.2Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-3"
          d="M205.4,81.8a.5.5,0,0,0-.5-.5h-.1l1.2-.2V67h1V81.2a2.4,2.4,0,0,1,1.5.9,8.3,8.3,0,0,0,4.9,3.3c4.8,1.5,10.7.6,13.6-2a4.1,4.1,0,0,0,1.4-3.6h0V68.2a5.2,5.2,0,0,0,1-2.3v-.5a2.9,2.9,0,0,0,0-1.3,6.1,6.1,0,0,0-2.5-3.4l-.4.5H226a5.1,5.1,0,0,1,2.4,3v.3h0a5.1,5.1,0,0,1-1.4,2.6h0c-2.9,2.6-8.8,3.5-13.5,2.1-2.4-.8-4.2-2-5-3.4a2.4,2.4,0,0,0-1.8-.9,3.5,3.5,0,0,0-2.6.6L191.3,78.4,169.8,71a12,12,0,0,0,6.4-3.3,4.6,4.6,0,0,0,1.1-3.7c.2-2.4-1.7-4.8-5-6.1-5.5-2.3-13.1-1.3-16.6,2.1a4.6,4.6,0,0,0-1.7,3.6,1.3,1.3,0,0,0,.1.6.5.5,0,0,0,.3.5h-.3a2.6,2.6,0,0,1-1.5.2l-20.8-7,32.1-31.5c1.3-1.3,4.3-1.7,6.6-.9l55.4,18.9L213.8,56.2a1.2,1.2,0,0,0-.4,1.1,1,1,0,0,0,.1.9h0a.9.9,0,0,1,0-.7.5.5,0,0,0,.3.5h.7a1.8,1.8,0,0,0,1.7.5h2a17.7,17.7,0,0,1,5.6.9l2.3,1,.6-.7V45.9l.9-.8a.4.4,0,0,0,.1-.5.3.3,0,0,0-.3-.3h0l-.5-.2h.5l.2.2a.3.3,0,0,0-.3-.3h0L170.8,24.5c-2.7-.9-6-.4-7.6,1.2L130.1,58.3H130c-.1,0-.1,0-.1.1h0v.2a.4.4,0,0,0-.1.3q.1.3.3.3l.7.3v14l20,7c-.2,0-.3.1-.4.3V81a.5.5,0,0,0,.3.5l1.6.5h1c.2,0,.3-.1.4-.3h.4c.2,0,.4-.1.4-.3l-.2.2h-.5c-.2-.1-.3-.2-.3-.4V81h0V67l1-.3V77.5a5.7,5.7,0,0,1,1.2-1.5c2.5-2.5,7.6-3.8,12.4-3.2V71.3h0a1.4,1.4,0,0,1,.2-.6,1.9,1.9,0,0,1,1.2-.7,10.5,10.5,0,0,0,5.9-3,3.7,3.7,0,0,0,.9-2.8v.2c.1.3.3.5.5.5h0c.2,0,.5-.2.5-.4a4.7,4.7,0,0,1-1.2,3.1,7.2,7.2,0,0,1-2.2,1.7,15.2,15.2,0,0,1-4.2,1.6h-.4c-.1-.2-.4-.2-.6,0a1.6,1.6,0,0,0-.5,1.1,1.4,1.4,0,0,0,.9.9V86.5h0a.5.5,0,0,0-1,0v.2a.5.5,0,1,0,1,0h0l.4.2,21.3,7.3V80.3h.7l.3-.2h.2V93.7l12.1-12,.6-.3c-.2.1-.3.2-.3.4a.5.5,0,0,0,.5.5h.3C205.4,82.1,205.4,82,205.4,81.8ZM152.7,66.1a3.3,3.3,0,0,0,1.4-.1A1.7,1.7,0,0,1,152.7,66.1Zm17.4-7.9a21.2,21.2,0,0,0-4.4-.5,27.1,27.1,0,0,0-4,.4,18.3,18.3,0,0,1,8.4.1Zm-15,6.9v.2c0-.2,0-.3-.1-.4l-.3-.3.3-.2c0,.2.1.5.1.7Zm-24.8-7Z"
          transform="translate(0 0.1)"
        />
        <path class="cls-2" d="M130,58.4" transform="translate(0 0.1)" />
        <path class="cls-2" d="M130.1,58.2" transform="translate(0 0.1)" />
        <path class="cls-2" d="M130.3,58.2Z" transform="translate(0 0.1)" />
        <path
          class="cls-2"
          d="M229.4,79.6h0V65.9a5.2,5.2,0,0,1-1,2.3V79.7h0a4.1,4.1,0,0,1-1.4,3.6c-2.9,2.6-8.8,3.5-13.6,2a8.3,8.3,0,0,1-4.9-3.3,2.4,2.4,0,0,0-1.5-.9v-14h-1v14l-1.2.2h.1a.5.5,0,0,1,.5.5c0,.2,0,.3-.2.4h1.2a1.8,1.8,0,0,1,1.2.5c.9,1.7,2.9,3,5.6,3.8a16.8,16.8,0,0,0,5,.7c3.7,0,7.4-1.1,9.4-3a4.8,4.8,0,0,0,1.8-3.3A2.9,2.9,0,0,0,229.4,79.6Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M154.1,64.9h.3a.5.5,0,0,1-.3-.5,1.3,1.3,0,0,1-.1-.6A4.1,4.1,0,0,0,154.1,64.9Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M154.7,64.6l.3.3c.1.1.1.2.1.4v-.2c0-.2-.1-.5-.1-.7Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M152.7,66.1a1.7,1.7,0,0,0,1.4-.1A3.3,3.3,0,0,1,152.7,66.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M170.1,58.2a18.3,18.3,0,0,0-8.4-.1,27.1,27.1,0,0,1,4-.4A21.2,21.2,0,0,1,170.1,58.2Z"
          transform="translate(0 0.1)"
        />
      </g>
      <g id="Piece-3">
        <path class="cls-3" d="M133.1,108.3l1.3.7Z" transform="translate(0 0.1)" />
        <path class="cls-3" d="M135.6,109.4Z" transform="translate(0 0.1)" />
        <path
          class="cls-2"
          d="M165.3,77.7V87.8l-10.3-6h-.8a1.8,1.8,0,0,1-.5-.7h0c-.2.5.1,1.1.8,1.5L165.6,89h.5a.8.8,0,0,0,.2-.5v-13A3.7,3.7,0,0,1,165.3,77.7Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M173.3,93.9l-.8.5v13.7H172l-17.2,10.1a1.6,1.6,0,0,1-1.5.1q-.3-.1-.3-.3a7.5,7.5,0,0,0-4.1-4.6,16,16,0,0,0-6.8-1.5v-1.4c-.1-.6-.8-1.1-1.8-1.2a14.1,14.1,0,0,1-6.7-1.9,5.6,5.6,0,0,1-3.1-3.9c0,.1-.2.2-.4.2s-.5-.2-.5-.4v-.6c0,.1-.1.2-.1.4a6,6,0,0,0,2.8,4.7,6,6,0,0,1-2.8-4.7c0-.2.1-.3.1-.4-.1-2.1,1.3-4.1,4.1-5.5s11.1-2,15.2.1c2.3,1.2,3.7,2.8,4.1,4.6,0,.1,0,.2.2.2a1.5,1.5,0,0,0,1.6,0h0l16.6-9.6-16.9-9.8a1.4,1.4,0,0,1-.8-1.6h0a.9.9,0,0,1,0-.7,2.5,2.5,0,0,1,2.2-1.3,13.5,13.5,0,0,0,7.1-1.9,5.3,5.3,0,0,0,2.4-3.1v-.2a4.8,4.8,0,0,0-2.7-3.6c-4-2.4-10.8-2.5-14.9-.2-1.7,1-2.7,2.3-2.8,3.6a1.7,1.7,0,0,1-1,1.2,3.7,3.7,0,0,1-3.1-.1L122.8,64.3l-46,26.6a2,2,0,0,0-1.2,1.5h.1a1.8,1.8,0,0,0,1.2,1.2l46.3,26.8,17.6-10.2h.5a1.2,1.2,0,0,1,.8,1.1,1,1,0,0,1-.8,1l-.3.2V126h-.1l-17.3,10V122.6h-.3c0,.1-.1.1-.2.1h-.5v13.6L76.8,109.7a1.9,1.9,0,0,1-1.2-2V95.3a3,3,0,0,1-1-1.9v14.3a3,3,0,0,0,1.7,2.9l46.5,26.8h.7l17.8-10.3a1,1,0,0,0,.7-1V112.9a15.7,15.7,0,0,1,6.4,1.4c2.1,1.1,3.3,2.5,3.6,3.9s.4.8.9,1a2,2,0,0,0,1.1.2,2.8,2.8,0,0,0,1.3-.3l17.1-9.9.7-.2a.4.4,0,0,0,.4-.4V93.5A.5.5,0,0,1,173.3,93.9ZM134.4,109l-1.3-.7Zm.9.3Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M173.5,92.9c0-.2-.1-.4-.2-.4h-.8l.8.5a.5.5,0,0,1,.2.4v-.6Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M74.8,92.4c0-.1.1-.1.1-.2a.5.5,0,0,0-.3.5h0v.6A1.5,1.5,0,0,1,74.8,92.4Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M123.4,121.4h-.5L76.3,94.5l-.4-.3a2.4,2.4,0,0,0,.9.8l46.3,26.7,17.8-10.2.2-.2H141Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M154.6,80.7h0l1.3-.2a13.9,13.9,0,0,0,7.1-2l1.5-1.2-1,.7h0a15.4,15.4,0,0,1-7.5,2.1A2,2,0,0,0,154.6,80.7Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M171.9,93.4,155.3,103a2.9,2.9,0,0,1-2.4.1v.2l.3.2a2,2,0,0,0,1.5,0l17.2-10Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M141.2,97.1a16.9,16.9,0,0,1,7.7,1.6,11,11,0,0,1,2.1,1.4,7,7,0,0,0-2.6-1.9c-3.8-2-10.4-2-14.3-.1a6.9,6.9,0,0,0-2.4,1.8,13.7,13.7,0,0,1,2-1.3A16.3,16.3,0,0,1,141.2,97.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-3"
          d="M173.3,93.1l-.8-.5h.8c.1,0,.2.2.2.4h0a.5.5,0,0,0-.2-.4l-7-4v.2a.8.8,0,0,1-.2.5h-.5l-11.1-6.4c-.7-.4-1-1-.8-1.5h0a1.8,1.8,0,0,0,.5.7h.8l10.3,6V77.7a3.5,3.5,0,0,0,1-2.1,3.4,3.4,0,0,0,.1-1v-.5c0-1.8-1.1-3.4-3.2-4.7-4.3-2.6-11.4-2.7-15.9-.1-2,1.1-3.2,2.7-3.3,4.3l-.4.4a2.4,2.4,0,0,1-2.2-.1L123.1,63.3h-.5L76.3,90.1a2.9,2.9,0,0,0-1.7,2.5h0a.5.5,0,0,1,.3-.5c0,.1-.1.1-.1.2a1.5,1.5,0,0,0-.2.9h0a3,3,0,0,0,1,1.9v12.4a1.9,1.9,0,0,0,1.2,2L122.6,136V122.6h1v13.6l17.3-10h.1V112.5l.3-.2a1,1,0,0,0,.8-1,1.2,1.2,0,0,0-.8-1.1h-.5l-17.6,10.2L76.9,93.6a1.8,1.8,0,0,1-1.2-1.2h-.1a2,2,0,0,1,1.2-1.5l46-26.6,18.1,10.5a3.7,3.7,0,0,0,3.1.1,1.7,1.7,0,0,0,1-1.2c.1-1.3,1.1-2.6,2.8-3.6,4.1-2.3,10.9-2.2,14.9.2a4.8,4.8,0,0,1,2.7,3.6v.2a5.3,5.3,0,0,1-2.4,3.1,13.5,13.5,0,0,1-7.1,1.9,2.5,2.5,0,0,0-2.2,1.3.9.9,0,0,0,0,.7h0a1.4,1.4,0,0,0,.8,1.6l16.9,9.8-16.6,9.6h0a1.5,1.5,0,0,1-1.6,0c-.2,0-.2-.1-.2-.2-.4-1.8-1.8-3.4-4.1-4.6-4.1-2.1-11-2.1-15.2-.1s-4.2,3.4-4.1,5.5c0,.1-.1.2-.1.4a6,6,0,0,0,2.8,4.7,6,6,0,0,1-2.8-4.7c0-.2.1-.3.1-.4v.6c0,.2.3.4.5.4s.4-.1.4-.2a5.6,5.6,0,0,0,3.1,3.9,14.1,14.1,0,0,0,6.7,1.9c1,.1,1.7.6,1.8,1.2v1.4a16,16,0,0,1,6.8,1.5A7.5,7.5,0,0,1,153,118q0,.1.3.3a1.6,1.6,0,0,0,1.5-.1l17.2-9.9h.5V94.4l.8-.5a.5.5,0,0,0,.1-.7ZM163.5,78h0l1-.7L163,78.5a13.9,13.9,0,0,1-7.1,2l-1.3.2h0a2,2,0,0,1,1.4-.6A15.4,15.4,0,0,0,163.5,78Zm-22.4,33.3-.2.2-17.8,10.2L76.8,95a2.4,2.4,0,0,1-.9-.8l.4.3,46.6,26.9h.5L141,111.2ZM172,93.5l-17.2,10a1.9,1.9,0,0,1-1.5,0l-.3-.2v-.2a2.9,2.9,0,0,0,2.4-.1l16.5-9.6Zm-37.9,4.6c3.9-1.9,10.5-1.9,14.3.1a7,7,0,0,1,2.6,1.9,11,11,0,0,0-2.1-1.4,16.9,16.9,0,0,0-7.7-1.6,16.3,16.3,0,0,0-7.5,1.5,13.7,13.7,0,0,0-2,1.3,6.9,6.9,0,0,1,2.4-1.8Z"
          transform="translate(0 0.1)"
        />
      </g>
      <g id="Piece-2">
        <path
          class="cls-1"
          d="M237.8,86h0c-4.1,2-11.1,2-15.2-.1a7.5,7.5,0,0,1-4.1-4.6q0-.1-.3-.3a1.6,1.6,0,0,0-1.5.1l-16.6,9.6,16.9,9.8a2,2,0,0,1,.8,1.2v.3a.9.9,0,0,1,0,.7c-.2.8-1,1.3-2.2,1.4h-.1a12.9,12.9,0,0,0-5.8,1.3l-1.2.6h0l-.6.5-.3.3h-.2a4.1,4.1,0,0,0-1.3,2.7,4.9,4.9,0,0,0,2.6,3.2c4.1,2.5,10.9,2.5,14.9.2a5.3,5.3,0,0,0,2.9-3.6,1.6,1.6,0,0,1,.9-1.2,3.6,3.6,0,0,1,3.2.1l18,10.5,46-26.6a2.5,2.5,0,0,0,1.1-1.2h.1a2.1,2.1,0,0,0-1.1-1.3L248.4,62.8,231,72.9h.3a16.1,16.1,0,0,1,7.1,2c2.3,1.4,3.6,3.2,3.5,5.1a2.2,2.2,0,0,1,.1.8C241.9,82.8,240.4,84.7,237.8,86Z"
          transform="translate(0 0.1)"
        />
        <path class="cls-3" d="M207.6,106.8l.3-.3Z" transform="translate(0 0.1)" />
        <path
          class="cls-3"
          d="M209.7,105.4a12.9,12.9,0,0,1,5.8-1.3A12.9,12.9,0,0,0,209.7,105.4Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M230,72.8h-.1l-.4.2a.4.4,0,0,0-.1.3v.4A2.4,2.4,0,0,1,230,72.8Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M229.9,87.4h.5a18.7,18.7,0,0,0,7.4-1.4h0c2.6-1.3,4.1-3.2,4.2-5.2a2.2,2.2,0,0,0-.1-.8v.7c0,.2-.3.4-.5.4h0c-.2,0-.4,0-.4-.2-.2,1.6-1.5,3.1-3.6,4.2a18.5,18.5,0,0,1-7,1.3V75.1a1.3,1.3,0,0,1-1-1h0V86.9a.5.5,0,0,0,.5.5Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M295.8,93.9v12.6h0q.1,1.1-1.2,1.8l-45.5,26.3V121l-.2.2h-.8v13.6l-17.6-10.4a2.9,2.9,0,0,0-1.6-.4h0V110.3l-1,.2v13.7a1.5,1.5,0,0,0-1.3,1.3,4.6,4.6,0,0,1-2.8,3.5c-4.1,2.4-11,2.3-15-.1-1.8-1.1-2.8-2.6-2.6-4.1V113.3a3.5,3.5,0,0,1-1-1.9v13.3c-.2,2,1,3.8,3.1,5.1a17.6,17.6,0,0,0,8.1,2,15.4,15.4,0,0,0,7.9-1.9,5.8,5.8,0,0,0,3.3-4.3q0-.3.9-.6h.1a2,2,0,0,1,1.5.3l18.3,10.6h.5l46.2-26.8a2.6,2.6,0,0,0,1.7-2.6V92A2.6,2.6,0,0,1,295.8,93.9Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M296.3,90.6h-.1a.5.5,0,0,1,.5.3,2.2,2.2,0,0,1,.1.8h0V91C296.8,90.8,296.5,90.6,296.3,90.6Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M205.1,109.6c0-.2.3-.4.5-.4h0a.7.7,0,0,1,.5.4,4.1,4.1,0,0,1,1.3-2.7h.2l.3-.3.6-.5h0l1.2-.6a12.9,12.9,0,0,1,5.8-1.3h.1a2.3,2.3,0,0,0,2.2-1.4c.1-.2,0-.4,0-.7a1.6,1.6,0,0,1-.6.8h-.6l-1.1.3a14.4,14.4,0,0,0-7.5,2.1,5.4,5.4,0,0,0-2.9,4.5l-6.1-3.6V92.6l-.8-.5-.2-.2v14.5a.8.8,0,0,0,.2.5l6.9,3.9A2.4,2.4,0,0,1,205.1,109.6Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M198.2,91.2l.8-.5h-.3a.5.5,0,0,0-.5,0l-.2.4h0v.3Z"
          transform="translate(0 0.1)"
        />
        <path class="cls-2" d="M216.4,101.3l-16.8-9.7h-.2l17.4,10h0Z" transform="translate(0 0.1)" />
        <path
          class="cls-3"
          d="M199,92.6v13.5l6.1,3.6a5.4,5.4,0,0,1,2.9-4.5,14.4,14.4,0,0,1,7.5-2.1l1.1-.3h.6a1.6,1.6,0,0,0,.6-.8c0,.3.1.5,0,.7a2.3,2.3,0,0,1-2.2,1.4c1.2-.1,2-.6,2.2-1.4a.9.9,0,0,0,0-.7v-.3a2,2,0,0,0-.8-1.2l-16.9-9.8,16.6-9.6a1.6,1.6,0,0,1,1.5-.1q.3.1.3.3a7.5,7.5,0,0,0,4.1,4.6c4.1,2.1,11.1,2.1,15.2.1a18.7,18.7,0,0,1-7.4,1.4h-.5a.5.5,0,0,1-.5-.5v-.4a15.3,15.3,0,0,1-6.3-1.5q-3.2-1.6-3.6-3.9c0-.4-.4-.8-.9-1a2.5,2.5,0,0,0-2.4.1l-18,10.4-.2.4h0l.2-.4h.8l-.8.5-.2.2a.4.4,0,0,0-.1.3c0,.1,0,.1.1.2l.2.2Zm17.8,9.1h0l-17.4-10h.2l16.8,9.7C216.7,101.5,216.8,101.6,216.8,101.7Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M237.9,75.7a16,16,0,0,0-6.7-1.8h-.8c0,.1.3.3.9.4h0a13.6,13.6,0,0,1,7.1,2,4.1,4.1,0,0,1,1.1.7Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M208.7,114.2c4,2.4,10.8,2.5,14.9.1a8.3,8.3,0,0,0,1.8-1.3,5.7,5.7,0,0,1-1.3.8c-4.4,2.6-11.5,2.5-15.9-.1l-1.2-.9Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M228.9,109.3a2.9,2.9,0,0,1,1.6.4L248,119.8v-.2l-17.9-10.4h0a2.8,2.8,0,0,0-2.2-.1c-.3.1-.4.3-.4.4h-.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-3"
          d="M206.2,113.3v11.5c-.2,1.5.8,3,2.6,4.1,4,2.4,10.9,2.5,15,.1a4.6,4.6,0,0,0,2.8-3.5,1.5,1.5,0,0,1,1.3-1.3V110.5l1-.2V124h0a2.9,2.9,0,0,1,1.6.4l17.6,10.2V121h.8l.2-.2v13.6l45.5-26.3q1.3-.7,1.2-1.8h0V93.9a2.6,2.6,0,0,0,1-1.9v-.2a2.2,2.2,0,0,0-.1-.8.5.5,0,0,0-.5-.3h.1a.5.5,0,0,1,.5.5v.7a.7.7,0,0,0,.1-.5,3.2,3.2,0,0,0-1.7-2.6l-46.5-27h-.5L230.1,72.2a1.6,1.6,0,0,0-.6.8l.4-.2h.1a2.4,2.4,0,0,0-.6.9V74h0a1.3,1.3,0,0,0,1,1V86.4a18.5,18.5,0,0,0,7-1.3c2.1-1.1,3.4-2.6,3.6-4.2,0,.2.2.2.4.2h0c.2,0,.5-.2.5-.4V80c.1-1.9-1.2-3.7-3.5-5.1a16.1,16.1,0,0,0-7.1-2H231l17.4-10.1,46.3,26.8a2.1,2.1,0,0,1,1.1,1.3h-.1a2.5,2.5,0,0,1-1.1,1.2l-46,26.6-18-10.5a3.6,3.6,0,0,0-3.2-.1,1.6,1.6,0,0,0-.9,1.2,5.3,5.3,0,0,1-2.9,3.6c-4,2.3-10.8,2.3-14.9-.2a4.9,4.9,0,0,1-2.6-3.2,4.1,4.1,0,0,1,1.3-2.7,4.1,4.1,0,0,0-1.3,2.7.7.7,0,0,0-.5-.4h0c-.2,0-.5.2-.5.4a2.4,2.4,0,0,0,0,1.2,1.3,1.3,0,0,0,.1.6A4.2,4.2,0,0,0,206.2,113.3Zm2,.4c4.4,2.6,11.5,2.7,15.9.1a5.7,5.7,0,0,0,1.3-.8,8.3,8.3,0,0,1-1.8,1.3c-4.1,2.4-10.9,2.3-14.9-.1l-1.7-1.4Zm19.2-4.1h.1c0-.1.1-.3.4-.4a2.8,2.8,0,0,1,2.2.1h0L248,119.6v.2l-17.5-10.1a2.9,2.9,0,0,0-1.6-.4l-1.5.3Zm67.2-16L249,119.9v-.2L295.1,93l.4-.2ZM239.5,77a4.1,4.1,0,0,0-1.1-.7,13.6,13.6,0,0,0-7.1-2h0c-.6-.1-.9-.3-.9-.4h.8a16,16,0,0,1,6.7,1.8Z"
          transform="translate(0 0.1)"
        />
        <path class="cls-2" d="M249,119.7v.2l45.6-26.3.9-.8-.4.2Z" transform="translate(0 0.1)" />
      </g>
      <g id="Piece-1">
        <path
          class="cls-1"
          d="M155.8,124.7v.4a1.6,1.6,0,0,1-.4.7h-.1l-1.1,1L143,136.5h0l-.8.7,53.3,20.7c2.2.8,5.2.5,6.6-.8h.1l35.2-30.3-20-7.9a1.8,1.8,0,0,0-1.6.2h-.1v.4h0v.2h0c.1,1.2-.3,2.6-2,4.1h0c-3.8,3.3-11.4,3.9-16.8,1.5a7.2,7.2,0,0,1-4.4-5,2.9,2.9,0,0,1,0-1.3,4.4,4.4,0,0,1,1.5-3.5,12.5,12.5,0,0,1,6.8-3.1h0L180,104.3l-14.2,12.4a3.1,3.1,0,0,1-2.8.5,1.9,1.9,0,0,1-1.4-1.1c-.7-1.4-2.4-2.6-4.7-3.5-4.6-1.5-10.6-.8-13.7,1.7a4.5,4.5,0,0,0-1.8,3h.1c.3,1.7,1.9,3.2,4.4,4.2a17.3,17.3,0,0,0,7.1,1,2.6,2.6,0,0,1,2.7,1.2,1.1,1.1,0,0,1,0,.8C155.7,124.6,155.8,124.6,155.8,124.7Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-3"
          d="M140.4,137.4h.7l-.8.6a.4.4,0,0,0-.1.5c0,.2.1.3.3.4l.6.2v13.7l54.3,21c2.2.9,5.2.6,6.6-.7l36.3-31.2V128.6l.8-.7a.8.8,0,0,0,.2-.5l-.4-.4-.8-.3.3-.3h.5l-21.3-8.3a3,3,0,0,0-2.6.3,1.2,1.2,0,0,0-.4,1.1,4,4,0,0,1-1.6,3.8c-2.5,2.1-6.7,3-10.7,2.7v.3l-.2.4h-.4a15.5,15.5,0,0,1-4.8-1.3c-2.4-1.1-4.1-2.8-4.5-4.8v-1.2a.9.9,0,0,0,.1.5c0,.3.2.4.5.4h0l.4-.2v.3c.3,1.7,1.8,3.2,3.9,4.1a18.2,18.2,0,0,0,4,1.1V114.8a1.7,1.7,0,0,0,1-1h0v-.4a1.8,1.8,0,0,0-.7-.8h.3c.2,0,.3.2.4.5a1.4,1.4,0,0,0-1-1.3L180,103.4h-.5l-14.3,12.4a2.2,2.2,0,0,1-1.9.3,1.4,1.4,0,0,1-.8-.5c-.8-1.7-2.6-3.1-5.2-4-4.9-1.7-11.4-.9-14.7,1.8a4.9,4.9,0,0,0-2.1,4.4v.8a4.3,4.3,0,0,0,1,2.3v11.5a3.8,3.8,0,0,0,1.1,3l11.9-10.2h.3l.4-.2a1.5,1.5,0,0,0,.5-.6,1.1,1.1,0,0,0,0-.8,2.6,2.6,0,0,0-2.7-1.2,17.3,17.3,0,0,1-7.1-1c-2.5-1-4.1-2.5-4.4-4.2h-.1a4.5,4.5,0,0,1,1.8-3c3.1-2.5,9.1-3.2,13.7-1.7,2.3.9,4,2.1,4.7,3.5a1.9,1.9,0,0,0,1.4,1.1,3.1,3.1,0,0,0,2.8-.5l14.1-12.2,20.8,8.1h0a12.5,12.5,0,0,0-6.8,3.1,4.4,4.4,0,0,0-1.5,3.5,2.9,2.9,0,0,0,0,1.3,7.2,7.2,0,0,0,4.4,5c5.4,2.4,13,1.8,16.8-1.5h0c1.7-1.5,2.1-2.9,2-4.1h0v-.2h0v-.4h.1a1.8,1.8,0,0,1,1.6-.2l20,7.9-35.2,30.3H202c-1.4,1.3-4.4,1.6-6.6.8l-53.3-20.7.8-.7h-.7l-.4-.4-1.5,1.3a.8.8,0,0,0-.2.5h0v-.2C140.1,137.6,140.2,137.5,140.4,137.4Zm54.2-21a11.5,11.5,0,0,1,6.1-2.8h.5c.1,0,.1,0,.1.1h0c0,.1-.2.3-.6.3a12.7,12.7,0,0,0-6.2,2.6Zm-39.8,7.7h0a2.3,2.3,0,0,0-1.4-.4H153a19.1,19.1,0,0,1-7.1-1h0a8.3,8.3,0,0,1-3.3-2.2,7.7,7.7,0,0,0,2.9,1.7,17.8,17.8,0,0,0,7.6,1.1A1.7,1.7,0,0,1,154.8,124.1Zm47.9,33.8,35.1-30.2h0L202,158.5c-1.4,1.3-4.4,1.6-6.6.7l-53.8-20.9.2-.2L195,158.8C197.6,159.8,201,159.4,202.7,157.9Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-3"
          d="M155.3,125.8a1.6,1.6,0,0,0,.4-.7C155.7,125.3,155.5,125.5,155.3,125.8Z"
          transform="translate(0 0.1)"
        />
        <path class="cls-3" d="M155.8,124.7Z" transform="translate(0 0.1)" />
        <polygon class="cls-3" points="155.3 126 154.2 126.9 155.3 126 155.3 126" />
        <path
          class="cls-2"
          d="M239,126.4h-.6l-.3.3.8.3.4.4a.8.8,0,0,1-.2.5l-.8.7V142L202,173.2c-1.4,1.3-4.4,1.6-6.6.7l-54.3-21V139.2l-.6-.2c-.2-.1-.3-.2-.3-.4a.4.4,0,0,1,.1-.5l.8-.6h-.7c-.2.1-.3.2-.3.4v15.4a.7.7,0,0,0,.4.5L195,175a10.6,10.6,0,0,0,3.1.5,7,7,0,0,0,4.6-1.4l36.4-31.4.2-.4V126.8C239.3,126.6,239.2,126.4,239,126.4Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M142.2,136.5h.7l11.2-9.7,1.1-1h.1c.2-.3.4-.5.4-.7v-.4c0-.1-.1-.1-.1-.2a1.5,1.5,0,0,1-.5.6l-.4.2h-.3l-11.8,10.1a3.8,3.8,0,0,1-1.1-3V121a4.3,4.3,0,0,1-1-2.3v13.7a5,5,0,0,0,1.3,3.7Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M201.3,114.8v10.8a18.2,18.2,0,0,1-4-1.1c-2.1-.9-3.6-2.4-3.9-4.1v-.3l-.4.2h0c-.3,0-.5-.1-.5-.4a.9.9,0,0,1-.1-.5v1.2c.4,2,2.1,3.7,4.5,4.8a15.5,15.5,0,0,0,4.8,1.3h.4l.2-.4V113.8A1.7,1.7,0,0,1,201.3,114.8Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M201.9,112.5h-.3a1.8,1.8,0,0,1,.7.8V113h0C202.2,112.7,202.1,112.5,201.9,112.5Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M201.3,113.6h-.6a11.5,11.5,0,0,0-6.1,2.8h-.1a12.7,12.7,0,0,1,6.2-2.6C201.1,113.9,201.3,113.7,201.3,113.6Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M153.1,123.5a17.8,17.8,0,0,1-7.6-1.1,7.7,7.7,0,0,1-2.9-1.7,8.3,8.3,0,0,0,3.3,2.2h0a19.1,19.1,0,0,0,7.1,1h.4a2.3,2.3,0,0,1,1.4.4h0A1.7,1.7,0,0,0,153.1,123.5Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M195,158.8l-53.2-20.7-.2.2,53.8,20.9c2.2.9,5.2.6,6.6-.7l35.8-30.8h0l-35.1,30.2C201,159.4,197.6,159.8,195,158.8Z"
          transform="translate(0 0.1)"
        />
      </g>
    </g>
    <g id="Guy_Glass" data-name="Guy Glass">
      <path
        id="Shadow"
        class="cls-3"
        d="M113.6,91.8l-.3-.4-9.9,5.7.7.2Zm.5,1.1c0-.2-.1-.3-.2-.5l-9.1,5.2-.4.8Zm.4.7-10.3,6v.6l11.4-6.6Zm3.2.1h-.8L104.3,101c0,.2.1.3.2.5Zm1.9.4-.7-.2-14.1,8.2.3.4Zm1.1.3-15.1,8.7.4.4,15.3-8.8Zm2,.9-.5-.3-15.6,9,.5.3Zm1.2.7-.5-.3-15.6,9,.5.3Zm1,.9-.3-.4-15.2,8.8.6.2Zm.8,1-.3-.4L111,105.8l.7.2Zm.5,1.2c0-.2-.1-.3-.2-.5l-13.1,7.5h.8Zm0,1.4v-.6l-11,6.4h1Zm1.4.1-9.4,5.4h.6c0,.1.1.1.1.2l9.4-5.4Zm1.7.5-9.9,5.7.4.3,10.1-5.8Zm2,.9-.5-.3-10.2,5.9.5.3Zm.9.9-.3-.4-9.9,5.7.6.2ZM104.8,89.5,103,90l-2.1,1.2a3.1,3.1,0,0,0-.9,1.1Zm1.9-.2-7,4v.6l7.9-4.5Zm3,.3h-.8L100,94.7l.2.4Zm1.6.6-.6-.2-9.9,5.7.4.3Zm.9.4L102,96.5l.5.3,10.2-5.9Z"
        transform="translate(0 0.1)"
      />
      <g id="Body">
        <g id="XMLID_3631" data-name="XMLID 3631">
          <path
            id="XMLID_3635"
            data-name="XMLID 3635"
            class="cls-2"
            d="M129.8,45.8a32.1,32.1,0,0,1-1.9-3.1c0-.1,1.1-7.6-.2-13.1a71.3,71.3,0,0,1,5.1,12.5l1.2,5a23.2,23.2,0,0,1-4.5,6.7L128,55.1h-.4l-1.3-1.8a.2.2,0,0,1,0-.3h0a44.6,44.6,0,0,1,2.2-5A15.9,15.9,0,0,0,129.8,45.8Z"
            transform="translate(0 0.1)"
          />
          <path
            id="XMLID_3632"
            data-name="XMLID 3632"
            class="cls-3"
            d="M127.9,55.6h0a.7.7,0,0,1-.6-.3L126,53.5a.9.9,0,0,1-.1-.7,29.4,29.4,0,0,1,2.3-5.1,7.6,7.6,0,0,0,1.2-1.9l-1.8-2.9h-.1c0-.3,1-7.6-.2-12.9v-.6l.7-.2.2.4c.1.3,3.9,7.7,5.1,12.5l1.3,5.1h-.1a31.5,31.5,0,0,1-4.5,6.9l-1.5,1.4Zm-1.2-2.5,1.2,1.7,1.4-1.2a30.5,30.5,0,0,0,4.3-6.5l-1.2-4.8a68.5,68.5,0,0,0-3.8-9.8,50.7,50.7,0,0,1-.2,10.3,17.5,17.5,0,0,0,1.8,2.9v.4a16.4,16.4,0,0,1-1.4,2.2C128.3,48.8,127.4,51.2,126.7,53.1Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3629" data-name="XMLID 3629">
          <path
            id="XMLID_3630"
            data-name="XMLID 3630"
            class="cls-3"
            d="M129.9,46.2l-.2-.8a2.2,2.2,0,0,1,1.6,0l-.2.8A2.4,2.4,0,0,0,129.9,46.2Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3624" data-name="XMLID 3624">
          <path
            id="XMLID_3628"
            data-name="XMLID 3628"
            class="cls-1"
            d="M128.7,102.4s.7.3,1.4,2.2a17,17,0,0,0,3.8,4.6c.9.7-.4,3.5-3.3,2.3l-4.1-2.1a4.1,4.1,0,0,1-2.3-3.1,5.7,5.7,0,0,1,0-2.6c.5-1.3,2.8-1.9,2.8-1.9Z"
            transform="translate(0 0.1)"
          />
          <path
            id="XMLID_3625"
            data-name="XMLID 3625"
            class="cls-3"
            d="M132.1,112.2a2.9,2.9,0,0,1-1.6-.4l-2.7-1.3-1.4-.7a4.2,4.2,0,0,1-2.5-3.4,5.3,5.3,0,0,1,.1-2.8c.6-1.5,3-2.1,3.1-2.2h.1l1.7.6c.1.1.9.4,1.6,2.4a14.3,14.3,0,0,0,3.7,4.4,1.5,1.5,0,0,1,.1,2.1A2.6,2.6,0,0,1,132.1,112.2Zm-5-10c-.7.2-2.1.8-2.4,1.6a4.9,4.9,0,0,0,0,2.4,3.5,3.5,0,0,0,2,2.7l1.5.7,2.6,1.3a1.9,1.9,0,0,0,2.7-.5c.3-.4.3-.9.1-1s-3.3-3.2-3.9-4.8-1.1-1.9-1.2-1.9Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3619" data-name="XMLID 3619">
          <path
            id="XMLID_3623"
            data-name="XMLID 3623"
            class="cls-2"
            d="M128.7,102.5a17.5,17.5,0,0,0,1.2,3.2c.5.9-.4,1.6-2.2.5a5.8,5.8,0,0,1-2.1-3.6l2.8-.4Z"
            transform="translate(0 0.1)"
          />
          <path
            id="XMLID_3620"
            data-name="XMLID 3620"
            class="cls-3"
            d="M129.2,107.2a2.7,2.7,0,0,1-1.7-.6,5.5,5.5,0,0,1-2.3-3.9v-.4l3.5-.5.5.6h0a28.3,28.3,0,0,0,1.1,3.1,1.2,1.2,0,0,1-.1,1.4Zm-3.1-4.2a4.8,4.8,0,0,0,1.9,2.9c.9.6,1.4.5,1.6.4s0-.2,0-.4a17.5,17.5,0,0,1-1.2-3.2h-.1Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3594" data-name="XMLID 3594">
          <g id="XMLID_3614" data-name="XMLID 3614">
            <path
              id="XMLID_3618"
              data-name="XMLID 3618"
              class="cls-1"
              d="M105.1,83.7a9.2,9.2,0,0,0,.3,5.7c1.2,2.5-1.5,4.3-3.8,1.6a10.7,10.7,0,0,1-2.3-6.2c-.4-.5-.4-2.6.1-3a3.8,3.8,0,0,1,3.5-.9C105.6,81.7,105.1,83.7,105.1,83.7Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3615"
              data-name="XMLID 3615"
              class="cls-3"
              d="M103.9,92.8a3.6,3.6,0,0,1-2.7-1.5A11.1,11.1,0,0,1,98.8,85c-.4-.8-.5-2.9.2-3.5a4,4,0,0,1,3.9-1,3.6,3.6,0,0,1,2.3,1.5,2.8,2.8,0,0,1,.3,1.8,10.3,10.3,0,0,0,.2,5.5c.7,1.5.2,2.7-.7,3.2A2,2,0,0,1,103.9,92.8Zm-2.1-11.6a3.1,3.1,0,0,0-2.2.9,3.6,3.6,0,0,0,0,2.5h.1a10.7,10.7,0,0,0,2.2,5.9c1,1.3,2.1,1.4,2.8,1s.8-1.1.3-2.2-.3-5.8-.3-6,.3-1.7-2-2.3Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3600" data-name="XMLID 3600">
            <path
              id="XMLID_3613"
              data-name="XMLID 3613"
              class="cls-2"
              d="M105.1,83.7l-.7,2.2c-.5.5-1.9-.6-2.2-1.2a2,2,0,0,1-.3-1.1,3.1,3.1,0,0,1,1-2.7Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3601"
              data-name="XMLID 3601"
              class="cls-3"
              d="M104,86.5h-.2a2.9,2.9,0,0,1-2-1.6,5.6,5.6,0,0,1-.4-1.2,4,4,0,0,1,1.1-3.1l.3-.3,2.7,3.3-.8,2.6h-.1Zm-1.3-4.9a2.5,2.5,0,0,0-.6,2l.3,1a2.8,2.8,0,0,0,1.5,1.1l.6-1.9Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3595" data-name="XMLID 3595">
            <path
              id="XMLID_3599"
              data-name="XMLID 3599"
              class="cls-3"
              d="M126.4,58.7a27.1,27.1,0,0,1-4.7,17.9l-3.1,2.5-5.3,1.4-8.4,3.2h-.7a2.8,2.8,0,0,1-1.4-1.8v-.5c0-.2,0-.4.2-.5l6.2-4.5c3-2.1,4.9-3.3,7-3.7s-.8-14.2-.8-14.2l5.6-2.7Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3596"
              data-name="XMLID 3596"
              class="cls-3"
              d="M104.7,84.2H104a3.1,3.1,0,0,1-1.6-2.1v-.7a.8.8,0,0,1,.4-.9c.7-.5,4.1-3.1,6.2-4.5s4.9-3.3,7.1-3.8.3-6.6-1.2-13.7v-.3l6-2.9,6,3.3v.2A28.1,28.1,0,0,1,122.2,77h-.1l-3.2,2.5h-.1l-5.3,1.4-8.4,3.2Zm11-25.7c.9,4.4,2.6,13.9.4,14.3s-4,1.7-6.8,3.6-5.5,4-6.2,4.5-.1.1,0,.1v.5a2.1,2.1,0,0,0,1.1,1.5h.4l8.4-3.2,5.3-1.4,3-2.4a26.8,26.8,0,0,0,4.6-17.4l-5.3-2.9Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
        <g id="XMLID_3589" data-name="XMLID 3589">
          <path
            id="XMLID_3593"
            data-name="XMLID 3593"
            class="cls-3"
            d="M121.9,61.6s5.9,16.7,6,20.2.7,17.8.9,20.5c.1.3-.1.5-.4.6h0a3.6,3.6,0,0,1-2.5,0h-.2a.7.7,0,0,1-.4-.5,48.4,48.4,0,0,0-2.2-8.3c-1.5-3.8-.5-9.9-.5-9.9s-2.1-5.9-5-8.6-7.2-9.7-7.1-14.2S121.9,61.6,121.9,61.6Z"
            transform="translate(0 0.1)"
          />
          <path
            id="XMLID_3590"
            data-name="XMLID 3590"
            class="cls-3"
            d="M127.1,103.7a3.2,3.2,0,0,1-1.4-.3h-.2a1,1,0,0,1-.7-.8,58,58,0,0,0-2.1-8.2c-1.4-3.6-.7-9.2-.5-10s-2.2-6-4.8-8.3-7.3-9.8-7.3-14.5a2.1,2.1,0,0,1,.9-1.8c2.6-1.8,10.2,1.3,11,1.6h.2v.2c.2.7,5.9,16.8,6,20.4s.7,16.5.9,20.5a1,1,0,0,1-.7,1ZM113.4,59.9a2.8,2.8,0,0,0-1.8.4,1.1,1.1,0,0,0-.6,1.1c0,4.3,4.1,11.3,7,13.9s5,8.5,5.1,8.8h0c0,.1-1,6,.5,9.7a48.4,48.4,0,0,1,2.2,8.3v.2h.2a2.8,2.8,0,0,0,2.2,0c.1,0,.1-.1.1-.2-.2-4.1-.8-17.5-.9-20.5s-5.3-18.1-5.9-19.9A28,28,0,0,0,113.4,59.9Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3584" data-name="XMLID 3584">
          <path
            id="XMLID_3588"
            data-name="XMLID 3588"
            class="cls-1"
            d="M106.6,34.1c1.7-3.1,8.1-5.5,8.1-5.5l2.6.4,4-1.9s5.7.9,6.6,2,1.4,9.2.6,12.3-.5,15.4-.5,15.4-2.1,3.4-2.9,3.9-1.8-2-1.8-2h-.2c-.2,1-.5,1.9-.8,2.9s-14.6,2.9-13.4-3.8-.3-17.2-.3-17.2S105,37.2,106.6,34.1Z"
            transform="translate(0 0.1)"
          />
          <path
            id="XMLID_3585"
            data-name="XMLID 3585"
            class="cls-3"
            d="M116,62.7c-2.5,0-5.2-.4-6.6-1.7a3.2,3.2,0,0,1-.9-3.2c1-6.2-.1-15.7-.3-17s-3.7-3.8-2-6.9,8-5.6,8.3-5.7h.1l2.6.4,4-1.9h.1c1,.2,5.9,1,6.8,2.2s1.4,9.6.7,12.7-.5,15.1-.5,15.3h-.1c-.4.6-2.2,3.6-3,4.1a.9.9,0,0,1-.7.1,2.9,2.9,0,0,1-1.3-1.4l-.5,2v.2h-.2A46.2,46.2,0,0,1,116,62.7Zm-9.4-28.6.4.2c-1.5,2.8,1.9,5.9,2,5.9h.1v.2c0,.1,1.4,10.6.3,17.4a2.5,2.5,0,0,0,.7,2.5c2.5,2.5,10.5,1.2,12,.9l.7-2.6v-.4h.8v.2c.4,1,1,1.8,1.2,1.8a25.1,25.1,0,0,0,2.7-3.7c0-1.4-.2-12.4.5-15.4s.2-11-.5-11.9-3.9-1.5-6.2-1.9l-4,1.9-2.7-.4c-.8.3-6.3,2.5-7.7,5.3Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3579" data-name="XMLID 3579">
          <path
            id="XMLID_3583"
            data-name="XMLID 3583"
            class="cls-2"
            d="M117.2,25.9a7.7,7.7,0,0,1-.7,2.6,9.5,9.5,0,0,0,1.9,2.1,4.9,4.9,0,0,0,4.8.5,13.1,13.1,0,0,1-.7-4.4C122.8,25,117.2,25.9,117.2,25.9Z"
            transform="translate(0 0.1)"
          />
          <path
            id="XMLID_3580"
            data-name="XMLID 3580"
            class="cls-3"
            d="M121.4,31.9a5,5,0,0,1-3.1-1,7,7,0,0,1-2-2.2v-.4a10.2,10.2,0,0,0,.6-2.5v-.4h.4c.7-.1,4.5-.6,5.6.4a.8.8,0,0,1,.3.9,12,12,0,0,0,.7,4.2v.4h-.4A3.9,3.9,0,0,1,121.4,31.9ZM117,28.5a7.3,7.3,0,0,0,1.7,1.8,4.3,4.3,0,0,0,4.1.6,15.2,15.2,0,0,1-.6-4.2v-.2a13.7,13.7,0,0,0-4.5-.2A7.9,7.9,0,0,1,117,28.5Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3574" data-name="XMLID 3574">
          <path
            id="XMLID_3578"
            data-name="XMLID 3578"
            class="cls-1"
            d="M117,27.1s-2.8.5-3.2,2.5a9.1,9.1,0,0,0,7.1,4.5l.4-2.6a6,6,0,0,1-3.2-1.2A2.8,2.8,0,0,1,117,27.1Z"
            transform="translate(0 0.1)"
          />
          <path
            id="XMLID_3575"
            data-name="XMLID 3575"
            class="cls-3"
            d="M121.3,34.6h-.4a9.8,9.8,0,0,1-7.5-4.7h-.1c.4-2.3,3.4-2.8,3.6-2.8h.7l-.2.7a2.4,2.4,0,0,0,1,2.7,4.8,4.8,0,0,0,3,1.1h.5Zm-7.1-5.1a9.1,9.1,0,0,0,6.3,4.1l.3-1.7a7.9,7.9,0,0,1-3-1.2,3.3,3.3,0,0,1-1.4-3A3.1,3.1,0,0,0,114.2,29.5Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3569" data-name="XMLID 3569">
          <path
            id="XMLID_3573"
            data-name="XMLID 3573"
            class="cls-1"
            d="M122.2,31.4l1.5,2.2a3.8,3.8,0,0,0,1-4.5l-2.1.3A1.8,1.8,0,0,1,122.2,31.4Z"
            transform="translate(0 0.1)"
          />
          <path
            id="XMLID_3570"
            data-name="XMLID 3570"
            class="cls-3"
            d="M123.6,34.2l-1.9-2.9.2-.2a1.4,1.4,0,0,0,.3-1.5l-.2-.5,3-.4V29a4.3,4.3,0,0,1-1.1,4.9Zm-.8-2.7,1,1.5a3.6,3.6,0,0,0,.6-3.3l-1.3.2A2.2,2.2,0,0,1,122.8,31.5Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3564" data-name="XMLID 3564">
          <path
            id="XMLID_3568"
            data-name="XMLID 3568"
            class="cls-2"
            d="M125.5,19.2a10,10,0,0,1,.6,5.4,12.7,12.7,0,0,1-1.1,3.8l-.3.7a.7.7,0,0,1-.7.4,8.7,8.7,0,0,1-5.7-2.2l-.8-.9A2.4,2.4,0,0,1,117,25a1.9,1.9,0,0,1-1.2-2.7.8.8,0,0,1,.9-.3l.7-.9,2.5-3.3Z"
            transform="translate(0 0.1)"
          />
          <path
            id="XMLID_3565"
            data-name="XMLID 3565"
            class="cls-3"
            d="M124,30a8.9,8.9,0,0,1-6-2.4l-.8-.9a2.5,2.5,0,0,1-.6-1.4,2.1,2.1,0,0,1-1.3-1.3,2.5,2.5,0,0,1,.1-1.9,1.1,1.1,0,0,1,1.1-.6l3.3-4.3,5.9,1.6V19a13.3,13.3,0,0,1,.7,5.6,10.3,10.3,0,0,1-1.1,3.9l-.3.7A1,1,0,0,1,124,30Zm-7.5-7.6a.2.2,0,0,0-.2.2,1.7,1.7,0,0,0-.1,1.2,1.5,1.5,0,0,0,1,.9h.3V25a2.8,2.8,0,0,0,.4,1.2l.8.9a8.3,8.3,0,0,0,5.4,2.1l.3-.2.3-.7a15.8,15.8,0,0,0,1.1-3.7,12,12,0,0,0-.5-5l-5-1.3L117,22.6l-.5-.3Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3559" data-name="XMLID 3559">
          <path
            id="XMLID_3563"
            data-name="XMLID 3563"
            class="cls-3"
            d="M125.4,16.6a2.4,2.4,0,0,0,2.7.4s-.1,4-4.1,3.9-6.1-.2-6.2,1.4l-.7-.3a1,1,0,0,0-1.3.7v.2a3.1,3.1,0,0,1-1.1-2.6c0-1.8,1.4-6,5.4-5.8h.7A9.7,9.7,0,0,1,125.4,16.6Z"
            transform="translate(0 0.1)"
          />
          <path
            id="XMLID_3560"
            data-name="XMLID 3560"
            class="cls-3"
            d="M116.1,23.8l-.6-.4a3.3,3.3,0,0,1-1.3-2.9,6.7,6.7,0,0,1,2.1-4.8,4.7,4.7,0,0,1,3.7-1.4h.7a8.3,8.3,0,0,1,5,2.1,1.8,1.8,0,0,0,2.2.3l.6-.3v.7s-.2,4.3-4.5,4.3h-.6c-3.6-.1-5.2,0-5.3,1.1v.2l-.4.2-.9-.3a.4.4,0,0,0-.5.1c-.2.1-.2.3-.3.4Zm3.6-8.8a4,4,0,0,0-2.9,1.2,6.4,6.4,0,0,0-1.8,4.2,2.8,2.8,0,0,0,.6,1.8c.1-.1.2-.3.4-.4a1.5,1.5,0,0,1,1.3-.1h.3c.5-1.4,2.6-1.4,6-1.3h.6a3.3,3.3,0,0,0,3.5-2.9,2.4,2.4,0,0,1-2.4-.7,7.3,7.3,0,0,0-4.5-1.9h-1.1Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3557" data-name="XMLID 3557">
          <path
            id="XMLID_3558"
            data-name="XMLID 3558"
            class="cls-3"
            d="M123.1,58.7h-.8c.6-10.1,0-22.9,0-23h.8A220.6,220.6,0,0,1,123.1,58.7Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3555" data-name="XMLID 3555">
          <path
            id="XMLID_3556"
            data-name="XMLID 3556"
            class="cls-1"
            d="M119.1,77.9l-.9-1.2-.2-.2c-.7-.8-2.4-2.5-3-3.4l.5-.4a31.7,31.7,0,0,0,3,3.4l.2.2,1,1.3Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3553" data-name="XMLID 3553">
          <path
            id="XMLID_3554"
            data-name="XMLID 3554"
            class="cls-1"
            d="M122.5,62.2l-.7.2,2.6,7.5.6-.2Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3551" data-name="XMLID 3551">
          <path
            id="XMLID_3552"
            data-name="XMLID 3552"
            class="cls-1"
            d="M112.2,67.7v-.6a3,3,0,0,0,2.2-1.4,3.9,3.9,0,0,0,.1-2.8l.6-.2a5,5,0,0,1-.1,3.4A5,5,0,0,1,112.2,67.7Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3549" data-name="XMLID 3549">
          <path
            id="XMLID_3550"
            data-name="XMLID 3550"
            class="cls-1"
            d="M122.9,84.5l-.5-.4a6.9,6.9,0,0,1,1.3-1.1l.3.6h0A3.1,3.1,0,0,0,122.9,84.5Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3547" data-name="XMLID 3547">
          <path
            id="XMLID_3548"
            data-name="XMLID 3548"
            class="cls-1"
            d="M126.7,101.9a3.9,3.9,0,0,1-1.8-.4l.3-.6c2.1.9,3.2-.2,3.3-.3l.5.5A4,4,0,0,1,126.7,101.9Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3545" data-name="XMLID 3545">
          <path
            id="XMLID_3546"
            data-name="XMLID 3546"
            class="cls-1"
            d="M105.7,83.3a4.2,4.2,0,0,1-2.1-3.3h.6a3.9,3.9,0,0,0,1.8,2.8Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3543" data-name="XMLID 3543">
          <path
            id="XMLID_3544"
            data-name="XMLID 3544"
            class="cls-1"
            d="M117.2,21.2a3.1,3.1,0,0,1,.2-2.8,3.7,3.7,0,0,1,2.8-1.3c1.6-.1,1.7-.9,1.7-1h.6c0,.1-.1,1.4-2.3,1.6a3.7,3.7,0,0,0-2.4,1,2.7,2.7,0,0,0-.1,2.3Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3541" data-name="XMLID 3541">
          <path
            id="XMLID_3542"
            data-name="XMLID 3542"
            class="cls-1"
            d="M115.9,21.6a3,3,0,0,1-.6-2.6l.6.2s-.4,1.3.4,1.9Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3539" data-name="XMLID 3539">
          <path
            id="XMLID_3540"
            data-name="XMLID 3540"
            class="cls-3"
            d="M130.4,109.3v-.8a3,3,0,0,0,1.9-1l.7.5A3.8,3.8,0,0,1,130.4,109.3Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3537" data-name="XMLID 3537">
          <path
            id="XMLID_3538"
            data-name="XMLID 3538"
            class="cls-3"
            d="M103.8,88a2.8,2.8,0,0,1-1.8-.6l.5-.7a2.5,2.5,0,0,0,2.2.2l.3.8C105,87.8,104.5,88,103.8,88Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3535" data-name="XMLID 3535">
          <path
            id="XMLID_3536"
            data-name="XMLID 3536"
            class="cls-3"
            d="M103.7,89.7l-1.6-.3.3-.8c1.6.7,2.3-.1,2.3-.1l.7.5A2.2,2.2,0,0,1,103.7,89.7Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3533" data-name="XMLID 3533">
          <path
            id="XMLID_3534"
            data-name="XMLID 3534"
            class="cls-3"
            d="M131.7,110.1v-.8a2.7,2.7,0,0,0,1.6-1l.7.5A3,3,0,0,1,131.7,110.1Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3531" data-name="XMLID 3531">
          <path
            id="XMLID_3532"
            data-name="XMLID 3532"
            class="cls-3"
            d="M115.3,31.3l-.8-.4a5.6,5.6,0,0,1,2.4-2.2l.3.8A6.6,6.6,0,0,0,115.3,31.3Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3529" data-name="XMLID 3529">
          <path
            id="XMLID_3530"
            data-name="XMLID 3530"
            class="cls-3"
            d="M117.5,25.3h-.8a3.5,3.5,0,0,1,.6-1.4l.6.6A1.2,1.2,0,0,0,117.5,25.3Z"
            transform="translate(0 0.1)"
          />
        </g>
      </g>
      <g id="Glass">
        <path
          class="cls-4"
          d="M166.9,16.9a27.8,27.8,0,0,0-5.7-.7c-6.8,0-14.3,2.7-18.7,7a9.5,9.5,0,0,0-3.3,5.8,10.1,10.1,0,0,0,5.8,3.6c7.7,2.1,18.6-.7,24.3-6.3a10.4,10.4,0,0,0,3.2-5.9A9.8,9.8,0,0,0,166.9,16.9ZM147.4,31.7c-4.9-.7-6.8-3.6-6.9-3.7l.7-.4s1.8,2.7,6.3,3.3Zm23.5-10.4a10.6,10.6,0,0,0-4.3-2.6l.2-.8a9.9,9.9,0,0,1,4.6,2.8Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-3"
          d="M180.4,20.7l-1.2-4.6h-.1c-1.1-3.6-4.5-6.3-9.6-7.8-10.7-2.9-25.8,1-33.7,8.8-3.9,3.8-5.5,8-4.5,11.8a1.9,1.9,0,0,0,.2.7l.9,3.4a9,9,0,0,0,4.4,5.8l-23.5,23h-.1l-.2.2a.8.8,0,0,0-.2.8l.8,2.9a1.6,1.6,0,0,0,1,1.1l3.1.9h.2l.5-.2h.3l4.5-4.5-4.4,4.1-.4-.4,7.8-7.4.4.3,18.3-17.8a28.1,28.1,0,0,0,5,.4c9.4,0,19.9-3.7,26-9.7C179.8,28.6,181.4,24.5,180.4,20.7Zm-6.2,6.9c-7.7,7.6-22.5,11.5-32.9,8.6-5-1.4-8.2-4.1-9.1-7.5s.6-7.4,4.3-11c7.7-7.6,22.5-11.5,32.9-8.6,5,1.4,8.2,4,9.1,7.5s-.6,7.4-4.3,11Zm-34.1,9.1,3,.8.4.5.3,1.3L118,64.5l-.2-.7a1.6,1.6,0,0,0-1-1.1l-2.5-.7Zm-26.4,26,2.9.8.4.5.7,2.8-2.9-.8-.4-.5Zm35.9-20.9-1.1-4.1.8-.2,1.1,4.1Zm22.8-7.4-1.1-4.1.8-.2,1.1,4.1Zm4.9-4.6-1.1-4.1.8-.2,1.1,4.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-2"
          d="M178.5,16.6c-.9-3.5-4.1-6.1-9.1-7.5-10.4-2.9-25.2,1-32.9,8.6-3.7,3.6-5.2,7.5-4.3,11s4.1,6.1,9.1,7.5c10.4,2.9,25.2-1,32.9-8.6C177.9,24,179.4,20.1,178.5,16.6Zm-28,17.5a22.5,22.5,0,0,1-5.8-.7c-3.9-1.1-6.5-3.3-7.3-6.1s.5-6,3.4-8.9c5.9-5.8,17.2-8.7,25.1-6.5,3.9,1.1,6.5,3.3,7.3,6.1s-.5,6-3.4,8.9C165.3,31.4,157.5,34.1,150.5,34.1Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-3"
          d="M173.2,18c-.8-2.8-3.4-5-7.3-6.1-7.9-2.2-19.2.7-25.1,6.5-2.9,2.9-4.1,6.1-3.4,8.9s3.4,5,7.3,6.1a22.5,22.5,0,0,0,5.8.7c7,0,14.8-2.7,19.3-7.2C172.7,24,173.9,20.8,173.2,18ZM145,32.6a10.1,10.1,0,0,1-5.8-3.6,9.5,9.5,0,0,1,3.3-5.8c4.4-4.3,11.9-7,18.7-7a27.8,27.8,0,0,1,5.7.7,9.8,9.8,0,0,1,5.6,3.5,10.4,10.4,0,0,1-3.2,5.9C163.6,31.9,152.7,34.7,145,32.6Zm18.2-16.9-.8.2-1.1-4.2.8-.2Zm-19.3,1,1.1,4.1-.8.2-1.1-4.1Z"
          transform="translate(0 0.1)"
        />
        <rect
          class="cls-1"
          x="149.2"
          y="37.5"
          width="0.8"
          height="4.3"
          transform="translate(-5.2 39) rotate(-14.6)"
        />
        <rect
          class="cls-1"
          x="176.8"
          y="25.5"
          width="0.8"
          height="4.3"
          transform="translate(-1.2 45.6) rotate(-14.6)"
        />
        <rect
          class="cls-1"
          x="172"
          y="30.1"
          width="0.8"
          height="4.3"
          transform="translate(-2.6 44.6) rotate(-14.6)"
        />
        <rect
          class="cls-1"
          x="143.7"
          y="16.7"
          width="0.8"
          height="4.3"
          transform="translate(-0.1 37) rotate(-14.6)"
        />
        <rect
          class="cls-1"
          x="161.9"
          y="11.5"
          width="0.8"
          height="4.3"
          transform="translate(1.8 41.4) rotate(-14.6)"
        />
        <path
          class="cls-2"
          d="M114.3,62l2.5.7a1.6,1.6,0,0,1,1,1.1l.2.7,25.8-25.2-.3-1.3-.4-.5-3-.8Zm6.5-2.2-.6-.6,4.5-4.4.6.6ZM141,38.9l.5.5L127.9,52.8l-.6-.6Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-1"
          d="M114.8,66l2.9.8L117,64l-.4-.5-2.9-.8.7,2.8Z"
          transform="translate(0 0.1)"
        />
        <rect
          class="cls-3"
          x="124.9"
          y="45.5"
          width="19.1"
          height="0.8"
          transform="translate(6.2 107) rotate(-44.3)"
        />
        <rect
          class="cls-3"
          x="119.7"
          y="57"
          width="6.3"
          height="0.8"
          transform="translate(-5.2 102.2) rotate(-44.3)"
        />
        <polygon
          class="cls-1"
          points="126.3 59.4 118.4 66.8 118.9 67.3 123.3 63.1 126.7 59.8 126.6 59.8 126.3 59.4"
        />
        <path
          class="cls-3"
          d="M141.2,27.6l-.7.4c.1.1,2,3,6.9,3.7v-.8A9,9,0,0,1,141.2,27.6Z"
          transform="translate(0 0.1)"
        />
        <path
          class="cls-3"
          d="M166.6,18.7a10.6,10.6,0,0,1,4.3,2.6l.5-.6a9.9,9.9,0,0,0-4.6-2.8Z"
          transform="translate(0 0.1)"
        />
      </g>
      <g id="Arm">
        <g id="XMLID_3471" data-name="XMLID 3471">
          <path
            id="XMLID_3475"
            data-name="XMLID 3475"
            class="cls-2"
            d="M116.1,57.3a5.6,5.6,0,0,0,3.3,1h2.5c1.4-.2,4-2.6.2-3l-1.9-.2v-.2l.8-.7v-.3l-.9-.2a2.7,2.7,0,0,0-2.5,1.6A9.5,9.5,0,0,1,116.1,57.3Z"
            transform="translate(0 0.1)"
          />
          <path
            id="XMLID_3472"
            data-name="XMLID 3472"
            class="cls-3"
            d="M119.3,58.7a6.7,6.7,0,0,1-3.4-1l-.4-.3.3-.4a7.4,7.4,0,0,0,1.3-2.1,3.1,3.1,0,0,1,2.9-1.8l1.3.3v.8l-.4.3,1.2.2c2,.3,2.4,1,2.4,1.6a4,4,0,0,1-2.6,2.3Zm-2.6-1.5a5.9,5.9,0,0,0,2.6.7h2.5c.8-.1,1.8-.9,1.8-1.4s-.6-.6-1.7-.8l-2-.2-.5-.6.7-.7h-.3a2.2,2.2,0,0,0-2,1.4Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3466" data-name="XMLID 3466">
          <path
            id="XMLID_3470"
            data-name="XMLID 3470"
            class="cls-1"
            d="M116.3,54.3l1.5.7a4.2,4.2,0,0,1-.7,2.9l-1.4-.6L114,55Z"
            transform="translate(0 0.1)"
          />
          <path
            id="XMLID_3467"
            data-name="XMLID 3467"
            class="cls-3"
            d="M117.2,58.3l-1.8-.7-2.1-2.9,3.1-.9,1.8.8v.2a4.1,4.1,0,0,1-.8,3.2Zm-1.3-1.4,1,.4a3.8,3.8,0,0,0,.5-2.1l-1.1-.5-1.6.5Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3461" data-name="XMLID 3461">
          <path
            id="XMLID_3465"
            data-name="XMLID 3465"
            class="cls-2"
            d="M110.1,33.6a2.3,2.3,0,0,0-3.2.4.1.1,0,0,0-.1.1c-1.3,2.5-5.8,11-7.2,15.2a1.1,1.1,0,0,0,.4,1.2c2.4,1.5,10.8,6.5,15.6,6.8,0,0,.6-.4.7-3,0,0-4.3-2.5-5.5-3.5a10.1,10.1,0,0,0-4.9-2.3s5.3-7.4,5.6-10.6S110.1,33.6,110.1,33.6Z"
            transform="translate(0 0.1)"
          />
          <path
            id="XMLID_3462"
            data-name="XMLID 3462"
            class="cls-3"
            d="M115.8,57.7h-.2c-4.9-.4-13.3-5.4-15.8-6.9a1.3,1.3,0,0,1-.6-1.6c1.5-4.4,6.2-13.3,7.3-15.2a2.1,2.1,0,0,1,1.4-1,3.1,3.1,0,0,1,2.5.4c.1.1,2,1.3,1.6,4.7s-4.1,8.4-5.3,10.2a11.3,11.3,0,0,1,4.5,2.3c1.2.9,5.4,3.4,5.5,3.5h.2v.3c-.1,2.6-.6,3.2-.8,3.3Zm-7.2-24.1h-.5a1.6,1.6,0,0,0-.8.6c-1.1,2-5.8,10.8-7.2,15.1a.6.6,0,0,0,.2.7c2.4,1.5,10.5,6.3,15.2,6.8a4.5,4.5,0,0,0,.4-2.3,49.3,49.3,0,0,1-5.4-3.4,10.2,10.2,0,0,0-4.7-2.2h-.7l.4-.6c.1-.1,5.2-7.4,5.6-10.4s-1.1-3.8-1.2-3.9A2,2,0,0,0,108.6,33.6Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3459" data-name="XMLID 3459">
          <path
            id="XMLID_3460"
            data-name="XMLID 3460"
            class="cls-3"
            d="M104.3,49.6l-.6-.6a4.1,4.1,0,0,1,2.1-1v.8C105.9,48.9,104.9,49,104.3,49.6Z"
            transform="translate(0 0.1)"
          />
        </g>
      </g>
      <g id="Hand">
        <path
          id="XMLID_3457"
          data-name="XMLID 3457"
          class="cls-2"
          d="M133.5,51.7h-.8a1.1,1.1,0,0,0-.8.3l-2.1,1.9a1,1,0,0,0-.3,1,1.2,1.2,0,0,0,1.3,1h.8a4.1,4.1,0,0,0,2.1-1,2.8,2.8,0,0,0,.9-1.9A1.4,1.4,0,0,0,133.5,51.7Z"
          transform="translate(0 0.1)"
        />
        <path
          id="XMLID_3454"
          data-name="XMLID 3454"
          class="cls-3"
          d="M130.6,56.3a1.6,1.6,0,0,1-.9-.3,2.1,2.1,0,0,1-.6-1,1.3,1.3,0,0,1,.5-1.3l2.1-1.9a1.5,1.5,0,0,1,1.1-.4h.8a1.2,1.2,0,0,1,1,.5A1.5,1.5,0,0,1,135,53a3.2,3.2,0,0,1-1,2.2,4.4,4.4,0,0,1-2.4,1.1Zm2-4.2-.5.2L130,54.2a.7.7,0,0,0-.2.6.5.5,0,0,0,.3.5.4.4,0,0,0,.5.1h.8a3.4,3.4,0,0,0,1.9-.9,2.5,2.5,0,0,0,.8-1.6.8.8,0,0,0-.2-.5l-.5-.2Z"
          transform="translate(0 0.1)"
        />
      </g>
    </g>
    <g id="ThreeBlocs">
      <path
        id="Shadow-2"
        class="cls-3"
        d="M98.4,158.1l-.6-.2L68.1,175l.5.3Zm1.6.6-.5-.2L69.4,175.8l.5.3Zm1.9.6-.7-.2L70.8,176.6l.5.3Zm1.7.5-.7-.2L72.1,177.3l.5.3Zm1.6.6-.6-.2L73.5,178.1l.5.3Zm1.2.4L74.9,178.9l.3.3L107,160.9Zm1.6.6L69.3,183.7a.6.6,0,0,0,0,.6l39.4-22.7Zm2.5.8-.8-.2L69.9,184.9l.5.3Zm1.6.6-.5-.3L71.3,185.7l.5.3Zm1.8.5-.7-.2L72.7,186.5l.5.3Zm1.7.6-.6-.2L74,187.3l.5.3Zm1.6.6-.6-.2L75.4,188.1l.5.2Zm1.8.6-.5-.2-41.8,24,.5.2Zm1.7.6-.6-.3-42,24.2.5.3Zm1.8.5-.6-.2L79.5,190.4l.4.3Zm-29.3-9.8-.6-.2L64.2,172.5c.1.2.1.3.3.4Zm1.8.5-.6-.2-29,16.7.5.3Zm1.1.4L66.7,174.2l.5.3,29.5-17Zm34.5,12.2-.6-.2L94.1,190l.5.2Zm1.4.7-.4-.2L95.5,190.7l.4.3Zm1.6.7-.6-.2L96.8,191.5l.5.3Zm1.4.7-.4-.2L98.2,192.3l.5.3Zm1.6.8-.6-.3-36.4,21,.4.3Zm1,.4-36.6,21h1l36-20.7Zm1.4.7-16,9.2h0l.5.2,16.1-9.2Zm2,1-.4-.3-16.2,9.3.5.3Zm.9,1.1v-.5l-16.2,9.3.5.3Zm-2.3,2.9,1-1.1L127,185.1l.6.3Zm-2.9,3.2,1-1.1-9.3,5.3.5.3Zm-2.8,3.2,1-1.2-5,3,.5.2Zm-2,2.2.3-.2-.8.4c.2.1.3,0,.5-.2Zm-8.3-20.5L80.9,191.2h.5l42.8-24.7Zm1.8.6L89.3,188h1L126,167.5Zm2.2.9-.6-.3L91.4,188.4l.4.3Zm1,.4L92.7,189.2l.5.3L129,168.8Z"
        transform="translate(0 0.1)"
      />
      <g id="BlockElement_3" data-name="BlockElement 3">
        <g id="XMLID_3693" data-name="XMLID 3693">
          <g id="XMLID_3738" data-name="XMLID 3738">
            <g id="XMLID_3739" data-name="XMLID 3739">
              <g id="XMLID_3742" data-name="XMLID 3742">
                <g id="XMLID_3753" data-name="XMLID 3753">
                  <path
                    id="XMLID_3757"
                    data-name="XMLID 3757"
                    class="cls-1"
                    d="M97.7,186.8,65,168c-.2-.1-.3-.2-.3-.4v-3.8a.2.2,0,0,1,.2-.2h6.3l24.7-14.4a1.8,1.8,0,0,1,1.6-.1L124,164.4h6.4l.2.2v3.8a.7.7,0,0,1-.4.5L99.4,186.6A2,2,0,0,1,97.7,186.8Z"
                    transform="translate(0 0.1)"
                  />
                  <path
                    id="XMLID_3754"
                    data-name="XMLID 3754"
                    class="cls-3"
                    d="M98.4,187.4l-.9-.2L64.8,168.4a1,1,0,0,1-.5-.8v-3.8a.6.6,0,0,1,.6-.6h6.2l24.6-14.3a2,2,0,0,1,2-.1L124.1,164h6.1l.5.2.2.4v3.8c0,.4-.2.6-.7.9L99.5,187A1.5,1.5,0,0,1,98.4,187.4Zm-.5-1a1.7,1.7,0,0,0,1.2-.1l30.8-17.9v-3.7h-6.1L97.3,149.3a1.7,1.7,0,0,0-1.2.1L71.4,163.8H65.1v3.6h.1Z"
                    transform="translate(0 0.1)"
                  />
                </g>
                <g id="XMLID_3748" data-name="XMLID 3748">
                  <path
                    id="XMLID_3752"
                    data-name="XMLID 3752"
                    class="cls-3"
                    d="M90.3,165.2c.4-.1,14.3-7,19.8-8.9l13.9,8h6.2l.2.2v3.8c0,.2-.2.4-.5.5L99.2,186.6h-.1v-3.9Z"
                    transform="translate(0 0.1)"
                  />
                  <path
                    id="XMLID_3749"
                    data-name="XMLID 3749"
                    class="cls-3"
                    d="M99.4,187.2h-.3a.5.5,0,0,1-.2-.4V183l-9-17.4v-.4h.3l2-.9c4.1-1.9,13.6-6.4,17.8-7.9h.5l13.6,7.9h6.2l.5.2c0,.2.1.3.1.5v3.8c0,.4-.1.6-.6.9Zm.4-4.5V186l30.1-17.6.3-.2v-3.5h-6.3l-13.7-7.9c-4.2,1.5-13.6,5.9-17.6,7.8l-1.7.8,8.9,17Z"
                    transform="translate(0 0.1)"
                  />
                </g>
                <g id="XMLID_3743" data-name="XMLID 3743">
                  <path
                    id="XMLID_3747"
                    data-name="XMLID 3747"
                    class="cls-2"
                    d="M130.2,163.8,97.6,145a1.8,1.8,0,0,0-1.6.1L65.2,163c-.5.3-.5.7-.1.9l32.7,18.8a1.8,1.8,0,0,0,1.6-.1l30.8-17.9C130.6,164.5,130.7,164.1,130.2,163.8Z"
                    transform="translate(0 0.1)"
                  />
                  <path
                    id="XMLID_3744"
                    data-name="XMLID 3744"
                    class="cls-3"
                    d="M98.4,183.3l-.9-.2L64.8,164.3a1,1,0,0,1-.5-.8,1.1,1.1,0,0,1,.6-.9l30.8-17.9a2,2,0,0,1,2-.1l32.7,18.8a.8.8,0,0,1,.4,1.2c-.1.3-.3.4-.6.5L99.5,183A2,2,0,0,1,98.4,183.3ZM65.1,163.5h0l32.8,18.8a1.7,1.7,0,0,0,1.2-.1l30.8-17.9c0-.1.1-.1.1-.2h-.1L97.3,145.3a1.7,1.7,0,0,0-1.2.1L65.3,163.3Z"
                    transform="translate(0 0.1)"
                  />
                </g>
              </g>
              <g id="XMLID_3740" data-name="XMLID 3740">
                <path
                  id="XMLID_3741"
                  data-name="XMLID 3741"
                  class="cls-3"
                  d="M66.9,165.5v3.8h.7l.2-3.9Z"
                  transform="translate(0 0.1)"
                />
              </g>
            </g>
          </g>
          <g id="XMLID_3716" data-name="XMLID 3716">
            <g id="XMLID_3717" data-name="XMLID 3717">
              <g id="XMLID_3722" data-name="XMLID 3722">
                <g id="XMLID_3733" data-name="XMLID 3733">
                  <path
                    id="XMLID_3737"
                    data-name="XMLID 3737"
                    class="cls-1"
                    d="M80.4,186.3,68,179.1c-.2-.1-.3-.2-.3-.4v-3.8l.2-.2h6.3l-2.1,1.2a1.8,1.8,0,0,1,1.6-.1l6.2,3.7h6.3l.2.2v3.8c0,.2-.2.5-.4.5l-4,2.4A1.8,1.8,0,0,1,80.4,186.3Z"
                    transform="translate(0 0.1)"
                  />
                  <path
                    id="XMLID_3734"
                    data-name="XMLID 3734"
                    class="cls-3"
                    d="M81.1,186.9l-.9-.2-12.4-7.2a1,1,0,0,1-.5-.8v-3.8a.6.6,0,0,1,.6-.6H74l.4.7-.6.3h.1l6.1,3.6h6.1l.4.2.2.4v3.8c0,.4-.2.6-.6.9l-4,2.4A1,1,0,0,1,81.1,186.9Zm-.5-1a1.7,1.7,0,0,0,1.2-.1l4-2.4.2-.2v-3.5H79.8L73.6,176a1.7,1.7,0,0,0-1.2.1l-.4-.7.6-.3H68.2v3.5h.1Z"
                    transform="translate(0 0.1)"
                  />
                </g>
                <g id="XMLID_3728" data-name="XMLID 3728">
                  <path
                    id="XMLID_3732"
                    data-name="XMLID 3732"
                    class="cls-3"
                    d="M80.8,179.4h5.4l.2.2v3.8c0,.2-.2.5-.4.5l-4,2.3h-.1v-3.9A14.5,14.5,0,0,0,80.8,179.4Z"
                    transform="translate(0 0.1)"
                  />
                  <path
                    id="XMLID_3729"
                    data-name="XMLID 3729"
                    class="cls-3"
                    d="M82.1,186.7h-.3a.5.5,0,0,1-.2-.4v-3.9l-1.2-2.7-.2-.4.4-.2h5.6l.5.2a.8.8,0,0,1,.2.5v3.8c0,.4-.2.6-.6.9Zm.4-4.4v3.1l3.4-2,.2-.2v-3.5H81.5l1,2.2Z"
                    transform="translate(0 0.1)"
                  />
                </g>
                <g id="XMLID_3723" data-name="XMLID 3723">
                  <path
                    id="XMLID_3727"
                    data-name="XMLID 3727"
                    class="cls-2"
                    d="M86.2,178.9l-12.4-7.2a1.8,1.8,0,0,0-1.6.1l-4,2.4c-.5.3-.5.7-.1.9l12.4,7.2a1.8,1.8,0,0,0,1.6-.1l4-2.4C86.6,179.5,86.6,179.1,86.2,178.9Z"
                    transform="translate(0 0.1)"
                  />
                  <path
                    id="XMLID_3724"
                    data-name="XMLID 3724"
                    class="cls-3"
                    d="M81.2,182.8l-.9-.2-12.4-7.2a1,1,0,0,1-.5-.8,1.1,1.1,0,0,1,.6-.9l4-2.4a2,2,0,0,1,2-.1l12.4,7.2a1,1,0,0,1,.5.8,1.1,1.1,0,0,1-.6.9l-4,2.4A2,2,0,0,1,81.2,182.8Zm-12.9-8.1,12.4,7.2a1.7,1.7,0,0,0,1.2-.1l4-2.4.2-.2H86L73.6,172a1.7,1.7,0,0,0-1.2.1l-4,2.4v.2Z"
                    transform="translate(0 0.1)"
                  />
                </g>
              </g>
              <g id="XMLID_3720" data-name="XMLID 3720">
                <path
                  id="XMLID_3721"
                  data-name="XMLID 3721"
                  class="cls-3"
                  d="M70,176.5l-.2,3.9h.8l.2-3.9Z"
                  transform="translate(0 0.1)"
                />
              </g>
              <g id="XMLID_3718" data-name="XMLID 3718">
                <path
                  id="XMLID_3719"
                  data-name="XMLID 3719"
                  class="cls-1"
                  d="M82.6,182v3.4h.7V182Z"
                  transform="translate(0 0.1)"
                />
              </g>
            </g>
          </g>
          <g id="XMLID_3694" data-name="XMLID 3694">
            <g id="XMLID_3695" data-name="XMLID 3695">
              <g id="XMLID_3700" data-name="XMLID 3700">
                <g id="XMLID_3711" data-name="XMLID 3711">
                  <path
                    id="XMLID_3715"
                    data-name="XMLID 3715"
                    class="cls-1"
                    d="M89.6,162.4,70.3,151.2c-.2-.1-.3-.2-.3-.4V147l.2-.2,13-3.9h.1l6.1-3.4a1.8,1.8,0,0,1,1.6-.1l13,7.7h6.4a.2.2,0,0,1,.2.2v3.8c0,.2-.1.4-.5.5L91.2,162.4A1.5,1.5,0,0,1,89.6,162.4Z"
                    transform="translate(0 0.1)"
                  />
                  <path
                    id="XMLID_3712"
                    data-name="XMLID 3712"
                    class="cls-3"
                    d="M90.2,163l-.9-.2L70.1,151.6a1,1,0,0,1-.5-.8V147a.6.6,0,0,1,.5-.6l13-3.9,6-3.4a2,2,0,0,1,2-.1l12.9,7.6h6.1l.5.2V151c0,.4-.1.6-.6.9L91.2,162.7A1.7,1.7,0,0,1,90.2,163Zm-.4-.9A1.7,1.7,0,0,0,91,162l19-10.9v-3.7h-6.1l-13.1-7.7a1.7,1.7,0,0,0-1.2.1l-6.1,3.4h-.2l-12.9,4v3.6h.1Z"
                    transform="translate(0 0.1)"
                  />
                </g>
                <g id="XMLID_3706" data-name="XMLID 3706">
                  <path
                    id="XMLID_3710"
                    data-name="XMLID 3710"
                    class="cls-3"
                    d="M104.9,147h5.3c.2,0,.3.1.3.2V151c0,.2-.1.4-.5.5L91.2,162.3h-.1v-3.9C90.7,157.1,104.9,147,104.9,147Z"
                    transform="translate(0 0.1)"
                  />
                  <path
                    id="XMLID_3707"
                    data-name="XMLID 3707"
                    class="cls-3"
                    d="M91.2,162.8h-.3a.5.5,0,0,1-.2-.4v-4c-.1-.4.1-1.4,6.8-6.5l7-5.2h5.6l.5.2c0,.2.1.3.1.5v3.8c0,.4-.1.6-.6.9Zm.4-4.3v3.2l18.3-10.5v-3.7h-5c-6.4,4.5-13,9.8-13.4,10.8Z"
                    transform="translate(0 0.1)"
                  />
                </g>
                <g id="XMLID_3701" data-name="XMLID 3701">
                  <path
                    id="XMLID_3705"
                    data-name="XMLID 3705"
                    class="cls-2"
                    d="M110.2,146.5,91,135.3a1.8,1.8,0,0,0-1.6.1l-19,10.9c-.5.3-.5.7-.1.9l19.2,11.2a1.8,1.8,0,0,0,1.6-.1L110,147.4C110.6,147.2,110.6,146.7,110.2,146.5Z"
                    transform="translate(0 0.1)"
                  />
                  <path
                    id="XMLID_3702"
                    data-name="XMLID 3702"
                    class="cls-3"
                    d="M90.3,159l-.9-.2L70.2,147.6a1,1,0,0,1-.5-.8,1.1,1.1,0,0,1,.6-.9l19-10.9a2,2,0,0,1,2-.1l19.2,11.2c.2.2.5.5.5.8a1.5,1.5,0,0,1-.6.9l-19,10.9A2,2,0,0,1,90.3,159ZM70.5,146.8,89.8,158a1.7,1.7,0,0,0,1.2-.1L110,147v-.2h-.1l-19-11.2a1.7,1.7,0,0,0-1.2.1l-19,10.9Z"
                    transform="translate(0 0.1)"
                  />
                </g>
              </g>
              <g id="XMLID_3698" data-name="XMLID 3698">
                <path
                  id="XMLID_3699"
                  data-name="XMLID 3699"
                  class="cls-3"
                  d="M72.3,148.7v3.9h.8v-3.9Z"
                  transform="translate(0 0.1)"
                />
              </g>
              <g id="XMLID_3696" data-name="XMLID 3696">
                <path
                  id="XMLID_3697"
                  data-name="XMLID 3697"
                  class="cls-1"
                  d="M106.7,149.7v3.4h.7v-3.4Z"
                  transform="translate(0 0.1)"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="XMLID_3687" data-name="XMLID 3687">
          <path
            id="XMLID_3688"
            data-name="XMLID 3688"
            class="cls-1"
            d="M97.9,175.6l-3.5-.5.5-1-1.2-.5a3.9,3.9,0,0,1-1-.8l-1.7.3-1-2.2,1.7-.3a2.4,2.4,0,0,1,.7-1.6l-1.3-.7,2.7-1.6,1.2.7a11.3,11.3,0,0,1,3.2-.5l.4-.9,3.4.5-.4,1,1.1.5a3.9,3.9,0,0,1,1,.8l1.8-.3,1,2.2-1.8.3a2,2,0,0,1-.7,1.6l1.4.7-2.8,1.6-1.1-.7a11.3,11.3,0,0,1-3.2.5Zm-2.5-1,2.1.3.4-.9h.2a12.6,12.6,0,0,0,3.3-.5h.1l1.1.6,1.4-.8-1-.6.2-.3a1.9,1.9,0,0,0,.8-1.7v-.3l1.5-.2-.5-1-1.5.2h-.1l-1-.8L101,168h-.4l.4-.9-2.1-.3-.4.9h-.2a12.6,12.6,0,0,0-3.3.5h-.1l-1.1-.8-1.4.8,1,.6-.3.3a2.1,2.1,0,0,0-.8,1.7v.3l-1.4.2.5,1,1.5-.2H93a3.9,3.9,0,0,0,1,.8l1.4.6h.4Zm2.9-2a4.4,4.4,0,0,1-2.5-.8,1.3,1.3,0,0,1-.2-1.8l.2-.2a3.9,3.9,0,0,1,4.8,0,1.2,1.2,0,0,1,.3,1.7l-.3.3A4,4,0,0,1,98.3,172.6Zm0-3a3.6,3.6,0,0,0-2,.6c-.2.2-.3.3-.3.5a.5.5,0,0,0,.3.5,3.5,3.5,0,0,0,3.9,0c.3-.2.4-.3.4-.5s-.2-.5-.4-.5A3.1,3.1,0,0,0,98.3,169.6Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3683" data-name="XMLID 3683">
          <path
            id="XMLID_3684"
            data-name="XMLID 3684"
            class="cls-3"
            d="M102.7,167.2a3.9,3.9,0,0,0-1.5-.6l.4-.9-2.7-.4-.4.9a12.7,12.7,0,0,0-3.4.5l-1.2-.7-2,1.2,1.2.7a2.5,2.5,0,0,0-.9,2l-1.6.2.8,1.6,1.6-.2,1.1.8,1.5.6-.4.9,2.8.4.4-.9a12.6,12.6,0,0,0,3.3-.5l1.3.7,2-1.2-1.3-.7a2.2,2.2,0,0,0,.9-2l1.6-.2-.7-1.6-1.6.2Zm-2.1,3.3a3.7,3.7,0,0,1-4.5,0,1,1,0,0,1-.3-1.2l.3-.3a3.7,3.7,0,0,1,4.5,0A1.1,1.1,0,0,1,100.6,170.5Z"
            transform="translate(0 0.1)"
          />
        </g>
      </g>
      <g id="Block_Element_2" data-name="Block Element 2">
        <g id="XMLID_3661" data-name="XMLID 3661">
          <g id="XMLID_3666" data-name="XMLID 3666">
            <g id="XMLID_3677" data-name="XMLID 3677">
              <path
                id="XMLID_3681"
                data-name="XMLID 3681"
                class="cls-1"
                d="M126,177.4l-12.4-7.2-.4-.4V166l.3-.2h6.2l6.2-3.4a1.8,1.8,0,0,1,1.6-.1l6.2,3.7h6.2l.3.2V170c0,.2-.2.4-.5.5l-12.1,7A1.8,1.8,0,0,1,126,177.4Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_3678"
                data-name="XMLID 3678"
                class="cls-3"
                d="M126.6,178l-.9-.2-12.3-7.2a.9.9,0,0,1-.5-.8V166a.6.6,0,0,1,.6-.6h6.1l6-3.4a2,2,0,0,1,2-.1l6.1,3.6h6.2l.3.2a.5.5,0,0,1,.2.4v3.8c0,.4-.2.6-.5.9l-12.3,7Zm-.5-1a2,2,0,0,0,1.3-.1l12.2-7v-3.7h-6.1l-6.2-3.7a2,2,0,0,0-1.3.1l-6.1,3.4h-6.3v3.5h.2Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_3672" data-name="XMLID 3672">
              <path
                id="XMLID_3676"
                data-name="XMLID 3676"
                class="cls-3"
                d="M134.6,165.8h5.3l.3.2v3.8c0,.2-.2.4-.5.5l-12.1,7h0v-3.9C127.1,172,134.6,165.8,134.6,165.8Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_3673"
                data-name="XMLID 3673"
                class="cls-3"
                d="M127.6,177.7h-.2c-.2-.1-.3-.2-.3-.4v-3.9c-.1-1.5,4.3-5.5,7.1-7.8h5.7c.3,0,.3.1.5.2s.2.3.2.5v3.8c0,.4-.2.6-.7.9Zm.4-4.3v3.2l11.7-6.6.2-.2v-3.5h-5.2c-3.3,2.8-6.7,6.1-6.7,6.9Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_3667" data-name="XMLID 3667">
              <path
                id="XMLID_3671"
                data-name="XMLID 3671"
                class="cls-2"
                d="M139.9,165.3l-12.3-7.2a1.8,1.8,0,0,0-1.6.1l-12.3,7c-.5.3-.5.7-.1.9l12.4,7.2a1.8,1.8,0,0,0,1.6-.1l12.3-7C140.2,166,140.4,165.6,139.9,165.3Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_3668"
                data-name="XMLID 3668"
                class="cls-3"
                d="M126.6,173.9l-.9-.2-12.3-7.2a.9.9,0,0,1-.5-.8.9.9,0,0,1,.6-.9l12.1-7a2,2,0,0,1,2-.1l12.4,7.2a.9.9,0,0,1,.6.8,1,1,0,0,1-.7.9l-12.2,7A2,2,0,0,1,126.6,173.9Zm-12.9-8.1,12.4,7.2a2,2,0,0,0,1.3-.1l12.2-7v-.2h0l-12.5-7.2a1.7,1.7,0,0,0-1.2.1l-12.1,7C113.9,165.7,113.7,165.7,113.7,165.8Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
          <g id="XMLID_3664" data-name="XMLID 3664">
            <path
              id="XMLID_3665"
              data-name="XMLID 3665"
              class="cls-3"
              d="M115.5,167.6v3.9h.8v-3.9Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3662" data-name="XMLID 3662">
            <path
              id="XMLID_3663"
              data-name="XMLID 3663"
              class="cls-1"
              d="M136.4,168.5v3.4h.7v-3.4Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
      </g>
      <g id="BlockElement1">
        <g id="XMLID_3643" data-name="XMLID 3643">
          <g id="XMLID_3655" data-name="XMLID 3655">
            <path
              id="XMLID_3659"
              data-name="XMLID 3659"
              class="cls-2"
              d="M133.4,154.9l-3.2-2h-.5l-3.3,1.9c-.2,0-.2.1-.2.2l3.2,5.4h0v.6a2,2,0,0,0,.6,1.4l-2.9-1.6h.1l3.2,5.4h.2l3.3-1.9a1.3,1.3,0,0,0,.1-.6V156A2.4,2.4,0,0,0,133.4,154.9Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3656"
              data-name="XMLID 3656"
              class="cls-3"
              d="M130.4,167h-.2a.3.3,0,0,1-.3-.3h0l-3.2-5.4h.2l.3-.7,1.7.8v-.8l-3.2-5.4a.6.6,0,0,1,.3-.8h0l3.2-1.9a.9.9,0,0,1,1,0l3.2,2a2.2,2.2,0,0,1,1,1.8V164c0,.4,0,.7-.4.9l-3.3,2Zm-2-4.9,2.2,3.9,3.1-1.8v-7.9a1.6,1.6,0,0,0-.5-1.1l-3.3-2h0l-3.2,1.8,3,5.2.2.3v.6a1.6,1.6,0,0,0,.5,1.1l-.5.7Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3649" data-name="XMLID 3649">
            <path
              id="XMLID_3654"
              data-name="XMLID 3654"
              class="cls-3"
              d="M127,159.9s1.2-7,2.4-1l-2.3,2.2h.1l3,5.3h.4l3.1-1.9c.2-.1.2-.3.2-.6v-7.6h0l-3.5,2Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3650"
              data-name="XMLID 3650"
              class="cls-3"
              d="M130.4,167h-.2a.3.3,0,0,1-.3-.3h0l-3-5.3-.3-.3.3-.3.5-.5-.9.4v-.8c.4-2.5,1-3.8,1.8-3.8s1,.7,1.3,2.3l.7-.3,3.5-2.1h.3c.2.1.2.2.2.4V164c0,.4,0,.7-.4.9l-3.3,1.9Zm-2.7-5.9,2.9,5,3.1-1.8v-7.1l-2.8,1.7-1.2.5Zm.7-4.1a9,9,0,0,0-.8,2.3l1.3-.6A8.4,8.4,0,0,0,128.4,157Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3644" data-name="XMLID 3644">
            <path
              id="XMLID_3648"
              data-name="XMLID 3648"
              class="cls-1"
              d="M129.9,166.7l-3.3-2a1.8,1.8,0,0,1-.6-1.4v-7.7c0-.5.2-.8.6-.6l3.3,2a2.1,2.1,0,0,1,.7,1.4v7.7C130.6,166.6,130.2,166.9,129.9,166.7Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3645"
              data-name="XMLID 3645"
              class="cls-3"
              d="M130.2,167.2h-.5l-3.2-2a2.1,2.1,0,0,1-.9-1.8v-7.7a1.3,1.3,0,0,1,.4-1c.4-.2.6-.1,1,0l3.2,2a2.3,2.3,0,0,1,.8,1.8v7.7a1.3,1.3,0,0,1-.4,1Zm-.2-.9h0c.2,0,.2,0,.2-.2v-7.7a1.6,1.6,0,0,0-.5-1.1l-3.2-2h-.1v7.9a1.6,1.6,0,0,0,.5,1.1Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
        <g id="XMLID_3641" data-name="XMLID 3641">
          <path
            id="XMLID_3642"
            data-name="XMLID 3642"
            class="cls-3"
            d="M132.1,154l-3.3,2,.5.7,3.3-2.1Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_3639" data-name="XMLID 3639">
          <path
            id="XMLID_3640"
            data-name="XMLID 3640"
            class="cls-1"
            d="M133.6,160.3l-2.9,1.8.4.6,2.9-1.8Z"
            transform="translate(0 0.1)"
          />
        </g>
      </g>
    </g>
    <g id="ProgrammerGirl">
      <g id="Boxes">
        <g id="XMLID_3447" data-name="XMLID 3447">
          <path
            id="XMLID_3451"
            data-name="XMLID 3451"
            class="cls-1"
            d="M258.3,122.3,246.4,129a1.9,1.9,0,0,1-1.8-.1l-3.4-1.9a.6.6,0,0,1-.3-.8l.3-.3,11.8-6.7a2.1,2.1,0,0,1,1.9.1l3.4,1.9a.6.6,0,0,1,.3.8Z"
            transform="translate(0 0.1)"
          />
          <path
            id="XMLID_3448"
            data-name="XMLID 3448"
            class="cls-2"
            d="M245.7,129.5a2.8,2.8,0,0,1-1.3-.3l-3.2-1.9a1,1,0,0,1-.5-1.3l.3-.4,11.9-6.8a2.7,2.7,0,0,1,2.3.1l3.2,1.9a1.1,1.1,0,0,1,.6.9,1.2,1.2,0,0,1-.4.8l-11.9,6.7A1.7,1.7,0,0,1,245.7,129.5Zm8.2-10.2h-.7l-12,6.8-.2.2.4.3,3.3,1.9a1.6,1.6,0,0,0,1.5.1l12-6.7c.1,0,.1-.1.1-.2s0-.2-.3-.3l-3.3-1.9a1.1,1.1,0,0,0-.8-.2Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_1256" data-name="XMLID 1256">
          <g id="XMLID_1234" data-name="XMLID 1234">
            <path
              id="XMLID_1238"
              data-name="XMLID 1238"
              class="cls-5"
              d="M252.8,98.2h0l-12.6,7.2A2.7,2.7,0,0,0,239,108v10.6a1.1,1.1,0,0,0,.5,1.2,1.3,1.3,0,0,0,1.2.1h.1l2.6-1.5h0l2.1-1.4,7.7-4.5a2.2,2.2,0,0,0,1-.9,5.7,5.7,0,0,0,.4-1.4V99.4a1.4,1.4,0,0,0-.6-1.2A1.3,1.3,0,0,0,252.8,98.2Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_108"
              data-name="Vector 108"
              class="cls-2"
              d="M249.6,103.7a.8.8,0,0,1,.2.7v1.4h0c0,.3.1.5.3.5l.8-.3v1l-.8.6a1.1,1.1,0,0,0-.3.8v1.5a2.9,2.9,0,0,1-.2.9l-.5.8-1,.7v-1c.3-.1.4-.3.6-.5a1.3,1.3,0,0,0,.1-.6v-1.4h0a1.8,1.8,0,0,1,1-1.6h0c-.6.2-.9,0-1-.5v-1.5c0-.2,0-.3-.1-.4l-.6.2v-1l1-.4Z"
              transform="translate(0 0.1)"
            />
            <path
              id="Vector_109"
              data-name="Vector 109"
              class="cls-2"
              d="M243.7,110.1a1.1,1.1,0,0,0,.3-.8h0v-1.5a1.7,1.7,0,0,1,.4-1.2,5.3,5.3,0,0,1,1.4-1.2v1a1,1,0,0,0-.6.5.7.7,0,0,0-.1.5v1.5a2.1,2.1,0,0,1-1,1.6h0c.3-.1.6-.2.7,0s.2.2.2.5h0v1.4c0,.2.1.4.2.4a.6.6,0,0,0,.5-.2v1a2.1,2.1,0,0,1-1.3.5c-.3-.1-.4-.4-.4-.8v-1.5c0-.3-.1-.5-.3-.5a1.1,1.1,0,0,0-.8.3v-1.1A1.2,1.2,0,0,0,243.7,110.1Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
        <g id="XMLID_3448_2" data-name="XMLID 3448 2">
          <g id="XMLID_1234_2" data-name="XMLID 1234 2">
            <path
              id="XMLID_1238_2"
              data-name="XMLID 1238 2"
              class="cls-5"
              d="M258,79.7h-.1l-9.6,5.5a2.2,2.2,0,0,0-1,2v8.2a1.2,1.2,0,0,0,.5,1,1.1,1.1,0,0,0,1.1,0h0l2-1.2h0l1.6-1,5.9-3.5c.4-.1.6-.4.8-.8a2,2,0,0,0,.3-1.1v-8a.9.9,0,0,0-.5-1A.9.9,0,0,0,258,79.7Z"
              transform="translate(0 0.1)"
            />
            <g id="Group_17" data-name="Group 17">
              <path
                id="Vector_110"
                data-name="Vector 110"
                class="cls-2"
                d="M258.1,85.9l-3,3.2v-.8l2.1-2.2h-2.1v-.7h3Z"
                transform="translate(0 0.1)"
              />
              <path
                id="Vector_111"
                data-name="Vector 111"
                class="cls-2"
                d="M254.8,90l-.8.5-1.7-4.1.9-.5Z"
                transform="translate(0 0.1)"
              />
              <path
                id="Vector_112"
                data-name="Vector 112"
                class="cls-2"
                d="M252.1,87.2V88L250,90.3l2.1-.2V91l-3.1.2v-.6Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
        </g>
      </g>
      <path
        id="Shadow-3"
        class="cls-3"
        d="M257.4,161.1h-.8l-13,7.5v.5Zm2.2.2h-.8L243.7,170a.8.8,0,0,0,.2.5Zm1.8.4-.6-.2L244.2,171c.2.1.2.3.4.4Zm1.6.5-.6-.2-17.5,10.1.5.4Zm1.6.6-.7-.2-18,10.4.5.3Zm.8.5h0l-18.2,10.5.5.2,18.2-10.5Zm1.5,1.1-.3-.3-18,10.4.6.2Zm.9.9-.2-.4L250,175l.7.2Zm.9,1-.4-.4-16.6,9.5h.7Zm.3,1.2c0-.2-.1-.3-.1-.5l-15.2,8.7h.9Zm.2.9L256,175.9h1l12.2-7Zm-.5,2.3c.1-.2.1-.5.2-.8l-10.1,5.9,1.2-.2Zm-1.4,1.7-4.4,2.5,2.5-1.1a13.3,13.3,0,0,0,1.9-1.4Zm-15.9-10.8-2,.6-4,2.3-1,1.2Zm2.3-.4-10,5.7a1.7,1.7,0,0,1-.1.7l11.3-6.5Z"
        transform="translate(0 0.1)"
      />
      <path
        id="Shadows2"
        class="cls-3"
        d="M300.9,184.8l-.3-.2,10.7-6.2-.5-.2L297.3,186l.4.2-10.8,6.2.5.2Zm-12.1,8.6,13.5-7.8-.5-.2,10.8-6.2-.6-.3-13.4,7.9.3.2-10.6,6.2Zm14.9-7-.4-.2,10.4-6c0-.2-.1-.3-.4-.4l-13.5,7.8.5.2L289.6,194l.4.3Zm1.3.8-.4-.3L291,194.8l.4.2Zm1.3.8-.5-.3-13.5,7.8.5.3Zm1.4.8-.4-.3-13.6,7.8.5.3Zm1.3.8-.4-.3L295,197.1l.6.3Zm1.2.9c0-.2-.2-.3-.4-.4l-13.5,7.8.6.2Zm-11.9-7.3-.5-.2,10.8-6.2-.6-.3-13.4,7.8.3.2-10.3,6c.1.2.1.3.2.4ZM286,191.9l13.6-7.9-.4-.2,10.6-6.2-.5-.2-13.5,7.8.5.2-10.7,6.2Zm14.6-14.1a1.3,1.3,0,0,0,.1-.6l-15.8,9h.8l6.1-3.5.5.3,13.5-7.8-.5-.3Zm6.1-2-13.5,7.8.5.3,13.5-7.8Zm-6.5.6-.5-.2-16.1,9.3.4.3,6.4-3.8.5.3,13.5-7.8-.5-.3Zm-12.4-7a2,2,0,0,0-1.1.1l-5.4,3.1-4,2.5h-.1l-13.5,7.8.5.3Zm-22.9,14.2.5.3,23.9-13.8-.5-.3Zm25.8-12.7-.4-.3-24,13.8.5.3Zm1.3.8-.4-.3-23.9,13.8.5.3Zm1.3.7-.5-.2L268.9,186l.5.2Zm1.5.8-.5-.2-24,13.8.5.2Zm1.2.8-.4-.2-23.9,13.8.5.2Zm-8,6.3c.2.1.2.3.3.4l13.5-7.8-.5-.2-3.9,2.2-.5-.3L273,188.4l.6.2Zm4.3-.9-3.1,1.8.5.3,13.5-7.8-.5-.3-3.9,2.2-.5-.3-16.7,9.6h.8Zm-17.5-5.7-.5-.2-13.1,7.6c0,.2.1.3.1.4Zm1.5.8-.5-.3L262.3,182l.5.3Z"
        transform="translate(0 0.1)"
      />
      <g id="Girl_Elements" data-name="Girl Elements">
        <g id="Leg">
          <g id="XMLID_3379" data-name="XMLID 3379">
            <path
              id="XMLID_3383"
              data-name="XMLID 3383"
              class="cls-1"
              d="M262.8,167.4l-2.9.7-3.1-1.2.5-.7,1-.3s1.3-.2,1.5-.9,2,0,2,0l1.4,1.1Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3380"
              data-name="XMLID 3380"
              class="cls-3"
              d="M259.9,168.5l-3.6-1.4.6-1.3,1.3-.4c.4-.1,1.1-.3,1.1-.6l.5-.5c.5-.3,1.9.1,2.1.2h.1l1.6,1.3-.4,1.9Zm-2.5-1.8,2.6,1,2.6-.6.2-.8-1-.9a2.6,2.6,0,0,0-1.5-.2c-.3.8-1.5,1.1-1.9,1.1l-.7.3Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3373" data-name="XMLID 3373">
            <path
              id="XMLID_3378"
              data-name="XMLID 3378"
              class="cls-2"
              d="M273,151s-5.8-1.9-7.4-3.3c0,0,1,2.1-.2,5.6s-1.4,9.1-1.7,11.4a1.3,1.3,0,0,1-1.1,1.1h-.5c-.6,0-1.9-.5-1.9-1.2-.1-4.7-.5-20.6.6-22.1s5.5-3.4,7.6-3l8.3,1.4Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3374"
              data-name="XMLID 3374"
              class="cls-3"
              d="M261.9,166.2a2.8,2.8,0,0,1-1.7-.7,1.1,1.1,0,0,1-.5-.9c-.2-7.7-.4-20.9.6-22.3s5.9-3.6,8-3.2l8.4,1.4h.5l-3.9,11h-.5c-2.2-.8-4.4-1.7-6.5-2.7a7.6,7.6,0,0,1-.5,4.7,69.1,69.1,0,0,0-1.5,9.1,8.5,8.5,0,0,1-.3,2.3,1.4,1.4,0,0,1-1.4,1.4H262A.1.1,0,0,0,261.9,166.2Zm5.7-26.3c-2.2,0-5.6,1.4-6.7,2.9s-.7,9.4-.5,21.8l.3.3a2.6,2.6,0,0,0,1.2.5h.5a.8.8,0,0,0,.8-.7c.1-.5.1-1.3.2-2.2.4-3,.8-7.2,1.5-9.3a12.2,12.2,0,0,0,.3-5.2l-.9-1.9,1.5,1.3c1.4,1.1,5.5,2.6,7,3.1l3.2-9.2-7.7-1.3Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3368" data-name="XMLID 3368">
            <path
              id="XMLID_3372"
              data-name="XMLID 3372"
              class="cls-3"
              d="M256.3,166.2a1.8,1.8,0,0,1,2-.4h-.1c-.4.3,0,.8.6,1.1a2.5,2.5,0,0,0,3.5-.6v-.4l.9-.9a.5.5,0,0,1,.8.1h.1a4.1,4.1,0,0,1-.2,2.9l-.2,2.3a.6.6,0,0,1-.1.4h-.8l-.7-.2a.3.3,0,0,1-.3-.3v-.9c0-.2-.1-.3-.2-.2l-.4.2a1.7,1.7,0,0,1-1,.3,2,2,0,0,1-1.1-.2C257.7,168.5,255.7,167.3,256.3,166.2Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3369"
              data-name="XMLID 3369"
              class="cls-3"
              d="M263.3,171.2h-.5l-.9-.2a.7.7,0,0,1-.3-.6v-.8h-.2a1.5,1.5,0,0,1-1.1.4l-1.3-.2c-2-1-2.8-1.8-3.2-2.6a1.2,1.2,0,0,1,.1-1c.4-.5.9-.9,2.4-.5l.6.2-.6.4h0c0,.1,0,.3.5.6a2.5,2.5,0,0,0,3.1-.5h.1V166h.2l.8-.9a.8.8,0,0,1,.8-.2c.2.1.5.2.5.5a4.2,4.2,0,0,1,0,3.1l-.3,2.2a1.4,1.4,0,0,1-.2.6h-.5Zm-1.5-2.5h.2c.3.1.3.3.3.5v1.2l.6.2h.5v-.2l.4-2.3a4.2,4.2,0,0,0,.1-2.7h-.2l-.8.8v.5a3.1,3.1,0,0,1-4,.7c-.4-.2-.9-.5-1-1v-.2c-.4,0-.9,0-1.1.3a.8.8,0,0,0-.2.5c.3.6,1.2,1.3,2.9,2.2l.9.2c.2,0,.6-.1.7-.3l.4-.2Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3366" data-name="XMLID 3366">
            <path
              id="XMLID_3367"
              data-name="XMLID 3367"
              class="cls-1"
              d="M261.6,167.4l-.2,1.3h.7l.2-1.3Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
        <g id="SittingBox">
          <g id="XMLID_3360" data-name="XMLID 3360">
            <path
              id="XMLID_3364"
              data-name="XMLID 3364"
              class="cls-1"
              d="M294.9,169.1V148.9h-.1l-9.5.9-1-5.3h0l-19.9,11.3h-.1l-1.6-.5h-.1v20.2a.8.8,0,0,0,.4.7l8.9,5.2a2.5,2.5,0,0,0,2.4,0l20-11.4A1,1,0,0,0,294.9,169.1Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3361"
              data-name="XMLID 3361"
              class="cls-3"
              d="M273.3,182.1a2.3,2.3,0,0,1-1.4-.4l-8.9-5.2a1.8,1.8,0,0,1-.7-1V155.3c0-.2.1-.3.3-.4h.3l1.5.4,19.8-11.2h.6l.9,5.1,9.2-.8h.1c.2,0,.4.3.4.5v20.3a1.3,1.3,0,0,1-.6,1.1l-20,11.4A2.8,2.8,0,0,1,273.3,182.1Zm-10.1-26.3v19.7l.2.4,8.9,5.2a1.8,1.8,0,0,0,2,0l20-11.4c.3-.1.4-.3.4-.4h0V149.4l-9.4.8h-.4l-.7-4.9-19.5,11.1h-.3Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3355" data-name="XMLID 3355">
            <path
              id="XMLID_3359"
              data-name="XMLID 3359"
              class="cls-3"
              d="M294.9,148.8l-9.6.9-12,9.5v22.5a3.1,3.1,0,0,0,1.3-.3l20-11.4a1.2,1.2,0,0,0,.4-.8c-.1-.1-.1-20-.1-20.4Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3356"
              data-name="XMLID 3356"
              class="cls-3"
              d="M273.3,182.1h-.5V159l12.5-9.8h.1l9.5-.9h.1c.2,0,.4.3.4.5v20.3a1.1,1.1,0,0,1-.6,1.1l-20,11.4A2.7,2.7,0,0,1,273.3,182.1Zm.4-22.7v21.8l.6-.2,20-11.4c.3-.1.4-.3.4-.4V149.3l-9.1.8Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3350" data-name="XMLID 3350">
            <path
              id="XMLID_3354"
              data-name="XMLID 3354"
              class="cls-3"
              d="M264,156.4l.3-.8-1.5-.4h-.1v20.2c-.1.3.2.6.5.7h0l.8.5V156.4Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3351"
              data-name="XMLID 3351"
              class="cls-3"
              d="M264.6,177.4l-1.6-.9a1.8,1.8,0,0,1-.7-1V155.3c0-.2.1-.3.3-.4h.3l2,.6v.4a2,2,0,0,1-.4.8Zm-1.4-21.7v19.7l.2.4.4.2V156.4h0V156Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3345" data-name="XMLID 3345">
            <path
              id="XMLID_3349"
              data-name="XMLID 3349"
              class="cls-2"
              d="M272.2,161.1l-8.9-5.2a1,1,0,0,1-.4-1.2l.4-.4,20-11.4a2.6,2.6,0,0,1,2.4,0l8.9,5.2a1,1,0,0,1,.4,1.2l-.4.4-20,11.4A2.1,2.1,0,0,1,272.2,161.1Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3346"
              data-name="XMLID 3346"
              class="cls-3"
              d="M273.3,161.9a2.3,2.3,0,0,1-1.4-.4l-8.9-5.2a1.5,1.5,0,0,1-.7-1.2,1.9,1.9,0,0,1,.7-1.2l20-11.4a2.8,2.8,0,0,1,2.8,0l9,5.2a1.5,1.5,0,0,1,0,2.4l-20,11.4A4.2,4.2,0,0,1,273.3,161.9ZM284.4,143l-1,.3-20,11.4a.7.7,0,0,0,0,1l8.9,5.2a2.3,2.3,0,0,0,2,0l20-11.4.3-.5a.5.5,0,0,0-.3-.5l-9-5.2A1.6,1.6,0,0,0,284.4,143Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
        <g id="FrontArm">
          <g id="XMLID_3338" data-name="XMLID 3338">
            <path
              id="XMLID_3342"
              data-name="XMLID 3342"
              class="cls-6"
              d="M258.9,123.8l-1.6-1.1a3.1,3.1,0,0,0-2.1-.5,2.5,2.5,0,0,0-2.2,1.2v.4l1.8.6v.3l-.5.3s.5,1.8,3.6,1.3S258.9,123.8,258.9,123.8Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3339"
              data-name="XMLID 3339"
              class="cls-3"
              d="M256.8,126.7c-2.4,0-2.9-1.6-2.9-1.7l-.2-.3h.2l-1.2-.5v-.9a2.9,2.9,0,0,1,2.5-1.4,5,5,0,0,1,2.4.6l1.7,1.2a1.9,1.9,0,0,1,.5,1.9c-.2.6-1,1-2,1.1Zm-1.9-1.7c.3.4,1,1,2.9.7s1-.2,1.2-.6-.1-.8-.2-1l-1.5-1.1a3.2,3.2,0,0,0-1.9-.5,2,2,0,0,0-1.7.9l1.7.5.2.8Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3333" data-name="XMLID 3333">
            <path
              id="XMLID_3337"
              data-name="XMLID 3337"
              class="cls-3"
              d="M260.7,124.4l-1-.6h-.5a4.6,4.6,0,0,0-1.3,1.8.4.4,0,0,0,.1.5h.2l1.1.5c.1.1.4,0,.5-.2l.9-1.5C260.9,124.9,260.8,124.5,260.7,124.4Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3334"
              data-name="XMLID 3334"
              class="cls-3"
              d="M259.6,127.2h-.4l-1.2-.5a.8.8,0,0,1-.4-1.1,8.2,8.2,0,0,1,1.2-2c.4-.2.6-.3,1-.1l1,.6c.2.1.5.3.5.6a1.7,1.7,0,0,1-.1.7l-.9,1.5Zm-.2-3a9.1,9.1,0,0,0-1.1,1.6h0l1.1.5.9-1.5h0Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3328" data-name="XMLID 3328">
            <path
              id="XMLID_3332"
              data-name="XMLID 3332"
              class="cls-6"
              d="M272,123.3h0l-2.2,5.5a42.5,42.5,0,0,0-4.9-2.1,15.8,15.8,0,0,1-3.6-2h-.1a2.3,2.3,0,0,0-1.6,2.1v.2c.6.7,7.1,6.5,12,7.6a16.6,16.6,0,0,0,4.1-7.3C277,122.4,272.6,121.5,272,123.3Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3329"
              data-name="XMLID 3329"
              class="cls-3"
              d="M271.7,134.9h-.3c-4.8-1.1-11.5-7-12.1-7.7a.5.5,0,0,1-.3-.5,2.9,2.9,0,0,1,1.9-2.5.4.4,0,0,1,.5.1,25.3,25.3,0,0,0,3.6,2l4.7,1.9c.3-.9,1.1-3,2-5h.1c0-.2,0-.3.1-.4a2.3,2.3,0,0,1,2.4-.5c1.5.5,2.7,2.3,1.9,5.2a17.4,17.4,0,0,1-4.4,7.5Zm-11.9-8.3c1,.9,7,6.2,11.5,7.4a18.4,18.4,0,0,0,4-6.9c.6-2.5-.4-3.8-1.5-4.1a1.2,1.2,0,0,0-1.4.3v.4l-2.1,5.2-.3.4-.3-.2a42.5,42.5,0,0,0-4.9-2.1,13.8,13.8,0,0,1-3.8-2A2.2,2.2,0,0,0,259.8,126.6Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
        <g id="FrontLeg">
          <g id="XMLID_3322" data-name="XMLID 3322">
            <path
              id="XMLID_3326"
              data-name="XMLID 3326"
              class="cls-1"
              d="M250.4,164.8a2.4,2.4,0,0,1-1.8.9,2.4,2.4,0,0,0-1.9,1l1.5,1.9h3.2l1.6-1.2.6-2-1.9-.9Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3323"
              data-name="XMLID 3323"
              class="cls-3"
              d="M248.2,168.9l-2-2.3.2-.3a2.7,2.7,0,0,1,2.2-1.2,2.9,2.9,0,0,0,1.6-.7h0l1.5-.6,2.3,1.1-.6,2.5-1.8,1.4Zm-.8-2.3,1.2,1.5h2.6l1.5-1,.2-1.5-1.3-.6-.9.4a3.9,3.9,0,0,1-2.3.9,1,1,0,0,0-1,.3Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3317" data-name="XMLID 3317">
            <path
              id="XMLID_3321"
              data-name="XMLID 3321"
              class="cls-2"
              d="M282.9,149.7s-7.3,12.6-25.9-1.5c-.1-.1-.2,0-.2.1a7.8,7.8,0,0,1-.4,5.8c-1.2,2.6-2.2,8.4-2.7,10.6a1.4,1.4,0,0,1-1.1,1H252a1.5,1.5,0,0,1-1.4-1.3c.1-4.7.8-20.6,2-21.9s5.8-1.9,8-1.4l13.8,3.9Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3318"
              data-name="XMLID 3318"
              class="cls-3"
              d="M252,166.1a2.1,2.1,0,0,1-1.4-.7.8.8,0,0,1-.4-1.1v-.2c.5-14.2,1.2-20.9,2-21.9s6.2-2.1,8.5-1.5l13.9,3.9h.1l8.7,4.9v.4a11.8,11.8,0,0,1-7.9,5.1c-5.1,1-11.2-1-18.1-6a8.4,8.4,0,0,1-.5,5.2c-1.1,2.4-2.1,7.5-2.6,10l-.2.5a1.5,1.5,0,0,1-1.4,1.3Zm5.6-24.9c-1.9,0-3.7.4-4.7,1.6s-1.2,4.7-2,21.4v.2c0,.2.1.3.3.5a1.2,1.2,0,0,0,.8.4h.6a.6.6,0,0,0,.6-.6h0l.2-.5c.5-2.5,1.5-7.7,2.6-10.2a7.5,7.5,0,0,0,.3-5.5c0-.3,0-.5.3-.6h.6c6.8,5.2,12.8,7.3,18.1,6.3a11.2,11.2,0,0,0,7-4.4l-8-4.5-14-3.8Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3312" data-name="XMLID 3312">
            <path
              id="XMLID_3316"
              data-name="XMLID 3316"
              class="cls-3"
              d="M245.9,166.8c.3-1.1,1.3-1.3,2.7-1.1a1.5,1.5,0,0,0-.9.6c-.5.4,0,.8.7,1.1a3.1,3.1,0,0,0,3.8-1l.2-.2.2-.3h.1l.7-1a.8.8,0,0,1,1,.1h0a3.9,3.9,0,0,1,0,3v2.4c0,.2,0,.3-.2.4h-.3c-.2.1-.5,0-1-.1s-.2-.2-.3-.3l-.2-1.2c0-.1,0-.2-.2-.1l-.2.2c-.1.2-.4.3-.6.5a2.5,2.5,0,0,1-1.7,0C247.9,169.3,245.6,168.3,245.9,166.8Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3313"
              data-name="XMLID 3313"
              class="cls-3"
              d="M253.7,171.3h-1a.6.6,0,0,1-.5-.6v-.9l-.8.4a2.7,2.7,0,0,1-2,.1c-1.2-.5-4.5-1.6-4-3.5s2.5-1.5,3-1.4l1.6.2-1.6.5-.7.5h0c0,.1.2.3.7.5a2.8,2.8,0,0,0,3.3-.8h0l.2-.2v-.3h.4l-.4-.2.9-1c.1-.2.5-.3.8-.3s.6.2.7.5a4.4,4.4,0,0,1,0,3.2v2.4c0,.2,0,.5-.2.6l-.5.2C253.9,171.3,253.9,171.3,253.7,171.3Zm-1.3-2.4h.2c.1.1.3.2.3.4v1.2H254l.2-.2v-2.5a5.4,5.4,0,0,0-.2-2.8v-.2h-.2c-.3.4-.7.7-.8,1l-.3.4-.2.2a3.2,3.2,0,0,1-4,1.1,1.7,1.7,0,0,1-1.2-1,.8.8,0,0,1,.2-.7h.2a1.4,1.4,0,0,0-1.4.9c-.3,1.2,2,2.2,3.7,2.8a2,2,0,0,0,1.5,0l.5-.4.3-.2Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3310" data-name="XMLID 3310">
            <path
              id="XMLID_3311"
              data-name="XMLID 3311"
              class="cls-1"
              d="M252.9,167.2h-.7v1.6h.7Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3308" data-name="XMLID 3308">
            <path
              id="XMLID_3309"
              data-name="XMLID 3309"
              class="cls-3"
              d="M256.4,148.4a3.8,3.8,0,0,0-.8-1.7l.4-.7a5,5,0,0,1,1.3,2.2l-.9.2Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
        <g id="Body-2">
          <g id="XMLID_3302" data-name="XMLID 3302">
            <path
              id="XMLID_3306"
              data-name="XMLID 3306"
              class="cls-3"
              d="M283.9,129.2s1.7,10.2,2.4,15.7-6.3,8.5-10.9,9-9.4-1.9-10.8-4.3a9.2,9.2,0,0,0-3.8-3.5s6-4.1,7.5-14.6,7.5-12.2,8-12.1S283.9,129.2,283.9,129.2Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3303"
              data-name="XMLID 3303"
              class="cls-3"
              d="M274,154.5c-4.2,0-8.4-2.3-9.8-4.6a11.4,11.4,0,0,0-3.5-3.4l-.7-.3.7-.4c.1,0,5.6-4.1,7.3-14.3s8.3-12.5,8.3-12.5.5,0,8,9.9h.1s1.6,10.2,2.4,15.7a5.8,5.8,0,0,1-1.1,4.6c-2.1,2.8-6.7,4.5-10.1,4.9A4.2,4.2,0,0,1,274,154.5Zm-12.3-8.4a12.6,12.6,0,0,1,3.2,3.3c1.4,2.1,5.9,4.7,10.5,4.1s7.6-2,9.5-4.6a5.2,5.2,0,0,0,1.1-4c-.7-5.2-2.2-14.5-2.3-15.6-2.5-3.4-6.7-8.6-7.4-9.5s-5.9,2.2-7.4,11.8-5.9,13.3-7.2,14.5Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3300" data-name="XMLID 3300">
            <path
              id="XMLID_3301"
              data-name="XMLID 3301"
              class="cls-1"
              d="M263,147l-.3-.5c4.6-3.1,6.9-10.3,7-10.4l.6.2C270.2,136.6,267.8,143.8,263,147Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
        <g id="Hand-2">
          <g id="XMLID_3280" data-name="XMLID 3280">
            <g id="XMLID_3283" data-name="XMLID 3283">
              <g id="XMLID_3284" data-name="XMLID 3284">
                <path
                  id="XMLID_3288"
                  data-name="XMLID 3288"
                  class="cls-6"
                  d="M271.4,124.7a1.2,1.2,0,0,0-1.4-.6l-.7.4-2.6,3.3c-1.7,2.5-5.1,7-5.1,7l-4.3-3.6a24.2,24.2,0,0,1-3.3-3.1h-.1a2,2,0,0,0-2,1.6v.2c.5.8,5,8.1,9.4,10.9a.9.9,0,0,0,1-.1,41.5,41.5,0,0,0,7.6-8.6C272.6,127.6,272,125.7,271.4,124.7Z"
                  transform="translate(0 0.1)"
                />
                <path
                  id="XMLID_3285"
                  data-name="XMLID 3285"
                  class="cls-3"
                  d="M261.8,141.2l-.6-.2c-4.4-2.8-9.2-10.2-9.6-11a.8.8,0,0,1-.2-.5,2.6,2.6,0,0,1,2.5-1.9c.3,0,.5.1.5.2a13,13,0,0,0,3.2,3l4,3.3c.8-1.1,3.4-4.6,4.7-6.6a21.6,21.6,0,0,1,2.7-3.3l.9-.5a2,2,0,0,1,1.9.8c1,1.7.5,4.2-1.5,7.6s-6.5,7.6-7.7,8.7A1.2,1.2,0,0,1,261.8,141.2Zm-9.6-11.6c.7,1.1,5.1,8,9.4,10.7h.3a44.5,44.5,0,0,0,7.7-8.5c1.7-3.1,2.2-5.4,1.4-6.8l.3-.2-.4.2a1,1,0,0,0-1-.4l-.5.3a15.9,15.9,0,0,0-2.6,3.2c-1.5,2.5-5,7-5,7.1l-.4.4-.2-.3s-2.5-2.2-4.4-3.6a15.2,15.2,0,0,1-3.1-3.1C253.4,128.4,252.6,128.6,252.2,129.6Z"
                  transform="translate(0 0.1)"
                />
                <path
                  id="XMLID_3298"
                  data-name="XMLID 3298"
                  class="cls-7"
                  d="M253.8,128.9l.2-.2v-.3l-.5.2.5-.2h0v-.2c-.1-.1-.1-.3-.2-.5a2.7,2.7,0,0,0-.9-1.2l-.6-.3h-.5l-.4.3-1-.6h-.5l-.6.3h0a2,2,0,0,0-.4.8,3.2,3.2,0,0,0,.3,1.4,3,3,0,0,0,1.8,1.7l.9.4h.7l.2-.2Z"
                  transform="translate(0 0.1)"
                />
                <path
                  id="Vector_10"
                  data-name="Vector 10"
                  class="cls-8"
                  d="M254.4,129.5l-.9-.9c-.8-.6-1.8,1.2-1.2,1.5a2.8,2.8,0,0,1,.9,1Z"
                  transform="translate(0 0.1)"
                />
              </g>
            </g>
            <g id="XMLID_3281" data-name="XMLID 3281">
              <path
                id="XMLID_3282"
                data-name="XMLID 3282"
                class="cls-3"
                d="M261,136.8a5,5,0,0,1,.2-2.1l.7.2a10.9,10.9,0,0,0-.1,1.8Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
        </g>
        <g id="Hair">
          <g id="XMLID_3274" data-name="XMLID 3274">
            <path
              id="XMLID_3278"
              data-name="XMLID 3278"
              class="cls-1"
              d="M272.3,118.1s.7,2.5,0,3.7,2.5.9,2.5.9l3-2.2a7.1,7.1,0,0,1-.9-2.8c.1-1.3.3-1.4-.1-1.3Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3275"
              data-name="XMLID 3275"
              class="cls-3"
              d="M273.9,123.1c-.6,0-1.6-.1-1.9-.6a.8.8,0,0,1,0-.9c.6-.9.2-2.7-.1-3.4v-.4h.5L277,116c.1,0,.4-.1.5.1a1.5,1.5,0,0,1,.3.8,2.8,2.8,0,0,1-.1.9,4.8,4.8,0,0,0,.7,2.6l.3.3-3.6,2.5h-1.2Zm-1.1-4.8c.1.8.5,2.6,0,3.7h0c0,.2,1,.2,1.9.2l2.6-2a6.3,6.3,0,0,1-.6-2.7,2.2,2.2,0,0,1,.1-.8Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3269" data-name="XMLID 3269">
            <path
              id="XMLID_3273"
              data-name="XMLID 3273"
              class="cls-2"
              d="M272.6,105.8s-3.8-.2-5.2,3.1a5.9,5.9,0,0,0,1.4,5.8s3.2-1,3.8-2.5S272.6,105.8,272.6,105.8Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3270"
              data-name="XMLID 3270"
              class="cls-3"
              d="M268.6,115.2l-.3-.2a6.8,6.8,0,0,1-1.4-6.3c1.4-3.5,5.5-3.4,5.5-3.4h.4v.4c0,.2.6,5,0,6.6s-3.6,2.7-4,2.8Zm3.6-9a4.8,4.8,0,0,0-3.4,8.1c1-.3,3-1.2,3.4-2.2S272.3,107.7,272.2,106.2Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3264" data-name="XMLID 3264">
            <path
              id="XMLID_3268"
              data-name="XMLID 3268"
              class="cls-6"
              d="M274.8,106.2s2.6-2.2,3.6,3.3c.8,3.9-.7,6.2-3.6,8.4a3.3,3.3,0,0,1-2.9.5,3.9,3.9,0,0,1-2.3-2.8,12.8,12.8,0,0,1-.4-6.7c-.5-2.3,1-2,3.6-2.7Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3265"
              data-name="XMLID 3265"
              class="cls-3"
              d="M272.8,119.1l-1-.2a4.3,4.3,0,0,1-2.6-3.1,12.1,12.1,0,0,1-.4-6.8,2.5,2.5,0,0,1,0-1.7,3.5,3.5,0,0,1,2.4-1l1.6-.4h1.9a1.8,1.8,0,0,1,2-.3c1.1.4,1.7,1.7,2.2,4a9.2,9.2,0,0,1-3.7,8.8A5.1,5.1,0,0,1,272.8,119.1Zm0-12.4-1.5.4c-1,.2-1.6.3-1.9.7a2.4,2.4,0,0,0,0,1.2h0a13.9,13.9,0,0,0,.4,6.4,4,4,0,0,0,2.1,2.5,2.3,2.3,0,0,0,2.4-.5c2.6-2,4.3-4.2,3.5-8s-1.1-3.2-1.6-3.4a1.7,1.7,0,0,0-1.4.3h-2Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3259" data-name="XMLID 3259">
            <path
              id="XMLID_3260"
              data-name="XMLID 3260"
              class="cls-3"
              d="M272.8,125a2.9,2.9,0,0,1-2.6-1.6,1.1,1.1,0,0,1,.2-1.4h.3a3.2,3.2,0,0,1,1.9-.3,5.4,5.4,0,0,0,2.8-.5c1-.6,1-1.2.9-1.4a1,1,0,0,1,.5-1.1,1.7,1.7,0,0,1,1-.3,1.3,1.3,0,0,1,1.2.8,2.4,2.4,0,0,1,.3,2,7.3,7.3,0,0,1-3.5,3.2,11.1,11.1,0,0,1-2.6.7C272.9,124.9,272.8,125,272.8,125Zm-.5-2.6h-1.4c-.1.1-.1.2-.1.4a2.4,2.4,0,0,0,2,1.1l2.6-.6a5.5,5.5,0,0,0,2.9-2.7,2.4,2.4,0,0,0,0-1.2l-.6-.4c-.3,0-.4,0-.4.1v.3a2.6,2.6,0,0,1-1.4,2.3,5.9,5.9,0,0,1-3.2.6Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3184" data-name="XMLID 3184">
            <g id="XMLID_3185" data-name="XMLID 3185">
              <path
                id="XMLID_3189"
                data-name="XMLID 3189"
                class="cls-2"
                d="M273.8,104c-2.1.3-4.6,2-5,3.4s-.4,2.7,1.5,2.5,1.3,1.8,1.5,2.5a1.1,1.1,0,0,0,1,.6c.5-.1,1.2.7,1.4,1.5a2.3,2.3,0,0,1-.6,1.8c1.2,2.8-4.4,5.9,1.1,8.1.1.1-3.9,5.5,1.2,8.5s12.9,1.6,14.9-3.3c3.2-8.5-8.5-10.1-9-17.4C281.3,106.7,277.2,103.6,273.8,104Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_3186"
                data-name="XMLID 3186"
                class="cls-3"
                d="M281.7,134.8a11,11,0,0,1-5.9-1.4c-2.1-1.3-4.2-3.8-1.8-8.7a4.5,4.5,0,0,1-2.2-1.9c-.4-1.1.1-2.2.6-3.3s1-2,.6-2.9v-.3l.4-.2a2.3,2.3,0,0,0,.4-1.4,1.9,1.9,0,0,0-.5-1l-.4-.2a1.6,1.6,0,0,1-1.5-.9v-.4c-.5-1.5-.9-1.9-1-1.9a1.9,1.9,0,0,1-1.9-.5c-.4-.5-.4-1.3-.1-2.6s3.1-3.4,5.5-3.7a7,7,0,0,1,5,1.6,10.6,10.6,0,0,1,3.5,7.2c.1,3,2.5,5,4.6,7s6.1,5.5,4.1,10.5a7.5,7.5,0,0,1-4.7,4.2A12.6,12.6,0,0,1,281.7,134.8ZM274,116.6a4.9,4.9,0,0,1-.7,3.3c-.5,1-.9,1.9-.5,2.6a3.7,3.7,0,0,0,2,1.6h.2l.2.2c.1.2,0,.3-.3.7-1.9,3.5-1.3,6,1.4,7.6a12.1,12.1,0,0,0,9.7.6,6.6,6.6,0,0,0,4.3-3.7c1.9-4.5-1-7-3.9-9.6s-4.7-4.2-5-7.6a8.8,8.8,0,0,0-3.1-6.6,6.1,6.1,0,0,0-4.5-1.3c-1.9.2-4.2,1.8-4.6,3.1s-.3,1.6-.2,1.8a1.3,1.3,0,0,0,1.2.2c.8-.1,1.5,1.4,1.8,2.4l.2.3a.7.7,0,0,0,.6.4,1.8,1.8,0,0,1,1,.4,2.6,2.6,0,0,1,.9,1.6,4.8,4.8,0,0,1-.7,2Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
          <g id="XMLID_3182" data-name="XMLID 3182">
            <path
              id="XMLID_3183"
              data-name="XMLID 3183"
              class="cls-3"
              d="M269.8,110a3.2,3.2,0,0,1,1.6-3.7l.4.8c-.1,0-1.5.7-1.2,2.8Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3180" data-name="XMLID 3180">
            <path
              id="XMLID_3181"
              data-name="XMLID 3181"
              class="cls-3"
              d="M275,124.7l-.7-.3a5.6,5.6,0,0,1,1.3-2.4l.6.6A7.2,7.2,0,0,0,275,124.7Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3178" data-name="XMLID 3178">
            <path
              id="XMLID_3179"
              data-name="XMLID 3179"
              class="cls-3"
              d="M279.4,112.2a7.4,7.4,0,0,0-1.7-4.3l.6-.6a7.7,7.7,0,0,1,2,4.8Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3176" data-name="XMLID 3176">
            <path
              id="XMLID_3177"
              data-name="XMLID 3177"
              class="cls-3"
              d="M286.3,131.6l-.5-.7a4.3,4.3,0,0,0,2.2-3.3h.8A4.8,4.8,0,0,1,286.3,131.6Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
      </g>
      <g id="Boxes-2">
        <g id="XMLID_3150" data-name="XMLID 3150">
          <g id="XMLID_3153" data-name="XMLID 3153">
            <g id="XMLID_3169" data-name="XMLID 3169">
              <path
                id="XMLID_3173"
                data-name="XMLID 3173"
                class="cls-1"
                d="M308.4,176.1V165.6h-.1l-9.5.9-1-5.3h0l-8.9,5.1h-.1l-1.6-.5H287v10.4a1.1,1.1,0,0,0,.6.7l8.8,5.2a2.6,2.6,0,0,0,2.4,0l9-5.2A.8.8,0,0,0,308.4,176.1Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_3170"
                data-name="XMLID 3170"
                class="cls-3"
                d="M297.8,182.8a2.8,2.8,0,0,1-1.5-.4l-8.9-5.2a1.1,1.1,0,0,1-.6-1V165.7c0-.2,0-.3.1-.4h.4l1.5.4,8.8-5h.7l.7,5.1,9.3-.8h.1c.2,0,.4.3.4.5V176a1.3,1.3,0,0,1-.6,1.1l-9,5.2A2.4,2.4,0,0,1,297.8,182.8Zm-10.1-16.5v10.3l9,5.2a1.8,1.8,0,0,0,2,0l9-5.2a.8.8,0,0,0,.2-.4h0V166.1l-9.2.8h-.5l-.7-4.9-8.6,4.9h-.1Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_3164" data-name="XMLID 3164">
              <path
                id="XMLID_3168"
                data-name="XMLID 3168"
                class="cls-3"
                d="M308.4,165.6l-9.6.9-1,3.3v12.7a2.7,2.7,0,0,0,1.2-.3l9-5.2c.3-.2.6-.5.6-.8S308.4,166,308.4,165.6Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_3165"
                data-name="XMLID 3165"
                class="cls-3"
                d="M297.8,182.8h-.5V169.5l1.3-3.7.2.2,9.5-.9h.1c.2,0,.4.3.4.5v10.5a1.1,1.1,0,0,1-.6,1.1l-9,5.2A2.3,2.3,0,0,1,297.8,182.8Zm.4-13V182l.6-.2,9-5.2.4-.4V166.1l-8.9.8Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_3159" data-name="XMLID 3159">
              <path
                id="XMLID_3163"
                data-name="XMLID 3163"
                class="cls-3"
                d="M288.6,166.9l.2-.8-1.5-.4h-.1v10.4c-.1.3.2.6.5.7h0l.9.5Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_3160"
                data-name="XMLID 3160"
                class="cls-3"
                d="M288.9,178.2l-1.5-.9a1.1,1.1,0,0,1-.6-1V165.8c0-.2,0-.3.1-.4h.4l2,.6v.4l-.4.8Zm-1.2-12v10.3l.4.2v-9.9a.6.6,0,0,0,.1-.4Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_3154" data-name="XMLID 3154">
              <path
                id="XMLID_3158"
                data-name="XMLID 3158"
                class="cls-2"
                d="M296.7,171.6l-8.9-5.2a1,1,0,0,1-.4-1.2l.4-.4,9-5.2a2.8,2.8,0,0,1,2.5,0l8.9,5.2a1,1,0,0,1,.4,1.2l-.4.4-9.2,5.2A2,2,0,0,1,296.7,171.6Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_3155"
                data-name="XMLID 3155"
                class="cls-3"
                d="M297.8,172.4a2.8,2.8,0,0,1-1.5-.4l-8.9-5.2a1.5,1.5,0,0,1,0-2.4l9.2-5.2a2.6,2.6,0,0,1,2.7,0l9,5.2a1.5,1.5,0,0,1,0,2.4l-9.1,5.2A2.3,2.3,0,0,1,297.8,172.4Zm.1-12.7-1,.3-9.1,5.2a.7.7,0,0,0,0,1l9,5.2a2.1,2.1,0,0,0,1.9,0l9.1-5.2a.7.7,0,0,0,0-1l-9-5.2A1.4,1.4,0,0,0,297.9,159.7Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
          <g id="XMLID_3151" data-name="XMLID 3151">
            <path
              id="XMLID_3152"
              data-name="XMLID 3152"
              class="cls-1"
              d="M287.3,167.4h-.7v6.3h.7Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
        <g id="XMLID_3130" data-name="XMLID 3130">
          <g id="XMLID_3134" data-name="XMLID 3134">
            <g id="XMLID_3145" data-name="XMLID 3145">
              <path
                id="XMLID_3149"
                data-name="XMLID 3149"
                class="cls-2"
                d="M302.7,156.8l-4.4-2.5h-.5l-5.1,3.2a.4.4,0,0,0-.1.3l5,5.4h0v1.7c0,.5,2-1,2.3-.7h.1l-2.6,1.6h.4l5.1-3.2s.3-.3.3-.5v-4.2A1.6,1.6,0,0,0,302.7,156.8Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_3146"
                data-name="XMLID 3146"
                class="cls-3"
                d="M297.8,166.5h0a.5.5,0,0,1-.5-.3v-.4l.5-.3c-.2,0-.3-.2-.3-.4v-1.6l-5-5.3a.8.8,0,0,1,.3-.9l5.1-3.2a.9.9,0,0,1,1,0l4.2,2.5a2,2,0,0,1,.9,1.7v4.1a2.4,2.4,0,0,1-.2.8h-.1l-5.3,3.2Zm-4.6-8.7,4.7,5.2a.4.4,0,0,1,.1.3v1.3l.6-.3c.7-.4,1.2-.6,1.7-.4h0l2.5-1.5v-4.3a1.1,1.1,0,0,0-.5-.9l-4.3-2.5Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_3140" data-name="XMLID 3140">
              <path
                id="XMLID_3144"
                data-name="XMLID 3144"
                class="cls-3"
                d="M294,162.4v.3l3.7,3.1c.1.2.2.2.5.1l5.1-3.2a.9.9,0,0,0,.1-.5v-3.8h-.1l-5.1,3.2Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_3141"
                data-name="XMLID 3141"
                class="cls-3"
                d="M297.8,166.4h-.1c-.3,0-.4-.1-.4-.3l-3.9-3.2.2-.9,4.2-.9,5-3.2h.6c.2,0,.4.3.4.5v3.8c0,.4-.4.7-.4.8h-.1l-5,3.2Zm-3.2-3.7,3.2,2.8,5-3.1v-3.5l-4.5,2.9h-.1Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_3135" data-name="XMLID 3135">
              <path
                id="XMLID_3139"
                data-name="XMLID 3139"
                class="cls-1"
                d="M297.3,166.1l-4.4-2.5a1.6,1.6,0,0,1-.6-1.3v-4.1c0-.5.3-.7.6-.5l4.4,2.5a1.6,1.6,0,0,1,.6,1.3v4.1C297.9,166.1,297.7,166.3,297.3,166.1Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_3136"
                data-name="XMLID 3136"
                class="cls-3"
                d="M297.6,166.6H297l-4.2-2.5a2.1,2.1,0,0,1-1-1.7v-4.1a1.1,1.1,0,0,1,.5-.9h.9l4.2,2.5a2,2,0,0,1,.9,1.7v4.1c0,.4-.1.8-.4.9Zm-.2-.9h0l.2-.2v-4.1a1,1,0,0,0-.6-.9l-4.2-2.5v4.3a1.1,1.1,0,0,0,.5.9Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
          <g id="XMLID_3131" data-name="XMLID 3131">
            <path
              id="XMLID_3133"
              data-name="XMLID 3133"
              class="cls-1"
              d="M302.8,160.6l-4.5,2.7.3.6,4.6-2.7Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
        <g id="XMLID_3112" data-name="XMLID 3112">
          <g id="XMLID_3117" data-name="XMLID 3117">
            <g id="XMLID_3124" data-name="XMLID 3124">
              <path
                id="XMLID_3129"
                data-name="XMLID 3129"
                class="cls-1"
                d="M294.6,147.3c-.3,0-.3.1-.3.3l.7,8.1c0,.5.6,1,1.4,1.2H298c.9-.2,1.4-.7,1.4-1.2l.9-8.1c0-.2-.1-.3-.4-.3Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_3126"
                data-name="XMLID 3126"
                class="cls-3"
                d="M297.3,157.4h-1c-1-.3-1.6-.9-1.6-1.6l-.9-8.1c0-.2,0-.4.2-.5l.6-.2H300l.6.2a.8.8,0,0,1,.2.5l-.9,8.1c0,.7-.6,1.3-1.6,1.6Zm-2.6-9.7.7,7.9c0,.3.4.6,1.2.8h1.3c.9-.2,1.1-.5,1.1-.8l.8-8h-5.1Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_3119" data-name="XMLID 3119">
              <path
                id="XMLID_3123"
                data-name="XMLID 3123"
                class="cls-1"
                d="M299.4,146c1.3.7,1.3,1.8,0,2.5a4.5,4.5,0,0,1-4.2,0c-1.3-.7-1.3-1.8,0-2.5A4.5,4.5,0,0,1,299.4,146Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_3120"
                data-name="XMLID 3120"
                class="cls-3"
                d="M297.3,149.5a5.4,5.4,0,0,1-2.5-.6,1.8,1.8,0,0,1-.8-2.4,2,2,0,0,1,.8-.8,5.1,5.1,0,0,1,4.8,0,1.7,1.7,0,0,1,1,2.2,1.4,1.4,0,0,1-1,1A4.6,4.6,0,0,1,297.3,149.5Zm0-3.6a4.6,4.6,0,0,0-2,.5,1.1,1.1,0,0,0-.6.9,1,1,0,0,0,.6.9,4.7,4.7,0,0,0,4,0,1.1,1.1,0,0,0,.6-.9,1,1,0,0,0-.6-.9A4.6,4.6,0,0,0,297.3,145.9Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
          <g id="XMLID_3115" data-name="XMLID 3115">
            <path
              id="XMLID_3116"
              data-name="XMLID 3116"
              class="cls-3"
              d="M301.6,140.7l-4.8,7.9.9.5,4.7-7.8Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3113" data-name="XMLID 3113">
            <path
              id="XMLID_3114"
              data-name="XMLID 3114"
              class="cls-3"
              d="M297.2,142.9l-1,5.8,1,.2,1-5.8Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
        <g id="XMLID_3088" data-name="XMLID 3088">
          <g id="XMLID_3106" data-name="XMLID 3106">
            <path
              id="XMLID_3110"
              data-name="XMLID 3110"
              class="cls-1"
              d="M306.3,187.1v-4.6h-.1l-9.6.9-.9-5.3h-.1l-8.8,5.1h-.1l-1.8-.5c-.1,0-.1,0-.1.1v4.5a.8.8,0,0,0,.5.7l9,5.2a2.6,2.6,0,0,0,2.4,0l9-5.2C306,187.7,306.3,187.4,306.3,187.1Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3107"
              data-name="XMLID 3107"
              class="cls-3"
              d="M295.6,193.8a2.3,2.3,0,0,1-1.4-.4l-8.9-5.2a1.2,1.2,0,0,1-.7-1v-4.6a.5.5,0,0,1,.2-.4h.4l1.6.4,8.6-5h.8l.7,5.1,9.4-.8h0c.3.1.5.3.5.5v4.6a1.5,1.5,0,0,1-.8,1.1l-9,5.2A2,2,0,0,1,295.6,193.8Zm-10.3-10.7v4c0,.1.1.3.4.4l8.9,5.2a1.8,1.8,0,0,0,2,0l9-5.2a.5.5,0,0,0,.2-.4v-4.2l-9.2.8h-.4l-.9-4.9-8.5,4.9h-.1Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3100" data-name="XMLID 3100">
            <path
              id="XMLID_3105"
              data-name="XMLID 3105"
              class="cls-3"
              d="M306.2,182.4l-9.6.9-1.2,3.3v6.9l1.4-.3,9-5.2c.2-.2.5-.5.5-.8s0-4.4-.1-4.8Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3101"
              data-name="XMLID 3101"
              class="cls-3"
              d="M295.6,193.8H295v-7.4l1.3-3.8.4.2,9.5-.9h.1c.1.1.4.3.4.5V187a1.2,1.2,0,0,1-.8,1.1l-9,5.2A1.9,1.9,0,0,1,295.6,193.8Zm.2-7.2V193l.8-.2,9-5.2a.5.5,0,0,0,.2-.4V183l-8.9.8Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3094" data-name="XMLID 3094">
            <path
              id="XMLID_3099"
              data-name="XMLID 3099"
              class="cls-3"
              d="M286.3,183.8a2,2,0,0,1,.4-.8l-1.7-.4h-.1v4.5a.8.8,0,0,0,.5.7l.9.5v-4.6Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3095"
              data-name="XMLID 3095"
              class="cls-3"
              d="M286.8,189.1l-1.5-.9a1.2,1.2,0,0,1-.7-1v-4.6a.5.5,0,0,1,.2-.4h.4l2,.6-.3.4c-.1.3-.1.6-.2.8Zm-1.5-6.1v4c0,.2.1.3.3.4l.2.2v-4a.6.6,0,0,0,.1-.4Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3089" data-name="XMLID 3089">
            <path
              id="XMLID_3093"
              data-name="XMLID 3093"
              class="cls-2"
              d="M294.3,188.5l-8.9-5.2a1,1,0,0,1-.4-1.2l.4-.4,9.2-5.2a2.4,2.4,0,0,1,2.3,0l8.9,5.2a1,1,0,0,1,.4,1.2.8.8,0,0,1-.4.4l-9,5.2A2.8,2.8,0,0,1,294.3,188.5Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3090"
              data-name="XMLID 3090"
              class="cls-3"
              d="M295.6,189.2a2.3,2.3,0,0,1-1.4-.4l-8.9-5.2a1.2,1.2,0,0,1-.7-1.2,1.4,1.4,0,0,1,.7-1.2l9-5.2a3,3,0,0,1,2.9,0l8.8,5.2a1.3,1.3,0,0,1,.8,1.2,2,2,0,0,1-.8,1.2l-9.1,5.2A2.8,2.8,0,0,1,295.6,189.2Zm.1-12.6a1.7,1.7,0,0,0-1,.3l-9.1,5.2a.6.6,0,0,0,0,1l8.8,5.2a2.1,2.1,0,0,0,1.9,0l9.1-5.2a.7.7,0,0,0,.4-.5c0-.1,0-.3-.4-.5l-8.8-5.2A1.4,1.4,0,0,0,295.7,176.6Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
        <g id="XMLID_3082" data-name="XMLID 3082">
          <g id="XMLID_3083" data-name="XMLID 3083">
            <path
              id="XMLID_3087"
              data-name="XMLID 3087"
              class="cls-2"
              d="M289.8,182.4l4.8,2.7,2.7-1.6-4.6-2.8Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3084"
              data-name="XMLID 3084"
              class="cls-3"
              d="M294.6,185.6l-5.6-3.2,3.7-2.1,5.5,3.2Zm-3.9-3.2,3.9,2.2,1.8-1.1-3.7-2.2Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
      </g>
    </g>
    <g id="LadyonSide">
      <path
        id="Shadow-4"
        class="cls-3"
        d="M54.2,90.2l8.1-4.7-.5-.2-6.9,3.9L44.1,95.5l.5.2Zm9.4-3.9-.4-.2L45.5,96.3l.5.2Zm1.4.8-.5-.3L46.8,97l.5.3Zm1.3.8-.5-.3L48.1,97.8l.2.4Zm.9.5L46.9,100.1a.7.7,0,0,0,.1.5l20.7-12ZM69,89.5l-.5-.3L47.7,101.3l.5.2Zm1.4.8-.5-.3L49,102l.5.3Zm1.3.8-.4-.3-20.9,12,.5.3Zm1.4.8-.5-.3-20.8,12,.5.3Zm1.4.8-.5-.3-20.8,12,.7.2Zm1.3.8-.5-.3L57.4,103.5l.7.2Zm1.4.8-.5-.3L59,104.2l.5.3Zm1.3.7-.5-.2L60.3,105l.5.2Zm1.4.8-.5-.2L61.7,105.8l.5.3Zm.8.6L63,106.6l.3.2h.2L81,96.7q0-.2-.3-.3Zm.7,1.1-16.6,9.6a3,3,0,0,0,1.3-.2l15.1-8.7a1.9,1.9,0,0,0,.2-.7ZM56.9,82.4l-.5-.3L38.7,92.3l.5.3Zm1.3.8-.5-.3L40.1,93.1l.4.3Zm1.4.7-.5-.2L41.4,93.9l.5.2Zm1.3.8-.5-.2L42.8,94.7l.5.2ZM45.6,76.2l-1.4.2L29.3,85a1.9,1.9,0,0,0-.2.7Zm1.5.4h-.3l-17.5,10,.4.3L47.4,76.7Zm1.6,1-.5-.3L30.5,87.5l.5.3Zm1.3.8-.4-.3L31.9,88.3l.5.3Zm1.4.7-.5-.2L33.2,89.1l.5.2Zm1.3.8-.5-.2L34.6,89.9l.5.2Zm1.4.8-.5-.3L35.9,90.6l.5.3Zm1.3.8-.4-.3L37.3,91.4l.5.3Z"
        transform="translate(0 0.1)"
      />
      <g id="SittingLady">
        <g id="Rectangle_2" data-name="Rectangle 2">
          <g id="XMLID_3073" data-name="XMLID 3073">
            <path
              id="XMLID_3077"
              data-name="XMLID 3077"
              class="cls-1"
              d="M75.1,94.4v-30H75l-9.6.9L64.5,60h-.1L32.2,51.5h-.1L30.4,51c-.1,0-.1,0-.1.1V81a.8.8,0,0,0,.5.7L63,100.3a2.5,2.5,0,0,0,2.4,0l9-5.2C74.9,95,75.1,94.7,75.1,94.4Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3074"
              data-name="XMLID 3074"
              class="cls-3"
              d="M64.4,101.1a2.3,2.3,0,0,1-1.4-.4L30.7,82.1a1.4,1.4,0,0,1-.7-1V51.2a.5.5,0,0,1,.2-.4h.4l1.5.4,32.3,8.4h.5l.8,5.1,9.3-.8h.1a.7.7,0,0,1,.4.5V94.6a1.2,1.2,0,0,1-.7,1.1l-9,5.2ZM30.9,51.5V81l.2.4L63.3,100a1.8,1.8,0,0,0,2,0l9-5.2c.2-.1.3-.2.3-.4V64.8l-9.3.8H65l-.8-5.2L32.4,51.9h-.2Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3068" data-name="XMLID 3068">
            <path
              id="XMLID_3072"
              data-name="XMLID 3072"
              class="cls-3"
              d="M75,64.3l-9.6.9-1.1,3.3v32.3a3.1,3.1,0,0,0,1.3-.3l9-5.2a1,1,0,0,0,.5-.8C75.1,94.3,75.1,64.7,75,64.3Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3069"
              data-name="XMLID 3069"
              class="cls-3"
              d="M64.4,101.1h-.5V68.3l1.3-3.7.3.2,9.5-.9h.1a.7.7,0,0,1,.4.5V94.5a1.2,1.2,0,0,1-.7,1.1l-9,5.2A3.5,3.5,0,0,1,64.4,101.1Zm.3-32.6v31.7l.7-.2,9-5.2c.2-.1.3-.2.3-.4V64.8l-8.9.8Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3063" data-name="XMLID 3063">
            <path
              id="XMLID_3067"
              data-name="XMLID 3067"
              class="cls-3"
              d="M31.8,52.2l.3-.8L30.5,51c-.1,0-.1,0-.1.1V81a.8.8,0,0,0,.5.7l.9.5Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3064"
              data-name="XMLID 3064"
              class="cls-3"
              d="M32.2,83l-1.5-.9a1.4,1.4,0,0,1-.7-1V51.2a.5.5,0,0,1,.2-.4h.4l2,.6-.2.4-.3.7ZM30.9,51.5V81l.2.4.3.2V52.3h0a.6.6,0,0,0,.1-.4Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3058" data-name="XMLID 3058">
            <path
              id="XMLID_3062"
              data-name="XMLID 3062"
              class="cls-2"
              d="M63.2,70.3,30.9,51.7a1,1,0,0,1-.4-1.2.8.8,0,0,1,.4-.4L40,44.9a2.5,2.5,0,0,1,2.4,0L74.7,63.5a1,1,0,0,1,.4,1.2.8.8,0,0,1-.4.4l-9.1,5.2A2.1,2.1,0,0,1,63.2,70.3Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3059"
              data-name="XMLID 3059"
              class="cls-3"
              d="M64.4,71.1a2.3,2.3,0,0,1-1.4-.4L30.7,52.1a1.4,1.4,0,0,1-.7-1.2,1.5,1.5,0,0,1,.7-1.2l9.1-5.2a2.8,2.8,0,0,1,2.8,0L74.9,63.1a1.4,1.4,0,0,1,.7,1.2,1.5,1.5,0,0,1-.7,1.2l-9.1,5.2A2.3,2.3,0,0,1,64.4,71.1ZM41.1,45a1.7,1.7,0,0,0-1,.3L31,50.5a.6.6,0,0,0,0,1L63.3,70.1a2.1,2.1,0,0,0,1.9,0l9.1-5.2a.6.6,0,0,0,0-1L42.1,45.3A1.7,1.7,0,0,0,41.1,45Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
        <g id="Rectangle">
          <g id="XMLID_3052" data-name="XMLID 3052">
            <path
              id="XMLID_3056"
              data-name="XMLID 3056"
              class="cls-1"
              d="M73,60V55.4c0-.1,0-.1-.1-.1L40,42.7l-.9-5.3H39l-8.8,5.1h-.1L28.4,42c-.1,0-.1,0-.1.1v4.5a.8.8,0,0,0,.5.7L61,65.9a2.5,2.5,0,0,0,2.4,0l9-5.2A.7.7,0,0,0,73,60Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3053"
              data-name="XMLID 3053"
              class="cls-3"
              d="M62.3,66.7a2.3,2.3,0,0,1-1.4-.4L28.6,47.7a1.4,1.4,0,0,1-.7-1V42.1a.5.5,0,0,1,.2-.4h.4l1.5.4,8.7-5a.5.5,0,0,1,.5,0h.2l.9,5.2L73,54.8a.5.5,0,0,1,.3.5v4.6a1.2,1.2,0,0,1-.7,1.1l-9,5.2A1.3,1.3,0,0,1,62.3,66.7ZM28.8,42.5v4a.8.8,0,0,0,.2.4L61.2,65.5a1.8,1.8,0,0,0,2,0l9-5.2c.2-.1.3-.2.3-.4V55.5L39.8,43.1h-.2l-.8-5L30.3,43h-.2Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3046" data-name="XMLID 3046">
            <path
              id="XMLID_3051"
              data-name="XMLID 3051"
              class="cls-3"
              d="M72.9,55.3,40,42.7,62.2,59.4v6.9a3.1,3.1,0,0,0,1.3-.3l9-5.2A1,1,0,0,0,73,60S73,55.7,72.9,55.3Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3047"
              data-name="XMLID 3047"
              class="cls-3"
              d="M62.3,66.7h-.5V59.6L39.7,43l.3-.5v-.3L73,54.8a.5.5,0,0,1,.3.5v4.6a1.2,1.2,0,0,1-.7,1.1l-9,5.2A2.1,2.1,0,0,1,62.3,66.7ZM42.6,44.2l20,15v6.6l.7-.2,9-5.2c.2-.1.3-.2.3-.4V55.6Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3040" data-name="XMLID 3040">
            <path
              id="XMLID_3045"
              data-name="XMLID 3045"
              class="cls-3"
              d="M29.7,43.2l.3-.8L28.4,42c-.1,0-.1,0-.1.1v4.5a.8.8,0,0,0,.5.7l.9.5Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3041"
              data-name="XMLID 3041"
              class="cls-3"
              d="M30.1,48.6l-1.5-.9a1.4,1.4,0,0,1-.7-1V42.1a.5.5,0,0,1,.2-.4h.4l2,.6-.2.4-.3.7Zm-1.3-6.1v4a.8.8,0,0,0,.2.4l.3.2v-4a.6.6,0,0,0,.1-.4Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_3035" data-name="XMLID 3035">
            <path
              id="XMLID_3039"
              data-name="XMLID 3039"
              class="cls-2"
              d="M61.1,61.3,28.8,42.7a1,1,0,0,1-.4-1.2.8.8,0,0,1,.4-.4l9.1-5.2a2.5,2.5,0,0,1,2.4,0L72.6,54.5a1,1,0,0,1,.4,1.2.8.8,0,0,1-.4.4l-9.1,5.2A2.1,2.1,0,0,1,61.1,61.3Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3036"
              data-name="XMLID 3036"
              class="cls-3"
              d="M62.3,62.1a2.3,2.3,0,0,1-1.4-.4L28.6,43.1a1.4,1.4,0,0,1-.7-1.2,1.5,1.5,0,0,1,.7-1.2l9.1-5.2a2.8,2.8,0,0,1,2.8,0L72.8,54.1a1.4,1.4,0,0,1,.7,1.2,1.5,1.5,0,0,1-.7,1.2l-9.1,5.2A2.3,2.3,0,0,1,62.3,62.1ZM39.1,36a1.7,1.7,0,0,0-1,.3L29,41.5a.6.6,0,0,0,0,1L61.3,61.1a2.1,2.1,0,0,0,1.9,0l9.1-5.2a.6.6,0,0,0,0-1L40,36.3A1.6,1.6,0,0,0,39.1,36Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
        <g id="Square">
          <g id="XMLID_3028" data-name="XMLID 3028">
            <path
              id="XMLID_3033"
              data-name="XMLID 3033"
              class="cls-2"
              d="M66,92.4l-5-2.8a.8.8,0,0,1-.4-.7V79.3c0-.3.2-.4.4-.3l5,2.8a.8.8,0,0,1,.4.7v9.6C66.3,92.4,66.2,92.5,66,92.4Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_3029"
              data-name="XMLID 3029"
              class="cls-3"
              d="M66.1,92.8h-.4l-5-2.8a1.4,1.4,0,0,1-.6-1.1V79.2a.9.9,0,0,1,.3-.7h.7l5,2.8a1.4,1.4,0,0,1,.6,1.1V92a.9.9,0,0,1-.3.7Zm.1-.8-.2.4ZM61,79.5v9.3c0,.1.1.3.2.3L66,91.8V82.5c0-.1-.1-.3-.2-.3Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2989" data-name="XMLID 2989">
            <path
              id="XMLID_2998"
              data-name="XMLID 2998"
              class="cls-3"
              d="M64.3,83.9c0,.3-.2.5-.5.3a1.1,1.1,0,0,1-.5-.9c0-.3.2-.5.5-.3A1.1,1.1,0,0,1,64.3,83.9Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
        <g id="BLock_2" data-name="BLock 2">
          <g id="XMLID_2967" data-name="XMLID 2967">
            <g id="XMLID_2983" data-name="XMLID 2983">
              <path
                id="XMLID_2987"
                data-name="XMLID 2987"
                class="cls-1"
                d="M46.5,36.8V32.2h-.1l-9.6.9L36,27.8h-.1l-8.8,5.1H27l-1.7-.5c-.1,0-.1,0-.1.1V37a.8.8,0,0,0,.5.7l8.9,5.2a2.5,2.5,0,0,0,2.4,0l9-5.2A.7.7,0,0,0,46.5,36.8Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_2984"
                data-name="XMLID 2984"
                class="cls-3"
                d="M35.8,43.6a2.3,2.3,0,0,1-1.4-.4L25.5,38a1.4,1.4,0,0,1-.7-1V32.4A.5.5,0,0,1,25,32h.4l1.5.4,8.7-5h.7l.8,5.1,9.3-.8h.1a.7.7,0,0,1,.4.5v4.7a1.2,1.2,0,0,1-.7,1.1l-9,5.2A3.3,3.3,0,0,1,35.8,43.6ZM25.6,32.8v4.1a.8.8,0,0,0,.2.4l8.9,5.2a1.8,1.8,0,0,0,2,0l9-5.2c.2-.1.3-.2.3-.4V32.7l-9.3.8h-.4l-.8-5.1-8.4,4.8h-.2Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_2978" data-name="XMLID 2978">
              <path
                id="XMLID_2982"
                data-name="XMLID 2982"
                class="cls-3"
                d="M46.4,32.2l-9.6.9-1.1,3.3v6.9A3.1,3.1,0,0,0,37,43l9-5.2a1,1,0,0,0,.5-.8C46.5,36.8,46.5,32.6,46.4,32.2Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_2979"
                data-name="XMLID 2979"
                class="cls-3"
                d="M35.8,43.6h-.5V36.2l1.3-3.7.3.2,9.5-.9h.1a.7.7,0,0,1,.4.5V37a1.2,1.2,0,0,1-.7,1.1l-9,5.2A3.5,3.5,0,0,1,35.8,43.6Zm.3-7.3v6.4l.7-.2,9-5.2c.2-.1.3-.2.3-.4V32.7l-8.9.8Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_2973" data-name="XMLID 2973">
              <path
                id="XMLID_2977"
                data-name="XMLID 2977"
                class="cls-3"
                d="M26.6,33.5l.3-.8-1.6-.4c-.1,0-.1,0-.1.1v4.5a.8.8,0,0,0,.5.7l.9.5Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_2974"
                data-name="XMLID 2974"
                class="cls-3"
                d="M27,38.9,25.5,38a1.4,1.4,0,0,1-.7-1V32.4A.5.5,0,0,1,25,32h.4l2,.6-.2.4-.3.7Zm-1.4-6.1v4.1a.8.8,0,0,0,.2.4l.3.2v-4a.6.6,0,0,0,.1-.4Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_2968" data-name="XMLID 2968">
              <path
                id="XMLID_2972"
                data-name="XMLID 2972"
                class="cls-2"
                d="M34.6,38.2,25.7,33a1,1,0,0,1-.4-1.2.8.8,0,0,1,.4-.4l9.1-5.2a2.5,2.5,0,0,1,2.4,0l8.9,5.2a1,1,0,0,1,.4,1.2l-.4.4L37,38.2A2.6,2.6,0,0,1,34.6,38.2Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_2969"
                data-name="XMLID 2969"
                class="cls-3"
                d="M35.8,39a2.3,2.3,0,0,1-1.4-.4l-8.9-5.2a1.4,1.4,0,0,1-.7-1.2,1.5,1.5,0,0,1,.7-1.2l9.1-5.2a2.8,2.8,0,0,1,2.8,0L46.3,31a1.4,1.4,0,0,1,.7,1.2,1.5,1.5,0,0,1-.7,1.2l-9.1,5.2A3.3,3.3,0,0,1,35.8,39Zm.1-12.7a1.7,1.7,0,0,0-1,.3l-9.1,5.2a.6.6,0,0,0,0,1L34.7,38a2.1,2.1,0,0,0,1.9,0l9.1-5.2a.6.6,0,0,0,0-1l-8.9-5.2A1.4,1.4,0,0,0,35.9,26.3Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
        </g>
        <g id="Lady">
          <g id="XMLID_2960" data-name="XMLID 2960">
            <path
              id="XMLID_2965"
              data-name="XMLID 2965"
              class="cls-1"
              d="M51.1,14.3a9.2,9.2,0,0,1-1.9,5.3c-2,2.7-.4,5.8,1.9,6S55,18.4,55,18.4s-.6-5.3-.9-5.3Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_2961"
              data-name="XMLID 2961"
              class="cls-3"
              d="M51.2,25.9h-.1a3.6,3.6,0,0,1-2.8-2.1,4.4,4.4,0,0,1,.6-4.4,9.4,9.4,0,0,0,1.9-5.1v-.2H51a16.6,16.6,0,0,1,3.1-1.2c.3,0,.6,0,1.2,5.6h0C55.1,19.3,53.6,25.9,51.2,25.9Zm.3-11.3a9.4,9.4,0,0,1-2,5.3,3.6,3.6,0,0,0-.6,3.7,2.8,2.8,0,0,0,2.2,1.7c1.4.1,2.9-4.1,3.5-6.9s-.6-4.2-.7-4.9Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2955" data-name="XMLID 2955">
            <path
              id="XMLID_2959"
              data-name="XMLID 2959"
              class="cls-2"
              d="M54,19.7s-3.3-.6-4.1,2.4a71.7,71.7,0,0,0-1.7,15.3,52.8,52.8,0,0,1-1.4,9.7l10.3-1.4,2.3-7.5Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_2956"
              data-name="XMLID 2956"
              class="cls-3"
              d="M46.4,47.4v-.5a53,53,0,0,0,1.4-9.6,66.8,66.8,0,0,1,1.8-15.4c.8-3.3,4.4-2.7,4.5-2.7h.2l5.4,19L57.4,46Zm7-27.4a3,3,0,0,0-3.1,2.2,77.8,77.8,0,0,0-1.7,15.2,41.7,41.7,0,0,1-1.3,9.3l9.6-1.3,2.2-7.2L53.8,20Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2950" data-name="XMLID 2950">
            <path
              id="XMLID_2954"
              data-name="XMLID 2954"
              class="cls-3"
              d="M33.5,91.9a7.3,7.3,0,0,1,2.3-4.1A37.9,37.9,0,0,0,40.6,82l.8-.8.7.2a42.1,42.1,0,0,0,0,7.1l-1.6.9-.2-.6a14.9,14.9,0,0,1-3.8,2.8C34.5,92.4,33.5,91.9,33.5,91.9Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_2951"
              data-name="XMLID 2951"
              class="cls-3"
              d="M34.5,92.4l-1.2-.2h-.2V92a7.3,7.3,0,0,1,2.5-4.3A50.8,50.8,0,0,0,40.3,82l1-1,1.1.4v.3a40.9,40.9,0,0,0,0,7v.2l-2.1,1.2-.2-.5a10.1,10.1,0,0,1-3.6,2.5A6.4,6.4,0,0,1,34.5,92.4Zm-.6-.7a3.3,3.3,0,0,0,2.4-.3A11.1,11.1,0,0,0,40,88.7l.4-.4.3.7,1.1-.6a37.5,37.5,0,0,1,0-6.7h-.3l-.6.7a37.9,37.9,0,0,1-4.8,5.8A6.8,6.8,0,0,0,33.9,91.7Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2944" data-name="XMLID 2944">
            <path
              id="XMLID_2949"
              data-name="XMLID 2949"
              class="cls-1"
              d="M38.1,81.7s-.3,3.9-2.2,6.1c0,0,.8,1.7,3.1,0s2.4-7.2,2.4-7.2Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_2945"
              data-name="XMLID 2945"
              class="cls-3"
              d="M37.1,88.9h-.4a1.4,1.4,0,0,1-1.1-.9v-.4c1.8-2.1,2.1-5.9,2.1-5.9v-.3l3.9-1.3v.5c0,.2-.2,5.8-2.6,7.5A2.7,2.7,0,0,1,37.1,88.9Zm-.8-1.1.6.4a2.6,2.6,0,0,0,1.9-.6c1.7-1.3,2.2-5.2,2.3-6.5l-2.6.9C38.3,82.8,37.8,85.8,36.3,87.8Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2925" data-name="XMLID 2925">
            <path
              id="XMLID_2943"
              data-name="XMLID 2943"
              class="cls-3"
              d="M37.8,93.7a7.3,7.3,0,0,1,2.3-4.1,37.9,37.9,0,0,0,4.8-5.8l.8-.8.7.2a42.1,42.1,0,0,0,0,7.1l-1.6.9-.2-.6a14.9,14.9,0,0,1-3.8,2.8C38.8,94.2,37.8,93.7,37.8,93.7Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_2926"
              data-name="XMLID 2926"
              class="cls-3"
              d="M38.8,94.2,37.6,94h-.2v-.2a7.5,7.5,0,0,1,2.5-4.4,50.8,50.8,0,0,0,4.7-5.7l1-1,1.1.4v.3a40.9,40.9,0,0,0,0,7v.2l-2.1,1.2-.2-.5a10.1,10.1,0,0,1-3.6,2.5A4.5,4.5,0,0,1,38.8,94.2Zm-.6-.7a3.3,3.3,0,0,0,2.4-.3,14.1,14.1,0,0,0,3.7-2.7l.4-.4.3.7,1.1-.6a37.5,37.5,0,0,1,0-6.7h-.3l-.6.7A37.9,37.9,0,0,1,40.4,90,6.2,6.2,0,0,0,38.2,93.5Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2920" data-name="XMLID 2920">
            <path
              id="XMLID_2924"
              data-name="XMLID 2924"
              class="cls-1"
              d="M42.4,83.6s-.3,3.9-2.2,6.1c0,0,.8,1.7,3.1,0s2.4-7.2,2.4-7.2Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_2921"
              data-name="XMLID 2921"
              class="cls-3"
              d="M41.4,90.8H41a1.4,1.4,0,0,1-1.1-.9v-.5c1.8-2.1,2.1-5.9,2.1-5.9v-.2L45.9,82v.5c0,.2-.2,5.8-2.6,7.5A2.7,2.7,0,0,1,41.4,90.8Zm-.8-1.1.6.4a2.6,2.6,0,0,0,1.9-.6c1.7-1.3,2.2-5.2,2.3-6.5l-2.6.9C42.6,84.6,42.1,87.7,40.6,89.7Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2915" data-name="XMLID 2915">
            <path
              id="XMLID_2919"
              data-name="XMLID 2919"
              class="cls-3"
              d="M41.1,61.7c-3.7-2-5.4-3.3-4.6-6l2.2-1.9,7.8-1,4.8,4.5.7,3.2-4.7,2.7A13.2,13.2,0,0,1,41.1,61.7Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_2916"
              data-name="XMLID 2916"
              class="cls-3"
              d="M47.2,63.5a13.7,13.7,0,0,1-6.3-1.6c-3.5-1.9-5.7-3.3-4.8-6.4h0l2.4-2,8-1.1,5,4.6.7,3.5-4.8,3ZM36.7,55.8c-.6,2.3.7,3.4,4.5,5.5a14,14,0,0,0,6,1.5l4.3-2.7L51,57.4l-4.6-4.3-7.5,1Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2910" data-name="XMLID 2910">
            <path
              id="XMLID_2914"
              data-name="XMLID 2914"
              class="cls-2"
              d="M40,54.4s-3.6-.4-3.6,6.4,1.2,16,1.1,21.7a3.7,3.7,0,0,0,3.9-1.3,48.3,48.3,0,0,1,.4-9.3c.7-5.2.4-10.3,0-11.6a15.6,15.6,0,0,0,9.5-3.5c4-3.6-6-6.3-6-6.3Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_2911"
              data-name="XMLID 2911"
              class="cls-3"
              d="M38.6,83l-1.2-.2h-.2v-.2c0-2.8-.2-6.4-.5-10.2s-.6-7.9-.6-11.4.6-4.9,1.8-6a3,3,0,0,1,2-.8l5.2-3.9h.2c.3.1,6.4,1.8,7.1,4.4a2.3,2.3,0,0,1-1,2.4,14.6,14.6,0,0,1-9.3,3.6A42.7,42.7,0,0,1,42,72a56.7,56.7,0,0,0-.4,9.2h-.1A3.2,3.2,0,0,1,38.6,83Zm-.7-.7a3.1,3.1,0,0,0,3.2-1.2,56.7,56.7,0,0,1,.4-9.2c.7-5.3.4-10.3,0-11.4v-.4H42c.1,0,5.5.1,9.2-3.4a1.8,1.8,0,0,0,.8-1.8c-.5-1.9-4.7-3.4-6.5-3.9l-5.2,3.8h-.1a2,2,0,0,0-1.6.7c-.7.7-1.6,2.1-1.6,5.5s.3,7.5.6,11.4S37.9,79.5,37.9,82.3Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2900" data-name="XMLID 2900">
            <path
              id="XMLID_2909"
              data-name="XMLID 2909"
              class="cls-2"
              d="M45.5,55.8s-4.6-.1-4.6,6.8,1.3,15.6,1.3,21.2c0,0,2.6,1.4,4.1-.8a48.3,48.3,0,0,1,.4-9.3,44.9,44.9,0,0,0,.1-11c0-.2.2-.5.4-.5a15.2,15.2,0,0,0,8.9-3.5c3.9-3.7-6-6.3-6-6.3Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_2906"
              data-name="XMLID 2906"
              class="cls-3"
              d="M43.9,84.6a3.2,3.2,0,0,1-1.9-.5h-.2v-.2c0-2.8-.3-6.3-.6-10s-.7-7.8-.7-11.3.6-4.5,1.9-5.8a4.4,4.4,0,0,1,2.9-1.4L50,51.9h.2c.3.1,6.4,1.8,7.1,4.4a2.3,2.3,0,0,1-1,2.4,14.4,14.4,0,0,1-9.1,3.6h-.1A45.8,45.8,0,0,1,47,73.4a56.7,56.7,0,0,0-.4,9.2h-.1A2.7,2.7,0,0,1,43.9,84.6Zm-1.4-.9A2.9,2.9,0,0,0,46,83a56.7,56.7,0,0,1,.4-9.2,44.2,44.2,0,0,0,.1-10.9.7.7,0,0,1,.2-.6.7.7,0,0,1,.6-.3A14.5,14.5,0,0,0,56,58.6a1.8,1.8,0,0,0,.8-1.8c-.5-1.9-4.7-3.4-6.5-3.9l-4.7,3.3h-.1a4.2,4.2,0,0,0-2.6,1.2c-1.1,1.1-1.7,2.9-1.7,5.3a105.2,105.2,0,0,0,.7,11.2C42.2,77.5,42.5,80.9,42.5,83.7Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2895" data-name="XMLID 2895">
            <path
              id="XMLID_2899"
              data-name="XMLID 2899"
              class="cls-1"
              d="M51.8,42.7A42.6,42.6,0,0,0,41.7,50c-4.3,4.5-5.2,5.7-5.2,5.7s1.6-2.5,6.7-.6,5.4,4.1,5.5,6.1-1,1.6-1.2,1.9h0c.9-.1,5.8-.9,12.3-5.5s5.4-9.9,3.4-13.5S51.8,42.7,51.8,42.7Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_2896"
              data-name="XMLID 2896"
              class="cls-3"
              d="M47.3,63.5l-.2-.2c-.1-.1,0-.3.1-.4l.2-.2c.3-.3.9-.7.9-1.4s-.2-3.9-5.3-5.9-5.7-.2-6.1.3l-.2.2-.5-.4.2-.2c.4-.5,1.7-2,5.1-5.5s10.2-7.3,10.2-7.4h.1c.4-.1,9.8-1.5,11.7,1.7S67.3,52.9,60,58s-11.5,5.4-12.4,5.5ZM39.7,54a11.5,11.5,0,0,1,3.6.7c5,1.9,5.6,4.1,5.7,6.4a2,2,0,0,1-.6,1.5,31.8,31.8,0,0,0,11.2-5.2c6.8-4.8,5.3-9.5,3.3-13S54.6,42.6,52,43a41.7,41.7,0,0,0-10,7.2l-3.8,4Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2890" data-name="XMLID 2890">
            <path
              id="XMLID_2894"
              data-name="XMLID 2894"
              class="cls-3"
              d="M55,19.6s-4-1-4.4,1.6a67.7,67.7,0,0,1-1.9,8.7c-.9,3.1,2.7,4.4,2.7,4.4a27.4,27.4,0,0,1-1.7,9.4s6.1,6.9,14.2,3.4l-.3-1.8s-1.4-8.2-.6-11.8,3.2-5,1.9-8.5-6.5-4.9-6.5-4.9Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_2891"
              data-name="XMLID 2891"
              class="cls-3"
              d="M59.4,48.5c-5.8,0-9.8-4.5-9.9-4.5v-.4a27.6,27.6,0,0,0,1.7-9c-.8-.4-3.6-1.8-2.7-4.7a67.7,67.7,0,0,0,1.9-8.7,2,2,0,0,1,1-1.6c1.3-.9,3.6-.4,3.8-.3l3.4.6c.3.1,5.4,1.5,6.8,5.2s.2,3.8-.7,5.6a16.6,16.6,0,0,0-1.2,3.1c-.9,3.4.5,11.5.5,11.6l.4,2h-.2A11.3,11.3,0,0,1,59.4,48.5Zm-9.2-4.8c.9.9,6.4,6.1,13.5,3.3l-.3-1.5c-.1-.3-1.4-8.3-.6-11.9A19.6,19.6,0,0,1,64,30.2c.8-1.6,1.4-2.9.6-5s-6.2-4.7-6.3-4.7L55,19.9s-2.2-.5-3.3.3a1.9,1.9,0,0,0-.7,1.1,65.6,65.6,0,0,1-1.9,8.8c-.8,2.8,2.4,4,2.5,4h.2v.3A26.8,26.8,0,0,1,50.2,43.7Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2885" data-name="XMLID 2885">
            <path
              id="XMLID_2889"
              data-name="XMLID 2889"
              class="cls-2"
              d="M53.8,20s-.9-.8-.9.6-.1,3.2-.1,6,3.5,4.3,6-.5,4.4-3.3,4.4-3.3l-1.6-3-4.2-2.3Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_2886"
              data-name="XMLID 2886"
              class="cls-3"
              d="M55.1,29.4h-.6a2.8,2.8,0,0,1-2.1-2.8c0-1.7,0-3,.1-4v-2c0-.2,0-.9.5-1.1a1.1,1.1,0,0,1,.8.1l3.6-2.5,4.5,2.3,2.3,4.5-1.2-1a1.1,1.1,0,0,0-.8-.1c-.7.1-1.7.8-3.1,3.3S56.5,29.4,55.1,29.4ZM53.2,20s-.1.1-.1.5v2c0,1.1-.1,2.4-.1,4a2.2,2.2,0,0,0,1.6,2.2c1.3.3,2.8-.7,3.9-2.8s2.3-3.4,3.5-3.7h.5L61.3,20l-3.9-2.1-3.6,2.6-.2-.3Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2883" data-name="XMLID 2883">
            <path
              id="XMLID_2884"
              data-name="XMLID 2884"
              class="cls-1"
              d="M57.5,36.7a8.1,8.1,0,0,1-3.7-1.2l.4-.5a5.3,5.3,0,0,0,6.3,0l.4.5A5.4,5.4,0,0,1,57.5,36.7Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2881" data-name="XMLID 2881">
            <path
              id="XMLID_2882"
              data-name="XMLID 2882"
              class="cls-3"
              d="M49.9,57.7l-.2-.6c.1,0,7.2-2.3,8.9-6.2l.6.3C57.4,55.3,50.2,57.6,49.9,57.7Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2879" data-name="XMLID 2879">
            <path
              id="XMLID_2880"
              data-name="XMLID 2880"
              class="cls-3"
              d="M59.7,49.6l-.7-.2a1.8,1.8,0,0,0-.3-2l.4-.5A2.7,2.7,0,0,1,59.7,49.6Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2877" data-name="XMLID 2877">
            <path
              id="XMLID_2878"
              data-name="XMLID 2878"
              class="cls-3"
              d="M55.5,27.1l-.6-.2c-1.6-1-.9-5-.9-5.5h.6c-.3,1.6-.4,4.3.6,4.8s.2.1.5,0a20.6,20.6,0,0,0,3.4-4.8l.6.2c-.4,1.1-2.2,4.6-3.8,5.2C55.8,27.1,55.7,27.1,55.5,27.1Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2852" data-name="XMLID 2852">
            <g id="XMLID_2872" data-name="XMLID 2872">
              <path
                id="XMLID_2876"
                data-name="XMLID 2876"
                class="cls-2"
                d="M53,12.3s-2.2,7.4,1.3,9.7h.2c.6,0,3,0,5.2-3l.2-.2A2.5,2.5,0,0,0,62,16.7a1.1,1.1,0,0,0-.8-1.4H61c-.3,0-.4-.3-.3-.6l1.2-2.6c.1-.2,0-.3-.1-.5L59.3,8.9c-.1-.1-.3-.2-.4-.1l-5,1.1a.3.3,0,0,0-.3.3Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_2873"
                data-name="XMLID 2873"
                class="cls-3"
                d="M54.8,22.4h-.7c-3.7-2.3-1.5-9.7-1.4-10l.7-2a1,1,0,0,1,.6-.5l5-1.1a.6.6,0,0,1,.7.2l2.5,2.7a.6.6,0,0,1,.1.8L61,15h.1a1.4,1.4,0,0,1,1.2,1.6h0c-.1,1.6-1.8,2.2-2.3,2.4C58,22,55.7,22.4,54.8,22.4Zm-1.5-10c-.1.2-2,7.2,1.2,9.3h.1c.5,0,2.8.1,4.9-2.9.1-.1.2-.3.4-.3s1.8-.6,1.9-1.8-.2-1-.7-1a.7.7,0,0,1-.5-.4.9.9,0,0,1,0-.7L61.8,12h0L59.3,9.3h-.1l-5,1.1h-.1Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_2861" data-name="XMLID 2861">
              <path
                id="XMLID_2871"
                data-name="XMLID 2871"
                class="cls-1"
                d="M65.7,19.6c-2.7-1.8-2-3.6-1.9-3.8l.4-.7c1.1-1.6,1.3-5.3-3.1-7.8a5,5,0,0,0-2.7-.8A7,7,0,0,0,51,13a5.6,5.6,0,0,0,0,1.3,10.5,10.5,0,0,0,.6,2.4c.9,1.8.6-2.4,4.6-3.5l.3.7h.2l1.8-1.2h.1c.3.2,2.3.9,1.1,2.8v.2c.1.1,1.9.1,1.5,1.1A5,5,0,0,1,60,18.8L58.8,20c-.1.2-.6,1.9,2.4,3.1h.2l1.8,1.1,1.3.9s2.7,12.7,2.7,9.8a18.3,18.3,0,0,1,1.5-7.6C69.9,24,68.6,21.5,65.7,19.6Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_2862"
                data-name="XMLID 2862"
                class="cls-3"
                d="M67.1,35.8c-.3,0-.8-.6-2.9-10.4L63,24.6l-1.7-1.1h-.2a3.9,3.9,0,0,1-2.5-2,2.6,2.6,0,0,1-.1-1.5h.1l1.3-1.2A7.1,7.1,0,0,0,61.1,17c0-.1.1-.2,0-.2l-1-.3h-.3a.3.3,0,0,1-.3-.3c-.1-.1,0-.3,0-.4a1.3,1.3,0,0,0,.3-1.2c-.1-.5-.8-.9-1.1-1.1h-.1L57,14.6h-.4l-.3-.2-.2-.5A5.4,5.4,0,0,0,52.9,17c-.3.5-.4.9-.8.9s-.5-.3-.7-.6a13.6,13.6,0,0,1-.6-2.9,7.1,7.1,0,0,1,2.1-5.9,6.9,6.9,0,0,1,5.7-2.2,7.1,7.1,0,0,1,2.8.9,7.4,7.4,0,0,1,3.8,4.5,4.8,4.8,0,0,1-.6,3.7,2.5,2.5,0,0,0-.4.7c-.1.2-.7,1.8,1.8,3.4s4.3,4.9,3.1,8.1-1.6,4.7-1.5,7.5C67.5,35.3,67.5,35.7,67.1,35.8ZM59.2,20.2a1.7,1.7,0,0,0,.1,1,4.1,4.1,0,0,0,2.2,1.7h.2L63.5,24l1.4,1h0c.6,2.7,1.5,6.5,2,8.6a18.6,18.6,0,0,1,1.5-6.5c1.1-3,.2-5.4-2.9-7.4s-2.1-4-2-4.2a2.2,2.2,0,0,1,.5-.8,4,4,0,0,0,.5-3.2A6.8,6.8,0,0,0,61,7.4a7.3,7.3,0,0,0-2.5-.8,6.7,6.7,0,0,0-7.1,6.2V14a10.5,10.5,0,0,0,.6,2.4c0,.1.1.1.1.2a.8.8,0,0,0,.2-.4,5.9,5.9,0,0,1,3.9-3.5h.3l.3.8,1.6-1.1h.7a2.3,2.3,0,0,1,1.4,1.5,2.2,2.2,0,0,1-.2,1.4c.5.1,1.2.2,1.4.6a.6.6,0,0,1,0,.8,6,6,0,0,1-1.4,2.1Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_2859" data-name="XMLID 2859">
              <path
                id="XMLID_2860"
                data-name="XMLID 2860"
                class="cls-3"
                d="M59.2,17.7H59v-.6a.9.9,0,0,0,.6-.3l.5.4A1.1,1.1,0,0,1,59.2,17.7Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_2857" data-name="XMLID 2857">
              <path
                id="XMLID_2858"
                data-name="XMLID 2858"
                class="cls-3"
                d="M51.7,15.5H51c0-.1.7-7.3,7.1-6.9v.6C52.4,8.9,51.7,15.3,51.7,15.5Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_2855" data-name="XMLID 2855">
              <path
                id="XMLID_2856"
                data-name="XMLID 2856"
                class="cls-3"
                d="M64.1,16.9h-.6c.5-4.3-1.5-5.9-1.6-6l.4-.5S64.6,12.2,64.1,16.9Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_2853" data-name="XMLID 2853">
              <path
                id="XMLID_2854"
                data-name="XMLID 2854"
                class="cls-3"
                d="M65.8,26.6h-.7a5.5,5.5,0,0,0-2.9-4.4A2.2,2.2,0,0,1,60.9,20h.6a1.8,1.8,0,0,0,1,1.6A5.5,5.5,0,0,1,65.8,26.6Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
          <g id="XMLID_2743" data-name="XMLID 2743">
            <path
              id="XMLID_2747"
              data-name="XMLID 2747"
              class="cls-2"
              d="M63.6,25.1c1.2-.7,2.7,2.1,3.4,7.5s0,6,.1,11.6c0,3.2-.1,8.1,0,9.5a6.3,6.3,0,0,0,1,2.7l2.1,2.4c.6.8.5,1.7-.3,2a2.5,2.5,0,0,1-2.8-.7l-2-2.2-.4.3a4.4,4.4,0,0,0,.5,1.5c.1,1.2-.9.6-1.8-1a2.2,2.2,0,0,1,0-1.6l.3-.8a8.6,8.6,0,0,0,.6-3.9c-.2-2.4-.4-6.4-.8-10.2C63,36.3,60.8,26.7,63.6,25.1Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_2744"
              data-name="XMLID 2744"
              class="cls-3"
              d="M69,61.1a3,3,0,0,1-2.2-1l-1.8-2a3.1,3.1,0,0,0,.5,1.2h0c0,.7-.2.9-.4,1s-1.6-1.2-2-1.8a1.9,1.9,0,0,1,0-1.8l.3-.8a8.2,8.2,0,0,0,.6-3.8c-.1-2.1-.4-6.3-.8-10.2-.1-1.3-.3-2.7-.5-4.3-.8-5.7-1.6-11.6.7-13a1.1,1.1,0,0,1,1.1,0c1.2.6,2.3,3.5,2.8,7.8a31.9,31.9,0,0,1,.2,6.9c-.1,1.2-.1,2.6-.1,4.7v9.5a5.8,5.8,0,0,0,.9,2.5l2.1,2.3a1.6,1.6,0,0,1,.4,1.6,1.4,1.4,0,0,1-.9.9Zm-3.9-3.8,2.2,2.4a2.2,2.2,0,0,0,2.4.7.5.5,0,0,0,.5-.5,1,1,0,0,0-.3-1l-2.1-2.3a6.5,6.5,0,0,1-1.1-2.9c-.1-.8,0-2.5,0-4.6V44.2c0-2.1,0-3.6.1-4.8a30.1,30.1,0,0,0-.2-6.7c-.6-4.5-1.6-6.9-2.4-7.3s-.3-.1-.4,0l-.2-.3.2.3c-1.9,1.1-1.1,7.3-.4,12.3.2,1.6.4,3,.5,4.3.4,3.8.7,8,.8,10.2a9.5,9.5,0,0,1-.6,4.1l-.3.8a1.5,1.5,0,0,0,0,1.3A4.4,4.4,0,0,0,65,59.9v-.2a3,3,0,0,1-.5-1.6v-.2Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2741" data-name="XMLID 2741">
            <path
              id="XMLID_2742"
              data-name="XMLID 2742"
              class="cls-1"
              d="M45,90.9h-.7A3.2,3.2,0,0,0,44,89l.5-.4C44.6,88.7,45,89.2,45,90.9Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2739" data-name="XMLID 2739">
            <path
              id="XMLID_2740"
              data-name="XMLID 2740"
              class="cls-1"
              d="M39.5,93.2a2,2,0,0,1-1.1-.3l.4-.5a2.2,2.2,0,0,0,1.6,0l.3.6A2.5,2.5,0,0,1,39.5,93.2Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2737" data-name="XMLID 2737">
            <path
              id="XMLID_2738"
              data-name="XMLID 2738"
              class="cls-1"
              d="M35.4,91.4a2,2,0,0,1-1.1-.3l.4-.5a2.2,2.2,0,0,0,1.6,0l.3.6Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2735" data-name="XMLID 2735">
            <path
              id="XMLID_2736"
              data-name="XMLID 2736"
              class="cls-1"
              d="M52,33.8l-.3.6L53,35l.3-.6Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2733" data-name="XMLID 2733">
            <path
              id="XMLID_2734"
              data-name="XMLID 2734"
              class="cls-1"
              d="M58.8,34.7v-.6a2.7,2.7,0,0,0,2-1.9l.6.2A3.6,3.6,0,0,1,58.8,34.7Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2731" data-name="XMLID 2731">
            <path
              id="XMLID_2732"
              data-name="XMLID 2732"
              class="cls-1"
              d="M59.9,47.2h-.6a29.4,29.4,0,0,0,0-4.2h.6A29.4,29.4,0,0,1,59.9,47.2Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2729" data-name="XMLID 2729">
            <path
              id="XMLID_2730"
              data-name="XMLID 2730"
              class="cls-1"
              d="M59.7,40.6H59v1.5h.8Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2727" data-name="XMLID 2727">
            <path
              id="XMLID_2728"
              data-name="XMLID 2728"
              class="cls-3"
              d="M65.6,37.5a13.4,13.4,0,0,0-.4-3.5l.6-.2a11.7,11.7,0,0,1,.4,3.7Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2725" data-name="XMLID 2725">
            <path
              id="XMLID_2726"
              data-name="XMLID 2726"
              class="cls-3"
              d="M66.9,30.4l-.6-.2c2.2-5.8.1-7.4.1-7.4l.4-.5C66.9,22.3,69.3,24.1,66.9,30.4Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2723" data-name="XMLID 2723">
            <path
              id="XMLID_2724"
              data-name="XMLID 2724"
              class="cls-3"
              d="M49.8,22.1a2.7,2.7,0,0,1-.4-3.4l.6.3a2.3,2.3,0,0,0,.3,2.6Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
        <g id="GLass-2">
          <g id="XMLID_2711" data-name="XMLID 2711">
            <g id="XMLID_2717" data-name="XMLID 2717">
              <path
                id="XMLID_2721"
                data-name="XMLID 2721"
                class="cls-1"
                d="M39.3,35.8a.3.3,0,0,0-.3.3l.8,8.1c0,.5.5,1,1.4,1.2a4.3,4.3,0,0,0,1.6,0c.9-.2,1.4-.7,1.4-1.2l.8-8.1a.3.3,0,0,0-.3-.3Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_2718"
                data-name="XMLID 2718"
                class="cls-3"
                d="M42.1,45.9h-.9c-1.1-.3-1.7-.9-1.7-1.6l-.8-8.1c0-.2,0-.4.2-.5l.5-.2h5.5l.5.2a.8.8,0,0,1,.2.5l-.9,8.1c0,.7-.6,1.3-1.7,1.6Zm-2.6-9.7.8,7.9c0,.3.3.6,1.1.8a3.3,3.3,0,0,0,1.4,0c.8-.2,1.1-.5,1.1-.8l.8-8H39.5Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_2712" data-name="XMLID 2712">
              <path
                id="XMLID_2716"
                data-name="XMLID 2716"
                class="cls-1"
                d="M44.2,34.5a1.3,1.3,0,0,1,.9,1.6,1.4,1.4,0,0,1-.9.9,4.7,4.7,0,0,1-4.3,0,1.3,1.3,0,0,1-.9-1.6,1.4,1.4,0,0,1,.9-.9A4.7,4.7,0,0,1,44.2,34.5Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_2713"
                data-name="XMLID 2713"
                class="cls-3"
                d="M42.1,37.9a5,5,0,0,1-2.4-.6,1.7,1.7,0,0,1-1-2.2,1.4,1.4,0,0,1,1-1,4.9,4.9,0,0,1,4.7,0,1.7,1.7,0,0,1,1,2.2,1.4,1.4,0,0,1-1,1A3.2,3.2,0,0,1,42.1,37.9Zm0-3.5a4.1,4.1,0,0,0-1.9.5c-.4.3-.7.6-.7.9s.2.6.7.9a4.5,4.5,0,0,0,3.9,0c.4-.3.7-.6.7-.9s-.2-.6-.7-.9A4.6,4.6,0,0,0,42.1,34.4Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
        </g>
        <g id="Blocky">
          <g id="XMLID_2685" data-name="XMLID 2685">
            <g id="XMLID_2704" data-name="XMLID 2704">
              <path
                id="XMLID_2708"
                data-name="XMLID 2708"
                class="cls-2"
                d="M57.7,89l-3.2-2H54l-3.3,1.9c-.1,0-.1.1-.1.2l3.1,3.5v2a1.7,1.7,0,0,0,.7,1.4l-2.9-1.6h.1l3.1,5.4h.2l3.3-1.9a1.4,1.4,0,0,0,.2-.6v-7A2.1,2.1,0,0,0,57.7,89Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_2705"
                data-name="XMLID 2705"
                class="cls-3"
                d="M54.8,100.5h-.2c-.2,0-.3-.1-.4-.3l-3.1-5.4h.1l.4-.7,1.6.8v-2l-3.1-3.4a.5.5,0,0,1,0-.7h.2l3.3-1.9a.9.9,0,0,1,1,0l3.2,2a2.2,2.2,0,0,1,1,1.8v7a1.1,1.1,0,0,1-.4.9l-3.3,2Zm-2.1-4.9,2.2,3.9L58,97.7V90.5a1.6,1.6,0,0,0-.5-1.1l-3.2-2h-.1l-3,1.8,2.1,2.4h0v-.4h.8v3.6a1.6,1.6,0,0,0,.5,1.1l-.4.7Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_2691" data-name="XMLID 2691">
              <path
                id="XMLID_2695"
                data-name="XMLID 2695"
                class="cls-3"
                d="M51.5,94.5h0l3.1,5.4h.3L58.1,98a1.4,1.4,0,0,0,.2-.6V90.6h-.1l-3.4,2Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_2692"
                data-name="XMLID 2692"
                class="cls-3"
                d="M54.9,100.4h-.2c-.2,0-.3-.2-.4-.3l-3.1-5.3-.4-.4,3.9-2.3L58.3,90h.3a.5.5,0,0,1,.2.4v7a1.1,1.1,0,0,1-.4.9l-3.3,1.9C55.1,100.4,55,100.4,54.9,100.4Zm-2.8-5.8,2.8,4.9L58,97.7V91.2l-2.8,1.7Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_2686" data-name="XMLID 2686">
              <path
                id="XMLID_2690"
                data-name="XMLID 2690"
                class="cls-1"
                d="M54.2,100.1l-3.2-2a1.7,1.7,0,0,1-.7-1.4v-7c0-.5.3-.8.7-.6l3.2,2a1.7,1.7,0,0,1,.7,1.4v7C55,100.1,54.6,100.3,54.2,100.1Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_2687"
                data-name="XMLID 2687"
                class="cls-3"
                d="M54.5,100.6H54l-3.2-2a2.1,2.1,0,0,1-.9-1.8v-7a1.2,1.2,0,0,1,.5-1h.9l3.2,2a2.1,2.1,0,0,1,.9,1.8v7a1.2,1.2,0,0,1-.5,1Zm-.1-.9h0c.1,0,.1,0,.1-.2v-7a1.6,1.6,0,0,0-.5-1.1l-3.2-2h-.1v7.2a1.6,1.6,0,0,0,.5,1.1Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
          <g id="XMLID_2683" data-name="XMLID 2683">
            <path
              id="XMLID_2684"
              data-name="XMLID 2684"
              class="cls-3"
              d="M56.4,88.1l-3.3,2,.5.7,3.3-2Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2681" data-name="XMLID 2681">
            <path
              id="XMLID_2682"
              data-name="XMLID 2682"
              class="cls-1"
              d="M57.9,93.8,55,95.6l.4.6,2.9-1.8Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
        <g id="Speech">
          <g id="XMLID_2661" data-name="XMLID 2661">
            <g id="XMLID_2674" data-name="XMLID 2674">
              <path
                id="XMLID_2678"
                data-name="XMLID 2678"
                class="cls-1"
                d="M32.7,7.1,44.3.4c.5-.3,1,0,1,.7V11a2.2,2.2,0,0,1-1,1.8L37.1,17a1.8,1.8,0,0,0,.2,1.6c0,.1,0,.2-.1.2s-1.9-.2-2.1-.7l-2.4,1.4c-.5.3-1,0-1-.7V8.9A2.5,2.5,0,0,1,32.7,7.1Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_2675"
                data-name="XMLID 2675"
                class="cls-2"
                d="M32.3,20h-.4a1.6,1.6,0,0,1-.5-1.1V8.9a2.6,2.6,0,0,1,1.1-2.1L44.1.1A1,1,0,0,1,45,0a1.6,1.6,0,0,1,.5,1.1V11a2.6,2.6,0,0,1-1.1,2.1l-7.1,4.1a2.5,2.5,0,0,0,.1,1.2.2.2,0,0,1,0,.3h0a.3.3,0,0,1-.3.3,1.7,1.7,0,0,1-1.7.3,1.2,1.2,0,0,1-.7-.7l-2.1,1.2C32.7,20,32.5,20,32.3,20ZM44.7.6h-.2L32.9,7.4a1.8,1.8,0,0,0-.8,1.5v9.9a.8.8,0,0,0,.2.5c.1.1.2,0,.3-.1l2.8-1.6V18a.8.8,0,0,0,.5.7,1.2,1.2,0,0,0,1-.2,3.2,3.2,0,0,1-.1-1.7h0l7.4-4.2a1.8,1.8,0,0,0,.8-1.5V1.1a.7.7,0,0,0-.4-.5Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_2662" data-name="XMLID 2662">
              <g id="XMLID_2668" data-name="XMLID 2668">
                <g id="XMLID_2671" data-name="XMLID 2671">
                  <path
                    id="XMLID_2672"
                    data-name="XMLID 2672"
                    class="cls-2"
                    d="M42.2,4.7,34.3,9.3l.3.6,8-4.6Z"
                    transform="translate(0 0.1)"
                  />
                </g>
                <g id="XMLID_2669" data-name="XMLID 2669">
                  <path
                    id="XMLID_2670"
                    data-name="XMLID 2670"
                    class="cls-2"
                    d="M42.3,6.6l-8,4.6.4.6,7.9-4.6Z"
                    transform="translate(0 0.1)"
                  />
                </g>
              </g>
              <g id="XMLID_2663" data-name="XMLID 2663">
                <g id="XMLID_2666" data-name="XMLID 2666">
                  <path
                    id="XMLID_2667"
                    data-name="XMLID 2667"
                    class="cls-2"
                    d="M42.3,8.4l-8,4.6.4.6L42.6,9Z"
                    transform="translate(0 0.1)"
                  />
                </g>
                <g id="XMLID_2664" data-name="XMLID 2664">
                  <path
                    id="XMLID_2665"
                    data-name="XMLID 2665"
                    class="cls-2"
                    d="M42.3,10.2l-8,4.6.3.6,8-4.6Z"
                    transform="translate(0 0.1)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <g id="OneBloc">
      <path
        id="Shadow-5"
        class="cls-3"
        d="M22.6,106.8l-.5-.3L4.4,116.7l.5.3L17,110Zm1.3.8-.5-.3L5.8,117.5l.5.3Zm1.4.8-.5-.3L7.1,118.3l.5.3Zm1.3.8-.4-.3L8.5,119.1l.5.3Zm1.4.7-.5-.2L9.8,119.9l.5.2Zm1.3.8-.5-.2L11.2,120.7l.5.2Zm1.4.8-.5-.3L12.5,121.4l.5.3Zm1.3.8-.5-.3L13.9,122.2l.5.3Zm1,.6h-.2L15.1,123l.4.2h.1L33.2,113Zm.7,1.1-16.8,9.7h1l15.7-9a1.7,1.7,0,0,0,.1-.7ZM15.9,103.8.1,112.9a1.3,1.3,0,0,0-.1.6l16.9-9.7Zm2.2.3h0L.4,114.3l.3.2H.9l17.7-10.1Zm1.8,1.1-.5-.3L1.7,115.1l.5.3Zm1.3.8-.5-.3L3.1,115.9l.4.3Z"
        transform="translate(0 0.1)"
      />
      <g id="Block">
        <g id="XMLID_2605" data-name="XMLID 2605">
          <g id="XMLID_2613" data-name="XMLID 2613">
            <g id="XMLID_2642" data-name="XMLID 2642">
              <g id="XMLID_2653" data-name="XMLID 2653">
                <path
                  id="XMLID_2657"
                  data-name="XMLID 2657"
                  class="cls-1"
                  d="M14.8,117.6,2.4,110.4c-.2-.1-.3-.2-.3-.4v-3.8l.2-.2H8.6l6.1-3.4a1.8,1.8,0,0,1,1.6-.1l6.2,3.7h6.3a.2.2,0,0,1,.2.2v3.8c0,.2-.2.5-.4.5l-12.2,7A1.8,1.8,0,0,1,14.8,117.6Z"
                  transform="translate(0 0.1)"
                />
                <path
                  id="XMLID_2654"
                  data-name="XMLID 2654"
                  class="cls-3"
                  d="M15.5,118.2l-.9-.2L2.2,110.8a1,1,0,0,1-.5-.8v-3.8a.6.6,0,0,1,.6-.6H8.5l6-3.4a2,2,0,0,1,2-.1l6.1,3.6h6.1l.4.2.2.4v3.8c0,.4-.2.6-.6.9l-12.2,7A1.2,1.2,0,0,1,15.5,118.2Zm-.5-1a1.7,1.7,0,0,0,1.2-.1l12.2-7,.2-.2v-3.5H22.4l-6.2-3.7a1.7,1.7,0,0,0-1.2.1l-6.1,3.4H2.6v3.5h.1Z"
                  transform="translate(0 0.1)"
                />
              </g>
              <g id="XMLID_2648" data-name="XMLID 2648">
                <path
                  id="XMLID_2652"
                  data-name="XMLID 2652"
                  class="cls-3"
                  d="M23.4,106h5.4a.2.2,0,0,1,.2.2V110c0,.2-.2.5-.4.5l-12.1,7h-.1v-3.9C16,112.2,23.4,106,23.4,106Z"
                  transform="translate(0 0.1)"
                />
                <path
                  id="XMLID_2649"
                  data-name="XMLID 2649"
                  class="cls-3"
                  d="M16.5,118h-.3a.5.5,0,0,1-.2-.4v-3.9c-.2-1.5,4.3-5.5,7.1-7.8h5.7l.5.2a.8.8,0,0,1,.2.5v3.8c0,.4-.2.6-.6.9Zm.4-4.4v3.2l11.6-6.6.2-.2v-3.5H23.6c-3.3,2.8-6.7,6.1-6.7,6.9Z"
                  transform="translate(0 0.1)"
                />
              </g>
              <g id="XMLID_2643" data-name="XMLID 2643">
                <path
                  id="XMLID_2647"
                  data-name="XMLID 2647"
                  class="cls-2"
                  d="M28.8,105.5,16.4,98.3a1.8,1.8,0,0,0-1.6.1l-12.2,7c-.5.3-.5.7-.1.9l12.4,7.2a1.8,1.8,0,0,0,1.6-.1l12.2-7a.4.4,0,0,0,.3-.6Z"
                  transform="translate(0 0.1)"
                />
                <path
                  id="XMLID_2644"
                  data-name="XMLID 2644"
                  class="cls-3"
                  d="M15.5,114.1l-.9-.2L2.2,106.7a1,1,0,0,1-.5-.8,1.1,1.1,0,0,1,.6-.9l12.2-7a2,2,0,0,1,2-.1L29,105.2a1,1,0,0,1,.5.8,1.1,1.1,0,0,1-.6.9l-12.2,7ZM2.6,106,15,113.2a1.7,1.7,0,0,0,1.2-.1l12.2-7,.2-.2h-.1L16.1,98.7a1.7,1.7,0,0,0-1.2.1l-12.2,7Z"
                  transform="translate(0 0.1)"
                />
              </g>
            </g>
            <g id="XMLID_2640" data-name="XMLID 2640">
              <path
                id="XMLID_2641"
                data-name="XMLID 2641"
                class="cls-3"
                d="M4.3,107.8v3.9h.8v-3.9Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_2637" data-name="XMLID 2637">
              <path
                id="XMLID_2638"
                data-name="XMLID 2638"
                class="cls-1"
                d="M25.2,108.7v3.4h.6v-3.4Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
        </g>
        <g id="XMLID_2585" data-name="XMLID 2585">
          <g id="XMLID_2588" data-name="XMLID 2588">
            <g id="XMLID_2600" data-name="XMLID 2600">
              <path
                id="XMLID_2604"
                data-name="XMLID 2604"
                class="cls-2"
                d="M12,100,9.3,98.4H9l-3.3,2.1c-.1,0-.1.1,0,.2l3.2,3.4h0v1.1c0,.3,1.3-.6,1.5-.5l-1.6,1H9l3.3-2.1v-2.9A.9.9,0,0,0,12,100Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_2601"
                data-name="XMLID 2601"
                class="cls-3"
                d="M8.9,106.3H8.8a.3.3,0,0,1-.3-.3h0l-.2-.4.2-.2v-1.3l-3.2-3.4a.5.5,0,0,1,0-.7h.2l3.3-2.1h.7l2.7,1.6a1.4,1.4,0,0,1,.7,1.2v2.6a1.4,1.4,0,0,1-.2.6h-.1l-3.4,2.3Zm-2.7-5.7,3,3.2a.4.4,0,0,1,.1.3v.6h.1a1.3,1.3,0,0,1,1.2-.3l1.4-.9h0v-2.6a.8.8,0,0,0-.2-.5L9.1,98.8Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_2595" data-name="XMLID 2595">
              <path
                id="XMLID_2599"
                data-name="XMLID 2599"
                class="cls-3"
                d="M6.5,103.6v.2l2.3,2h.3l3.3-2V101h-.1L9,103Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_2596"
                data-name="XMLID 2596"
                class="cls-3"
                d="M9,106.3H8.8l-.4-.2L6,104v-.7l2.8-.6,3.3-2.1h.5c.2.1.3.2.3.4v2.5a1.4,1.4,0,0,1-.2.6h-.1l-3.3,2Zm-1.8-2.5L9,105.3l3.1-1.9h0v-2l-2.7,1.7h0Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_2589" data-name="XMLID 2589">
              <path
                id="XMLID_2594"
                data-name="XMLID 2594"
                class="cls-1"
                d="M8.6,105.9l-2.7-1.6a.9.9,0,0,1-.4-.8v-2.6c0-.3.2-.5.4-.3l2.7,1.6a.9.9,0,0,1,.4.8v2.6C9,105.9,8.8,106.1,8.6,105.9Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_2590"
                data-name="XMLID 2590"
                class="cls-3"
                d="M8.8,106.4H8.4l-2.7-1.6a1.4,1.4,0,0,1-.7-1.2V101a.7.7,0,0,1,.4-.7h.7l2.7,1.5a1.4,1.4,0,0,1,.7,1.2v2.6a.7.7,0,0,1-.4.7Zm0-.8-.2.4Zm-3-4.6v2.5a.8.8,0,0,0,.2.5l2.5,1.5V103a.8.8,0,0,0-.2-.5Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
          <g id="XMLID_2586" data-name="XMLID 2586">
            <path
              id="XMLID_2587"
              data-name="XMLID 2587"
              class="cls-1"
              d="M12,102.3l-2.9,1.8.4.6,2.9-1.8Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
      </g>
    </g>
    <g id="TwoBlocs">
      <path
        id="Shadow-6"
        class="cls-3"
        d="M230.4,182.3l-13.5,7.8.5.3,13.5-7.8ZM213,187.6l.4.4,13.5-7.8-.7-.2Zm1.2.9.5.3,13.5-7.8-.5-.3Zm1.4.8.4.3,13.6-7.8-.6-.3Zm7,5.7,1.3-.8h.3l13.5-7.8-.5-.3-9.3,5.4h-.2l-6,3.5-20.8,12,.5.3Zm2.8,0h.2l13.1-7.6c0-.2,0-.3-.3-.4l-9.2,5.3h0l-26.8,15.5h0l.3.2Zm5.5-1.7-.5-.2-26.7,15.5.5.3Zm1.5.8-.5-.2L205,209.3l.2.2h.2Zm1.3.8-.5-.3-26.8,15.5.5.3Zm1.3.8-.4-.3-26.9,15.5h0l.5.3Zm1.4.8-.5-.3L209,211.7l.6.3Zm1.3.8-.5-.3-26.8,15.5h.2l.3.2Zm1.5.8-.5-.3-27,15.5.5.3Zm1.2.8-.4-.3-26.8,15.5h0l.5.2Zm1.5.8-.5-.3-26.8,15.5.3.3Zm1,1c-.2-.1-.2-.3-.3-.4l-26.7,15.3h.1l.4.2Zm.1.8-25.3,14.6h1l24.2-13.9c0-.2.1-.4.1-.7Zm-24.4-10.4h.1l13.5-7.8-.5-.3-9.8,5.7h-.3L196.9,203v.6Zm1.3.8h.3l13.5-7.8-.5-.3-9.3,5.4h-.2L197,204.5c.2.1.2.3.4.4Zm-21.2,13.8,22.5-13.1h.2l13.5-7.8-.5-.3-9.2,5.4H225l-26.8,15.5Zm24-12.3h0l13.5-7.8-.3-.3-9.3,5.4h-.2l-26.8,15.5.4.3Z"
        transform="translate(0 0.1)"
      />
      <g id="XMLID_2559" data-name="XMLID 2559">
        <g id="XMLID_2560" data-name="XMLID 2560">
          <g id="XMLID_2566" data-name="XMLID 2566">
            <g id="XMLID_2578" data-name="XMLID 2578">
              <path
                id="XMLID_2582"
                data-name="XMLID 2582"
                class="cls-1"
                d="M215.9,208.6l-19.2-11.2-.3-.4v-3.8l.3-.2,13-3.9h0l6.2-3.4a1.6,1.6,0,0,1,1.5-.1l13.2,7.7h6.3v4a.5.5,0,0,1-.3.5l-19,10.9A2.5,2.5,0,0,1,215.9,208.6Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_2579"
                data-name="XMLID 2579"
                class="cls-3"
                d="M216.7,209.2l-1-.2-19.1-11.2a.9.9,0,0,1-.6-.8v-3.8q0-.4.6-.6l13-3.9,6-3.4a2,2,0,0,1,2-.1l13,7.6h6.1c.2,0,.2.1.3.2a.5.5,0,0,1,.2.4v3.8c0,.4-.2.6-.5.9l-19,10.9A1.8,1.8,0,0,1,216.7,209.2Zm-.5-.9a1.7,1.7,0,0,0,1.2-.1l19-10.9.3-.2v-3.5h-6.3l-13-7.7a1.7,1.7,0,0,0-1.2.1l-6.2,3.4h-.1L197,193.3v3.6h.2Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_2573" data-name="XMLID 2573">
              <path
                id="XMLID_2577"
                data-name="XMLID 2577"
                class="cls-3"
                d="M231.4,193.2h5.3c.2,0,.2.1.2.2v3.8c0,.2,0,.4-.3.5l-18.9,10.8h-.1v-3.9C217.2,203.3,231.4,193.2,231.4,193.2Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_2574"
                data-name="XMLID 2574"
                class="cls-3"
                d="M217.7,209h-.3c-.2-.1-.2-.2-.2-.4v-3.9c-.2-.4,0-1.4,6.7-6.5l7-5.2h5.8l.5.2c0,.1.2.3.2.5v3.8c0,.4-.2.6-.7.9Zm.3-4.3v3.2l18.4-10.5.2-.2v-3.5h-5.2c-6.4,4.5-13,9.8-13.4,10.8Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_2568" data-name="XMLID 2568">
              <path
                id="XMLID_2572"
                data-name="XMLID 2572"
                class="cls-2"
                d="M236.7,192.7l-19.1-11.2a2,2,0,0,0-1.7.1l-19,10.9c-.5.3-.5.7,0,.9L216,204.6a2,2,0,0,0,1.7-.1l19-10.9C237,193.4,237.2,192.9,236.7,192.7Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_2569"
                data-name="XMLID 2569"
                class="cls-3"
                d="M216.7,205.2l-.8-.2-19.2-11.2a1,1,0,0,1-.5-.8,1.1,1.1,0,0,1,.5-.9l19-10.9a2,2,0,0,1,2-.1l19.2,11.2a1,1,0,0,1,.5.8,1.1,1.1,0,0,1-.5.9l-19,10.9ZM196.9,193l19.3,11.2a1.7,1.7,0,0,0,1.2-.1l19-10.9.3-.2h-.1l-19.2-11.2a1.7,1.7,0,0,0-1.2.1l-19,10.9Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
          <g id="XMLID_2563" data-name="XMLID 2563">
            <path
              id="XMLID_2565"
              data-name="XMLID 2565"
              class="cls-3"
              d="M198.8,194.9v3.9h.8v-3.9Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2561" data-name="XMLID 2561">
            <path
              id="XMLID_2562"
              data-name="XMLID 2562"
              class="cls-1"
              d="M233.2,195.8v3.4h.7v-3.4Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
      </g>
      <g id="XMLID_2515" data-name="XMLID 2515">
        <g id="XMLID_2542" data-name="XMLID 2542">
          <g id="XMLID_2554" data-name="XMLID 2554">
            <path
              id="XMLID_2558"
              data-name="XMLID 2558"
              class="cls-2"
              d="M209,202.5l-2.6-1.6H206l-3.3,2.1v.2l3.2,3.4h0v1.1c0,.3,1.3-.6,1.5-.5l-1.5,1h.1l3.4-2.1v-2.9c.1-.3,0-.5-.3-.7Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_2555"
              data-name="XMLID 2555"
              class="cls-3"
              d="M205.9,208.8h0a.3.3,0,0,1-.3-.3h0l-.2-.4.2-.2v-1.3l-3.2-3.4a.5.5,0,0,1,0-.7h.2l3.3-2.1h.7l2.6,1.6a1.2,1.2,0,0,1,.7,1.2v2.6a1.4,1.4,0,0,1-.2.6h0l-3.3,2.1C206.4,208.6,206.1,208.8,205.9,208.8Zm-2.7-5.7,3,3.2.2.3v.6h0a1.5,1.5,0,0,1,1.3-.3l1.3-.9h0v-2.6c0-.2-.1-.3-.1-.5l-2.7-1.6Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2549" data-name="XMLID 2549">
            <path
              id="XMLID_2553"
              data-name="XMLID 2553"
              class="cls-3"
              d="M203.6,206.1v.2l2.3,2h.3l3.2-2,.2-.3v-2.5h-.2l-3.2,2.1Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_2550"
              data-name="XMLID 2550"
              class="cls-3"
              d="M206,208.8h-.1l-.5-.2-2.5-2.1v-.7l2.9-.6,3.3-2.1h.5a.5.5,0,0,1,.2.4V206a1.4,1.4,0,0,1-.2.6h0l-3.3,2Zm-1.8-2.4,1.8,1.5,3.2-1.9h0v-1.9l-2.8,1.7h0Z"
              transform="translate(0 0.1)"
            />
          </g>
          <g id="XMLID_2543" data-name="XMLID 2543">
            <path
              id="XMLID_2548"
              data-name="XMLID 2548"
              class="cls-1"
              d="M205.7,208.5l-2.8-1.6c-.2-.1-.3-.5-.3-.8v-2.6c0-.3.1-.5.3-.3l2.8,1.6c.2.1.3.5.3.8v2.6C206,208.4,205.9,208.6,205.7,208.5Z"
              transform="translate(0 0.1)"
            />
            <path
              id="XMLID_2544"
              data-name="XMLID 2544"
              class="cls-3"
              d="M205.9,208.9h-.5l-2.7-1.6a1.5,1.5,0,0,1-.7-1.2v-2.7a.8.8,0,0,1,.4-.7h.8l2.7,1.6a1.5,1.5,0,0,1,.7,1.2v2.6a.8.8,0,0,1-.4.7Zm0-.8-.2.4Zm-3-4.6V206a.7.7,0,0,0,.1.5l2.6,1.5v-2.5c0-.2-.2-.4-.2-.5Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
        <g id="XMLID_2516" data-name="XMLID 2516">
          <path
            id="XMLID_2541"
            data-name="XMLID 2541"
            class="cls-1"
            d="M209.2,204.9l-3,1.7.4.6,2.9-1.7Z"
            transform="translate(0 0.1)"
          />
        </g>
      </g>
      <g id="XMLID_2390" data-name="XMLID 2390">
        <g id="XMLID_2401" data-name="XMLID 2401">
          <g id="XMLID_2402" data-name="XMLID 2402">
            <g id="XMLID_2409" data-name="XMLID 2409">
              <g id="XMLID_2423" data-name="XMLID 2423">
                <path
                  id="XMLID_2514"
                  data-name="XMLID 2514"
                  class="cls-1"
                  d="M219,191.4l-12.3-7.2c-.2,0-.3-.2-.3-.4V180c0-.1,0-.2.2-.2h6.3l6-3.4a2,2,0,0,1,1.7-.1l6.1,3.7H233c.2,0,.2.1.2.2V184c0,.2,0,.4-.3.5l-12.2,7A2,2,0,0,1,219,191.4Z"
                  transform="translate(0 0.1)"
                />
                <path
                  id="XMLID_2486"
                  data-name="XMLID 2486"
                  class="cls-3"
                  d="M219.7,191.9l-.8-.2-12.5-7.2c-.2-.2-.5-.5-.5-.8v-3.8a.7.7,0,0,1,.7-.6h6.1l6-3.4a2,2,0,0,1,2-.1l6.2,3.6h6c.3,0,.3.1.5.2l.2.4v3.8c0,.4-.2.6-.7.9l-12.2,7C220.6,191.9,220.2,191.9,219.7,191.9Zm-.5-.9a1.7,1.7,0,0,0,1.2-.1l12.3-7,.2-.2v-3.5h-6.2l-6.3-3.7a1.7,1.7,0,0,0-1.2.1l-6,3.4h-6.3v3.5h0Z"
                  transform="translate(0 0.1)"
                />
              </g>
              <g id="XMLID_2415" data-name="XMLID 2415">
                <path
                  id="XMLID_2419"
                  data-name="XMLID 2419"
                  class="cls-3"
                  d="M227.7,179.8H233c.2,0,.2.1.2.2v3.8c0,.2,0,.4-.3.5l-12.2,7h0v-3.9C220.2,186,227.7,179.8,227.7,179.8Z"
                  transform="translate(0 0.1)"
                />
                <path
                  id="XMLID_2416"
                  data-name="XMLID 2416"
                  class="cls-3"
                  d="M220.7,191.7h-.3c0-.1-.2-.2-.2-.4v-3.9c-.2-1.5,4.4-5.5,7.2-7.8H233l.6.2a.7.7,0,0,1,.1.5v3.8a1.1,1.1,0,0,1-.5.9Zm.5-4.3v3.2l11.5-6.6.2-.2v-3.5h-5c-3.3,2.8-6.7,6.1-6.7,6.9Z"
                  transform="translate(0 0.1)"
                />
              </g>
              <g id="XMLID_2410" data-name="XMLID 2410">
                <path
                  id="XMLID_2414"
                  data-name="XMLID 2414"
                  class="cls-2"
                  d="M233,179.3l-12.3-7.2a2,2,0,0,0-1.7.1l-12.1,7c-.5.3-.5.7-.2.9l12.5,7.2a1.6,1.6,0,0,0,1.5-.1l12.2-7C233.4,180,233.4,179.6,233,179.3Z"
                  transform="translate(0 0.1)"
                />
                <path
                  id="XMLID_2411"
                  data-name="XMLID 2411"
                  class="cls-3"
                  d="M219.9,187.9l-1-.2-12.3-7.2a.9.9,0,0,1-.6-.8,1,1,0,0,1,.7-.9l12.2-7a2,2,0,0,1,2-.1l12.3,7.2a.9.9,0,0,1,.5.8,1.1,1.1,0,0,1-.5.9l-12.3,7A1.7,1.7,0,0,1,219.9,187.9Zm-13-8.2h0l12.3,7.2a1.7,1.7,0,0,0,1.2-.1l12.3-7c0-.1.2-.1.2-.2h-.2l-12.3-7.2a1.7,1.7,0,0,0-1.2.1l-12.3,7Z"
                  transform="translate(0 0.1)"
                />
              </g>
            </g>
            <g id="XMLID_2407" data-name="XMLID 2407">
              <path
                id="XMLID_2408"
                data-name="XMLID 2408"
                class="cls-3"
                d="M208.7,181.7v3.9h.8v-3.9Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_2405" data-name="XMLID 2405">
              <path
                id="XMLID_2406"
                data-name="XMLID 2406"
                class="cls-1"
                d="M229.5,182.4v3.4h.7v-3.4Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
        </g>
        <g id="XMLID_2395" data-name="XMLID 2395">
          <path
            id="XMLID_2396"
            data-name="XMLID 2396"
            class="cls-1"
            d="M219.7,183.4l-2.5-.4.2-.7-.7-.3-.5-.5-1.2.2-.8-1.7,1.2-.2a3.1,3.1,0,0,1,.5-1l-1-.5,2-1.2.8.5a6.4,6.4,0,0,1,2-.3l.3-.6,2.6.4-.4.7.7.3a1.8,1.8,0,0,1,.7.5l1.1-.2.7,1.7-1.2.2-.3,1,.8.5-2,1.2-.8-.5a6.4,6.4,0,0,1-2,.3Zm-1.7-.9,1.2.2.4-.6h.1a8.3,8.3,0,0,0,2.2-.3h.1l.7.4.7-.4-.7-.4.3-.3a1.4,1.4,0,0,0,.6-1.1v-.3h.8l-.2-.5-1,.2h0l-.6-.5-.9-.4h-.5l.4-.6-1.2-.2-.4.6h-.1a8.3,8.3,0,0,0-2.2.3h-.1l-.7-.4-.7.4.7.4-.3.3a1.4,1.4,0,0,0-.6,1.1v.3h-.8l.2.5,1-.2h0l.6.5.9.4h.5Zm1.9-1.1a2.7,2.7,0,0,1-1.7-.6.9.9,0,0,1-.3-.7c0-.3,0-.5.3-.7a2.7,2.7,0,0,1,3.4,0l.3.7a.9.9,0,0,1-.3.7,2.7,2.7,0,0,1-1.7.6Zm0-2a1.4,1.4,0,0,0-1.2.4.4.4,0,0,0-.1.3v.3a2.3,2.3,0,0,0,2.5,0v-.6a2,2,0,0,0-1.3-.4Z"
            transform="translate(0 0.1)"
          />
        </g>
        <g id="XMLID_2391" data-name="XMLID 2391">
          <path
            id="XMLID_2392"
            data-name="XMLID 2392"
            class="cls-3"
            d="M222.9,177.5l-1-.4.3-.6-1.8-.3-.4.6a5.9,5.9,0,0,0-2.3.4l-.8-.4-1.3.8.8.4a1.7,1.7,0,0,0-.7,1.3l-1,.2.5,1.1,1.2-.2.6.6,1,.4-.3.6,1.9.3.3-.6a5.9,5.9,0,0,0,2.3-.4l.7.4,1.5-.8-.8-.4a3.1,3.1,0,0,0,.6-1.3l1-.2-.5-1.1-1.1.2Zm-1.5,2.2a2.7,2.7,0,0,1-3,0,.9.9,0,0,1,0-1,2.7,2.7,0,0,1,3,0,.7.7,0,0,1,0,1Z"
            transform="translate(0 0.1)"
          />
        </g>
      </g>
    </g>
    <g id="SideStair">
      <path
        id="Shadow-7"
        class="cls-3"
        d="M155.8,184.4,82.2,226.8l.3.5L156,184.9Zm1.3.8L83.6,227.6l.2.4,73.6-42.4Zm1.4.8L85.4,228.1l.2.4,73.1-42.1Zm.8,1.2-71.2,41,.3.4,71.1-41Zm-.1,1.4L90.7,228.1l.3.5,68.5-39.5Zm-8.6-7.6L78.9,222.4l.2.4,71.7-41.3Zm.9,1.1L78.8,224l.3.5,72.7-42Zm1.3.8L79.7,225.1l.2.4L153,183.3Zm1.6.7L80.8,226l.3.5,73.5-42.4Zm1.3.9L82.1,226.9l.2.4,73.6-42.4Z"
        transform="translate(0 0.1)"
      />
      <g id="Stair">
        <g id="XMLID_32" data-name="XMLID 32">
          <g id="XMLID_149" data-name="XMLID 149">
            <g id="XMLID_167" data-name="XMLID 167">
              <path
                id="XMLID_170"
                data-name="XMLID 170"
                class="cls-2"
                d="M82.4,217.7c8.7-4.6,63.5-35.9,65.5-86.5a2.7,2.7,0,0,1,1.1-1.9q.6-.3.9,0l5.3,3.2-2,19.3-3,11.6v15.1a4.8,4.8,0,0,1-2.3,3.9l-25.4,14.7-13.3,12.5-22,14.1-5.6-3.3a.8.8,0,0,1-.4-.7A2.8,2.8,0,0,1,82.4,217.7Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_153" data-name="XMLID 153">
              <path
                id="XMLID_156"
                data-name="XMLID 156"
                class="cls-3"
                d="M81.5,220.7a1.1,1.1,0,0,1-.6-1.1,2.7,2.7,0,0,1,1.4-2.3c10.6-5.6,63.4-36.3,65.4-86.1a2.5,2.5,0,0,1,1.2-2.2,1.1,1.1,0,0,1,1.3,0l5.7,3.3-2.2,19.6-3,11.6v15a5.3,5.3,0,0,1-2.5,4.3l-25.5,14.7-13.1,12.4L87.2,224.2Zm40.6-23.9,25.6-14.7a4.7,4.7,0,0,0,2-3.6V163.4l3.2-11.6,2-19-5.2-3.1h-.5a2.3,2.3,0,0,0-1,1.5c-.8,21.4-11,41.8-30.3,60.7A164.4,164.4,0,0,1,82.5,218a2.2,2.2,0,0,0-.9,1.6c0,.2,0,.3.2.4l5.3,3.2L109,209.3Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
          <g id="XMLID_127" data-name="XMLID 127">
            <g id="XMLID_142" data-name="XMLID 142">
              <path
                id="XMLID_146"
                data-name="XMLID 146"
                class="cls-1"
                d="M105,202.7l7.1,4.1-3.2,3.1-1,.6-7.5-4.3C102,205.1,103.5,203.9,105,202.7Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_128" data-name="XMLID 128">
              <path
                id="XMLID_132"
                data-name="XMLID 132"
                class="cls-3"
                d="M99.8,206.2l.4-.4,4.7-3.5v-.2l8,4.5-3.8,3.5-1.2.8Zm11.8.6-6.5-3.7-3.9,3L108,210l.7-.5Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
          <g id="XMLID_105" data-name="XMLID 105">
            <g id="XMLID_122" data-name="XMLID 122">
              <path
                id="XMLID_125"
                data-name="XMLID 125"
                class="cls-1"
                d="M81.6,220.4a.8.8,0,0,1-.4-.7,2.1,2.1,0,0,1,1.1-1.9c2-1.1,6.4-3.5,12-7.3l6.9,4.2L87,223.8Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_106" data-name="XMLID 106">
              <path
                id="XMLID_116"
                data-name="XMLID 116"
                class="cls-3"
                d="M81.4,220.8a1.1,1.1,0,0,1-.6-1.1,2.7,2.7,0,0,1,1.4-2.3,123.9,123.9,0,0,0,12-7.3h.2l7.7,4.6-14.9,9.6Zm13.1-9.9c-5.5,3.7-9.8,6-11.8,7.2a2.2,2.2,0,0,0-.9,1.6c0,.2,0,.3.1.4l5.4,3.2,13.4-8.6Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
          <g id="XMLID_68" data-name="XMLID 68">
            <g id="XMLID_73" data-name="XMLID 73">
              <path
                id="XMLID_103"
                data-name="XMLID 103"
                class="cls-1"
                d="M145.4,147.3l7.8,4.4h0l-1,3.8-8-4.5A32.2,32.2,0,0,0,145.4,147.3Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_69" data-name="XMLID 69">
              <path
                id="XMLID_70"
                data-name="XMLID 70"
                class="cls-3"
                d="M143.7,151.4l.2-.3c.3-1.2.8-2.5,1-3.8v-.5l8.6,4.8v.3l-1.2,4.4Zm2-3.5-1,3,7.2,4.1.8-3Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
          <g id="XMLID_61" data-name="XMLID 61">
            <g id="XMLID_66" data-name="XMLID 66">
              <path
                id="XMLID_67"
                data-name="XMLID 67"
                class="cls-1"
                d="M154,144.3l-7.1-4a74.6,74.6,0,0,0,1-8.1l7,4Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_62" data-name="XMLID 62">
              <path
                id="XMLID_63"
                data-name="XMLID 63"
                class="cls-3"
                d="M146.6,140.5v-.3c.3-2.6.6-5.3.8-8v-.7l8,4.5-1,8.9Zm1.6-7.6a35.3,35.3,0,0,1-.8,7.2l6.3,3.5.9-7.2Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
          <g id="XMLID_54" data-name="XMLID 54">
            <g id="XMLID_59" data-name="XMLID 59">
              <path
                id="XMLID_60"
                data-name="XMLID 60"
                class="cls-3"
                d="M155.7,133.3v48.5a4.8,4.8,0,0,1-2.3,3.9L88,223.5c-.6.4-1.1.1-1.1-.6A2.1,2.1,0,0,1,88,221c8.7-4.6,63.6-35.9,65.6-86.5a2.1,2.1,0,0,1,1.1-1.9C155.2,132.3,155.7,132.6,155.7,133.3Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_55" data-name="XMLID 55">
              <path
                id="XMLID_56"
                data-name="XMLID 56"
                class="cls-3"
                d="M87,224a1.6,1.6,0,0,1-.5-1.1,2.7,2.7,0,0,1,1.4-2.3c10.6-5.6,63.3-36.3,65.3-86.1a3,3,0,0,1,1.4-2.2,1.1,1.1,0,0,1,1.1-.1,1.6,1.6,0,0,1,.5,1.1v48.5a5,5,0,0,1-2.5,4.3L88.3,223.9l-.7.2Zm67.9-91a2.3,2.3,0,0,0-1,1.5c-.7,21.4-11,41.8-30.3,60.7a164.4,164.4,0,0,1-35.4,26.1,2.2,2.2,0,0,0-.9,1.6c0,.2,0,.3.1.4h.4l65.4-37.9a4.5,4.5,0,0,0,2.2-3.6V133.3c0-.2,0-.3-.2-.4h-.3Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
          <g id="XMLID_51" data-name="XMLID 51">
            <g id="XMLID_52" data-name="XMLID 52">
              <path
                id="XMLID_53"
                data-name="XMLID 53"
                class="cls-3"
                d="M140.9,159.9l-.4.7,5.6,3.3.4-.7Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
          <g id="XMLID_48" data-name="XMLID 48">
            <g id="XMLID_49" data-name="XMLID 49">
              <path
                id="XMLID_50"
                data-name="XMLID 50"
                class="cls-3"
                d="M116.4,192.6l-.4.7,5.6,3.3.4-.7Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
          <g id="XMLID_45" data-name="XMLID 45">
            <g id="XMLID_46" data-name="XMLID 46">
              <path
                id="XMLID_47"
                data-name="XMLID 47"
                class="cls-3"
                d="M139.4,162.6l-.4.7,5.6,3.3.4-.7Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
          <g id="XMLID_42" data-name="XMLID 42">
            <g id="XMLID_43" data-name="XMLID 43">
              <path
                id="XMLID_44"
                data-name="XMLID 44"
                class="cls-3"
                d="M133.8,172.5l-.4.7,5.5,3.3.5-.7Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
          <g id="XMLID_39" data-name="XMLID 39">
            <g id="XMLID_40" data-name="XMLID 40">
              <path
                id="XMLID_41"
                data-name="XMLID 41"
                class="cls-3"
                d="M108.3,200l-.4.7,5.6,3.3.4-.7Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
          <g id="XMLID_36" data-name="XMLID 36">
            <g id="XMLID_37" data-name="XMLID 37">
              <path
                id="XMLID_38"
                data-name="XMLID 38"
                class="cls-3"
                d="M82.5,217.5l-.4.7,5.6,3.3.4-.7Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
          <g id="XMLID_33" data-name="XMLID 33">
            <g id="XMLID_34" data-name="XMLID 34">
              <path
                id="XMLID_35"
                data-name="XMLID 35"
                class="cls-1"
                d="M148.9,134.4l-.3.5,3.7,2.3.4-.5Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
        </g>
        <g id="XMLID_13" data-name="XMLID 13">
          <g id="XMLID_16" data-name="XMLID 16">
            <g id="XMLID_27" data-name="XMLID 27">
              <path
                id="XMLID_31"
                data-name="XMLID 31"
                class="cls-2"
                d="M146.4,178.4l-1.8-1,6.1-3.6,1.9,1Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_28"
                data-name="XMLID 28"
                class="cls-3"
                d="M146.4,178.8h-.2l-2-1.1v-.4h.2l6.3-3.6h.2l2,1.2v.4h-.2Zm-1.2-1.4,1.2.7,5.5-3.2-1.2-.7Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_22" data-name="XMLID 22">
              <path
                id="XMLID_26"
                data-name="XMLID 26"
                class="cls-3"
                d="M146.4,178.4v7.2l6.2-3.6v-7.2Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_23"
                data-name="XMLID 23"
                class="cls-3"
                d="M146.4,186l-.4-.2v-7.6h.2l6.4-3.6.3.2v7.6h-.2Zm.3-7.4v6.5l5.5-3.2v-6.5Z"
                transform="translate(0 0.1)"
              />
            </g>
            <g id="XMLID_17" data-name="XMLID 17">
              <path
                id="XMLID_21"
                data-name="XMLID 21"
                class="cls-1"
                d="M144.6,177.4v7.2l1.8,1v-7.2Z"
                transform="translate(0 0.1)"
              />
              <path
                id="XMLID_18"
                data-name="XMLID 18"
                class="cls-3"
                d="M146.4,186h-.2l-2-1.1v-7.6l.2-.2h.3l2,1.1v7.6Zm-1.5-1.6,1.1.7v-6.5l-1.1-.7Z"
                transform="translate(0 0.1)"
              />
            </g>
          </g>
          <g id="XMLID_14" data-name="XMLID 14">
            <path
              id="XMLID_15"
              data-name="XMLID 15"
              class="cls-1"
              d="M146.4,185.9l-.2-.5,6-3.5v-6.5h.5v6.8h0Z"
              transform="translate(0 0.1)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import coords from "@/components/coords.js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { mapState } from "vuex";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState(["toggleConfig", "startConfig", "isAnimationDisabled", "viewportSize"]),
  },
  mixins: [coords],
  props: {
    x: {
      type: [Number, String],
      default: 1200,
    },
    y: {
      type: [Number, String],
      default: 50,
    },
    xSmall: {
      type: [Number, String],
      default: 1200,
    },
    ySmall: {
      type: [Number, String],
      default: 50,
    },
  },
  methods: {
    buildplugins() {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: "#milestone-build-plugins",
            toggleActions: this.toggleConfig,
            start: "center 60%",
          },
          defaults: {
            duration: 1,
            transformOrigin: "50% 50%",
            ease: "back.out(1)",
          },
        })
        .add("buildplugins")
        .from(
          "#ThreeBlocs > g, #TwoBlocs > g, #OneBloc > g",
          {
            opacity: 0,
            scale: 0,
            rotation: 360,
            stagger: 0.1,
            ease: "back",
          },
          "buildplugins"
        )
        .from(
          "#Piece-1",
          {
            x: 40,
            y: 40,
            rotation: 20,
          },
          "buildplugins"
        )
        .from(
          "#Piece-2",
          {
            x: 40,
            y: -40,
            rotation: -20,
          },
          "buildplugins"
        )
        .from(
          "#Piece-3",
          {
            x: -40,
            y: 40,
            rotation: 20,
          },
          "buildplugins"
        )
        .from(
          "#Piece-4",
          {
            x: -40,
            y: -40,
            rotation: -20,
          },
          "buildplugins"
        );
    },
  },
  mounted() {
    this.buildplugins();
  },
};
</script>

<style lang="scss" scoped>
.cls-1 {
  fill: #ffad43;
}

.cls-2 {
  fill: #fff;
}

.cls-3,
.cls-5 {
  fill: #0e1e25;
}

.cls-4 {
  fill: none;
}

.cls-5 {
  stroke: #fff;
}

.cls-6,
.cls-7 {
  fill: #caa677;
}

.cls-7 {
  stroke: #0e1e25;
}

.cls-8 {
  fill: #caa577;
}
</style>